var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 265,
    viewBox: "0 0 1920 265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.232,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#fff",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#fff",
    stopOpacity: 0.651
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 1920,
    height: 265,
    transform: "translate(0 2072)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_26",
    "data-name": "Mask Group 26",
    transform: "translate(0 -2072)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(5 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sdfasdfsd",
    transform: "translate(1610 2078.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M561.774,32.14C548.4,6.457,514.98-6.58,487.862,3.319s-44.435,41.431-38.318,69.766c-8.768-5.874-20.868-6.324-29.587-.389a27.6,27.6,0,0,0-11.176,27.763c-1.216-7.479-3.806-15.079-9.133-20.442s-13.656-8.123-20.673-5.387-11.382,11.808-7.856,18.509c1.617-7.758-5.655-15.152-13.535-15.347s-14.921,7.88-13.705,15.712c-11.99,1.557-18.788,16.186-15.286,27.811s16.94,18.8,28.772,16.3c-10.434,11.419-9.8,28.626-1.386,41.626s23.652,20.454,38.975,22.108,30.8-1.909,45.3-7.187c4.864,14.325,16.915,26.182,30.183,33.357s28.444,10.191,43.5,10.823c19.287.815,39.619-2.542,54.845-14.459,14.97-11.711,23.251-30.4,25.927-49.336s.328-38.087-2.627-56.924c-1.447-9.206-3.089-18.569-7.454-26.753s-11.978-15.225-21.16-16.49c7.491-4.864,13.766-14.8,13.62-23.75S569.411,36.749,561.774,32.14Z",
    transform: "translate(-268.867 -0.003)",
    fill: "#f7fbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M4.958,277.955,0,243.3l16.236-7.95,14.077,3.83,23.512-1.747L46.935,128.588,68.893,113.92l24.668,12.867-11.189,104.3,26.524-5.563-6.87-83.589,35.01-13.341,19.063,8.239-5.728,82.716,25.617-.86-9.676-108.862L204.052,92l-2.833-29.385L232.881,47.86l34.687,18.671,6.3,70.3h45.058L311.553,85.7l19.895-13.259,17.536,17.529,6.4,193.262L6.671,284.949Z",
    transform: "translate(0 -14.949)",
    fill: "#aceff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M125.68,322.341l7.957-103.828,39.941-12.743,27.24,9.965-14.208,112.8-60.93,2.091Z",
    transform: "translate(-39.251 -64.266)",
    fill: "#52b4b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M336.158,385.416h-141l1.341-1.926h138.6Z",
    transform: "translate(-60.95 -119.769)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M333.04,385.416l.908-1.926h44.219l1.052,1.926Z",
    transform: "translate(-104.011 -119.769)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M275.775,123l-.653-10.9-2.111.358-.158-.371,4.47-1.21.481.688-2.063.406.688,11Zm3.143-1h-.605V101.714l-2.373-1.073-1.279,1.375h-.309l1.032-1.657L272.811,99.2l-.131-.722,3.026,1.375L276.841,98l.921.433-1.5,1.657,5.907,2.675.977-1.231.88.378-1.286,1.114,1.286.585-.248.55-1.424-.646-.963.763-.282-.172.688-.853-2.868-1.293Zm2.8-2.208-.309-6.616-1.836.351.234-.956h2.964l.33.371-1.093.234.309,6.588Z",
    transform: "translate(-85.16 -30.608)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M309.54,370.31l-.378,9.064H226.178l-.908-7.489Z",
    transform: "translate(-70.353 -115.652)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M264.29,133.258l26.187-14.338v12.351l-1.011,156.54H270.493Z",
    transform: "translate(-82.539 -37.142)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M302.37,118.92l12.647,5.006L302.37,134.874Z",
    transform: "translate(-94.432 -37.142)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M233.122,370.258l-2.6,8.809H229.47l.557-8.624Zm5.357,0-.688,8.809h1.135l2.95-8.809Zm8.472-.254c-.117.124-.908,9.064-.908,9.064H247.1c.117,0,3.115-9.064,3.115-9.064Zm8.355,0-.784,9.064h1.252l2.985-9.5Zm8.864-.254-1.135,9.311H265l6.877-9.311Zm15.219,0-.646,9.311h1.135l2.909-9.5Zm8.252,0-.873,9.311h1.1l2.8-9.5Zm7.455-.193-.688,9.5h.949l2.689-9.5Zm8.025,0-.908,9.5h1.2l2.95-9.731Z",
    transform: "translate(-71.665 -115.346)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M226.81,343.214l85.075-7.764-5.2,16-75.756,2.771Z",
    transform: "translate(-70.834 -104.765)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M298.464,127.961,342.3,90l-8.28,168.794-36.338,4.442Z",
    transform: "translate(-92.967 -28.11)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M248.274,159.29l-42.2,6.464,10.7,122.753,37.156-2.221Z",
    transform: "translate(-64.357 -49.75)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M347.26,379.374h19.255l1.637-8.61-20.514-.454Z",
    transform: "translate(-108.452 -115.652)",
    fill: "#a96e92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M349.109,358.5l25.2,1.293-1.582,7.372-23.815-.543Z",
    transform: "translate(-108.967 -111.964)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M221.63,347.049l5.983,10.762,3.26-.117-4.009-10.955Z",
    transform: "translate(-69.216 -108.291)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M238.666,346.04l3.2,11.175-3.163.11-4.821-11Z",
    transform: "translate(-73.042 -108.073)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M250.476,345.35l2.373,11.381-3.067.117-3.652-11.237Z",
    transform: "translate(-76.868 -107.857)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M262.279,344.66l1.561,11.595-2.971.11-2.489-11.471Z",
    transform: "translate(-80.694 -107.642)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M274.089,343.96l.743,11.815-2.881.11-1.32-11.718Z",
    transform: "translate(-84.52 -107.423)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M297.68,341.729v12.7l2.723-.1.5-13Z",
    transform: "translate(-92.967 -106.602)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M312.38,339.86,310.7,353.614l-2.792.1.667-13.383Z",
    transform: "translate(-96.162 -106.143)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M323.858,338.39,321,352.893l-2.854.1,1.341-14.07Z",
    transform: "translate(-99.36 -105.684)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M335.333,336.92l-4.03,15.253-2.923.11,2.015-14.758Z",
    transform: "translate(-102.555 -105.225)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M346.8,335.45l-5.2,16-2.985.11,2.682-15.439Z",
    transform: "translate(-105.753 -104.765)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M350.52,258.794l23.5,2.826,14.311-147.943L358.8,90Z",
    transform: "translate(-109.47 -28.11)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M371.657,338.276l-6.175,13.96-22.522-.784,5.2-16Z",
    transform: "translate(-107.109 -104.765)",
    fill: "#a96e92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M226.01,372.578l2.3-.048.832,7.537h-2.235Z",
    transform: "translate(-70.584 -116.346)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M238.43,372.348l2.256-.048.619,7.7h-2.077Z",
    transform: "translate(-74.463 -116.274)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M250.86,372.118l2.194-.048.419,7.853h-1.926Z",
    transform: "translate(-78.345 -116.202)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M263.28,371.888l2.139-.048.213,8.012h-1.774Z",
    transform: "translate(-82.224 -116.13)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M275.71,371.658l.468,8.122h1.616v-8.17Z",
    transform: "translate(-86.106 -116.058)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M225.27,372.578l2.311-.048.832,7.537h-2.235Z",
    transform: "translate(-70.353 -116.346)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M237.7,372.348l2.249-.048.626,7.7H238.5Z",
    transform: "translate(-74.235 -116.274)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M250.12,372.118l2.194-.048.419,7.853h-1.926Z",
    transform: "translate(-78.114 -116.202)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M262.55,371.888l2.139-.048.206,8.012h-1.767Z",
    transform: "translate(-81.996 -116.13)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M274.98,371.658l.468,8.122h1.609v-8.17Z",
    transform: "translate(-85.878 -116.058)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M299.33,371.215l.3,8.424h1.513l.378-8.479Z",
    transform: "translate(-93.483 -115.918)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M310.72,370.991l.234,8.576,1.6.007.378-8.624Z",
    transform: "translate(-97.04 -115.852)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M322.12,370.774l.151,8.72,1.678.014.378-8.768Z",
    transform: "translate(-100.6 -115.787)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M333.51,370.554l.076,8.864,1.767.021.378-8.919Z",
    transform: "translate(-104.157 -115.718)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M299,371.215l.3,8.424h1.513l.378-8.479Z",
    transform: "translate(-93.38 -115.918)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M310.39,370.991l.227,8.576,1.6.007.378-8.624Z",
    transform: "translate(-96.937 -115.852)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M321.78,370.774l.151,8.72,1.685.014.378-8.768Z",
    transform: "translate(-100.494 -115.787)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M333.18,370.554l.076,8.864,1.76.021.378-8.919Z",
    transform: "translate(-104.054 -115.718)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M346.8,370.31l-2.228.028v9.009l1.85.027Z",
    transform: "translate(-107.611 -115.652)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M267.44,159.29l.756.605,6.244,138.185-.605.021-.743-11.815Z",
    transform: "translate(-83.523 -49.75)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M269.06,168.538l20.4-7.118-.715,136.824-13.8.5Z",
    transform: "translate(-84.029 -50.415)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M269.95,169.368l19.785-6.9-.715,136.1-13.2.481Z",
    transform: "translate(-84.307 -50.743)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M377.216,218.155,376.2,229.412l-16.353-4.436.8-12.172Zm-1.678,18.609-16.2-4.387-.8,12.241,15.975,3.48Zm-13.63-43.517-.791,12.09,16.78,5.405,1.011-11.175Zm-3.837,58.708-.77,11.794,15.611,2.428.97-10.783Zm5.116-78.273-.784,11.993,17.192,6.389,1-11.079Zm19.764-18.96,1.43-15.879-18.2-11-1.21,18.478Zm-18.485-.605-.777,11.89,17.577,7.379.99-11Z",
    transform: "translate(-111.587 -39.927)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M357.29,264.111l.729-11.168,15.2,3.28-.922,10.192ZM358.542,245l.756-11.608,15.6,4.222-.97,10.735Zm1.3-19.627.756-11.533,16,5.151-.963,10.659Zm1.286-19.634.75-11.443,16.4,6.093-.956,10.563Zm1.265-19.661.743-11.347,16.8,7.056-.942,10.48Zm1.286-19.654.736-11.23,17.192,8.025-.935,10.315Zm1.286-19.661L366.127,129l17.612,10.632-1.375,15.26Z",
    transform: "translate(-111.584 -40.29)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M238.279,175.228l7.386-1.038,6.547,110.643-6.506.433Zm-3.555,110.781,6.753-.454L234.07,175.82l-7.826,1.1ZM222.036,177.5l-7.166,1,8.809,108.236,6.815-.454Z",
    transform: "translate(-67.105 -54.403)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M215.81,179.339l6.567-.922,8.4,108.16-6.189.413Zm11.374-1.6,7.221-1.011,7.365,109.109-6.155.413Zm12.035-1.685,6.788-.949,6.512,110.031-5.907.392Z",
    transform: "translate(-67.399 -54.69)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M236.474,325.435l-2.015-25.905-.419,26.07Z",
    transform: "translate(-73.092 -93.547)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M257.767,175.1l-2.71.385-1.568,37.692,1.4,20.686,3.727-44.5Z",
    transform: "translate(-79.167 -54.687)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M241.688,192.579,240.67,177.47l-4.3.605-.5,31.538,3.844,49.514Z",
    transform: "translate(-73.664 -55.427)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M249.142,323.557l1.678-20.067-.557-8.28-1.183,28.347Z",
    transform: "translate(-77.789 -92.198)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M273.3,170.81l-1.767,36.118-1.582-34.955Z",
    transform: "translate(-84.307 -53.347)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M296.121,305.82l-4.051,37.658,3.858-.138Z",
    transform: "translate(-91.215 -95.512)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M223.175,260.065l1.1,13.52L222.439,180.1l-3.679.516Z",
    transform: "translate(-68.32 -56.249)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M266.354,316.97l-2.366-39.9-3.858,35.561.316,4.731Z",
    transform: "translate(-81.24 -86.533)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M316.727,139.984l6.141-3.755-1.334,128.8-6.712.97Zm10.412-6.361-1.375,130.792,6.107-.887L336.54,127.86Zm-14.7,8.981L305,147.157l-1.162,120.4,6.733-.977Z",
    transform: "translate(-94.891 -39.934)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M305.865,147.962l6.829-4.174-1.857,123.2-6.127.887Zm11.691-7.166,5.5-3.383L321.73,265.406l-6.1.88Zm10.412-6.368,8.8-5.378L332.128,263.9l-5.5.8Z",
    transform: "translate(-95.163 -40.305)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M331.154,132.771l5.075-3.1L327.076,234.8l.289-27.577Zm-14.813,98.4-.213,14.208,6.671-65.255.44-42.52-.729.447Zm-11.154-1.148-.117,11.856,7.413-97.707-2.648,1.616Zm5.233,37.232.763-15.473.715-49.4c-2.1,28.677-4.216,57.766-4.766,65.331Zm23.547-52.388L329.9,264.437l2.366-.344Z",
    transform: "translate(-95.275 -40.499)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M220.68,361.725l88.382-3.225-.2,8.122-87.378,1.616Z",
    transform: "translate(-68.92 -111.964)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M245.169,257.174l-.027-.454-6.691.674.034.454Z",
    transform: "translate(-74.47 -80.178)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M249.227,314.644l-.028-.454-6.3.5.034.454Z",
    transform: "translate(-75.859 -98.126)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M242.739,222.694l-.034-.454-6.925.777.034.454Z",
    transform: "translate(-73.636 -69.409)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M243.547,234.184l-.027-.454-6.849.75.034.447Z",
    transform: "translate(-73.914 -72.998)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M241.925,211.194l-.028-.454-7.008.818.034.454Z",
    transform: "translate(-73.358 -65.818)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M248.419,303.154l-.034-.454-6.375.53.034.454Z",
    transform: "translate(-75.581 -94.537)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M245.983,268.664l-.027-.454-6.616.64.034.454Z",
    transform: "translate(-74.747 -83.766)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M247.6,291.654l-.027-.454-6.457.571.034.454Z",
    transform: "translate(-75.303 -90.946)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M246.8,280.164l-.034-.454-6.533.605.034.454Z",
    transform: "translate(-75.025 -87.357)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M244.361,245.674l-.028-.454-6.774.715.034.454Z",
    transform: "translate(-74.192 -76.586)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M234.041,200.557l7.069-.853-.027-.454L234,200.1Z",
    transform: "translate(-73.08 -62.229)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M255.2,255.723l.027.454,6.327-.633-.048-.454Z",
    transform: "translate(-79.701 -79.668)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M255.97,267.265l.034.454,6.272-.612-.048-.447Z",
    transform: "translate(-79.941 -83.282)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M254.42,244.187l.028.454,6.389-.667-.048-.454Z",
    transform: "translate(-79.457 -76.055)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M262.994,278.677l-.041-.447-6.2.571.034.454Z",
    transform: "translate(-80.185 -86.895)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M252.08,209.573l.034.454,6.554-.763-.055-.454Z",
    transform: "translate(-78.726 -65.215)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M251.31,198.038l.028.454,6.609-.8-.055-.454Z",
    transform: "translate(-78.486 -61.602)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M252.86,221.109l.034.454,6.492-.729-.048-.454Z",
    transform: "translate(-78.97 -68.828)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M253.64,232.651l.034.454,6.437-.7-.048-.454Z",
    transform: "translate(-79.213 -72.442)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M232.167,304.514l-.034-.454-6.292.53.041.454Z",
    transform: "translate(-70.531 -94.962)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M230.365,281.687l-.034-.447-6.341.585.041.454Z",
    transform: "translate(-69.954 -87.835)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M229.472,270.274l-.041-.454-6.361.612.034.454Z",
    transform: "translate(-69.666 -84.269)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M231.267,293.1l-.034-.454-6.313.557.034.454Z",
    transform: "translate(-70.244 -91.399)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M228.57,258.864l-.034-.454-6.4.64.041.454Z",
    transform: "translate(-69.376 -80.705)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M233.962,327.344l-.034-.454-6.237.468.041.454Z",
    transform: "translate(-71.109 -102.092)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M233.069,315.934l-.041-.454-6.258.5.034.454Z",
    transform: "translate(-70.822 -98.529)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M250.014,325.69l-6.224.461.034.454,6.217-.468Z",
    transform: "translate(-76.137 -101.717)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M265.829,324.51l-5.969.447.034.454,5.955-.447Z",
    transform: "translate(-81.156 -101.349)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M227.671,247.444l-.034-.454-6.416.674.034.454Z",
    transform: "translate(-69.088 -77.139)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M233.151,189.1l7.152-.894-.034-.454-7.159.894Z",
    transform: "translate(-72.802 -58.638)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M265.114,312.94l-6.024.475.027.454,6.024-.475Z",
    transform: "translate(-80.915 -97.735)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M263.678,289.8l-6.148.536.027.454,6.155-.543-.014-.2Z",
    transform: "translate(-80.428 -90.509)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M250.558,186.956l6.664-.832-.055-.454-6.636.832Z",
    transform: "translate(-78.242 -57.988)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M258.31,301.879l.028.454,6.086-.509-.021-.454Z",
    transform: "translate(-80.672 -94.122)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M224.973,213.2l-.034-.454-6.5.763.041.454Z",
    transform: "translate(-68.22 -66.445)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M216.624,191.2l6.554-.811-.034-.454-6.554.818Z",
    transform: "translate(-67.642 -59.319)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M225.876,224.614l-.034-.454-6.471.736.034.454Z",
    transform: "translate(-68.511 -70.009)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M226.775,236.034l-.041-.454-6.444.7.041.454Z",
    transform: "translate(-68.798 -73.575)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M224.074,201.794l-.034-.454-6.519.791.034.454Z",
    transform: "translate(-67.933 -62.882)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M293.728,203.326l.22-40.856-3.04,1.059-7.468,135.4,2.228-.083Z",
    transform: "translate(-88.52 -50.743)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M276.05,263.213l1.671,36.97.234-.007,6.54-134.086-7.159,2.5Z",
    transform: "translate(-86.212 -51.873)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M245.169,256.924l-.027-.454-6.691.674.034.454Z",
    transform: "translate(-74.47 -80.099)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M249.227,314.394l-.028-.454-6.3.5.034.454Z",
    transform: "translate(-75.859 -98.048)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M242.739,222.444l-.034-.454-6.925.784.034.454Z",
    transform: "translate(-73.636 -69.331)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M243.547,233.934l-.027-.454-6.849.75.034.454Z",
    transform: "translate(-73.914 -72.92)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M241.925,210.944l-.028-.454-7.008.825.034.447Z",
    transform: "translate(-73.358 -65.74)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M248.419,302.9l-.034-.454-6.375.536.034.454Z",
    transform: "translate(-75.581 -94.459)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M245.983,268.424l-.027-.454-6.616.64.034.447Z",
    transform: "translate(-74.747 -83.691)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M247.6,291.411l-.027-.461-6.457.571.034.454Z",
    transform: "translate(-75.303 -90.868)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M246.8,279.914l-.034-.454-6.533.605.034.454Z",
    transform: "translate(-75.025 -87.279)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M244.361,245.434l-.028-.454-6.774.708.034.454Z",
    transform: "translate(-74.192 -76.511)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M234.041,200.307l7.069-.853-.027-.454-7.083.86Z",
    transform: "translate(-73.08 -62.151)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M255.2,255.473l.027.461,6.327-.64-.048-.454Z",
    transform: "translate(-79.701 -79.59)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M255.97,267.015l.034.454,6.272-.605-.048-.454Z",
    transform: "translate(-79.941 -83.204)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M254.42,243.937l.028.454,6.389-.667-.048-.454Z",
    transform: "translate(-79.457 -75.977)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M262.994,278.434l-.041-.454-6.2.571.034.454Z",
    transform: "translate(-80.185 -86.817)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M252.08,209.323l.034.454,6.554-.763-.055-.454Z",
    transform: "translate(-78.726 -65.137)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M251.31,197.791l.028.454,6.609-.8-.055-.447Z",
    transform: "translate(-78.486 -61.527)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M252.86,220.866l.034.454,6.492-.736-.048-.454Z",
    transform: "translate(-78.97 -68.75)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M253.64,232.4l.034.454,6.437-.7-.048-.454Z",
    transform: "translate(-79.213 -72.364)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M232.167,304.264l-.034-.454-6.292.53.041.454Z",
    transform: "translate(-70.531 -94.884)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M230.365,281.437l-.034-.447-6.341.585.041.454Z",
    transform: "translate(-69.954 -87.757)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M229.472,270.024l-.041-.454-6.361.619.034.454Z",
    transform: "translate(-69.666 -84.191)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M231.267,292.854l-.034-.454-6.313.557.034.454Z",
    transform: "translate(-70.244 -91.321)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M228.57,258.614l-.034-.454-6.4.646.041.447Z",
    transform: "translate(-69.376 -80.627)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M233.962,327.094l-.034-.454-6.237.468.041.454Z",
    transform: "translate(-71.109 -102.014)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M233.069,315.684l-.041-.454-6.258.5.034.454Z",
    transform: "translate(-70.822 -98.451)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M250.014,325.44l-6.224.468.034.447,6.217-.461Z",
    transform: "translate(-76.137 -101.639)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M265.829,324.26l-5.969.447.034.454,5.955-.447Z",
    transform: "translate(-81.156 -101.271)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M227.671,247.2l-.034-.447-6.416.667.034.454Z",
    transform: "translate(-69.088 -77.064)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M233.151,188.848l7.152-.894-.034-.454-7.159.894Z",
    transform: "translate(-72.802 -58.56)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M265.114,312.69l-6.024.475.027.454,6.024-.475Z",
    transform: "translate(-80.915 -97.657)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M263.678,289.55l-6.148.543.027.454,6.155-.543-.014-.206Z",
    transform: "translate(-80.428 -90.431)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M250.558,186.709l6.664-.832-.055-.447-6.636.825Z",
    transform: "translate(-78.242 -57.913)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M258.31,301.629l.028.454,6.086-.509-.021-.454Z",
    transform: "translate(-80.672 -94.044)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M224.973,212.954l-.034-.454-6.5.763.041.454Z",
    transform: "translate(-68.22 -66.367)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M216.624,190.952l6.554-.818-.034-.454-6.554.818Z",
    transform: "translate(-67.642 -59.241)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M225.876,224.374l-.034-.454-6.471.729.034.454Z",
    transform: "translate(-68.511 -69.934)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M226.775,235.784l-.041-.454-6.444.7.041.454Z",
    transform: "translate(-68.798 -73.497)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M224.074,201.544l-.034-.454-6.519.791.034.454Z",
    transform: "translate(-67.933 -62.804)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M291.037,303.25l-15.067,2.022.028.605,15.1-2.029.007-.1Z",
    transform: "translate(-86.187 -94.709)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M291.195,318.77l-14.545,1.6.028.605,14.579-1.6v-.028Z",
    transform: "translate(-86.4 -99.556)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M290.876,287.72,275.3,290.175l.028.605,15.624-2.455v-.158Z",
    transform: "translate(-85.978 -89.859)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M290.722,272.19l-16.092,2.888.028.612,16.14-2.9V272.6Z",
    transform: "translate(-85.769 -85.009)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M291.548,350.435l-.034-.605L278,350.559l.028.605Z",
    transform: "translate(-86.821 -109.256)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M291.356,334.3l-14.036,1.162.027.605,14.056-1.162Z",
    transform: "translate(-86.609 -104.406)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M289.79,179.03l-19.2,5.495.028.626,19.255-5.515v-.316Z",
    transform: "translate(-84.507 -55.914)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M290.1,210.08l-18.169,4.628.028.619,18.217-4.642.007-.282Z",
    transform: "translate(-84.926 -65.612)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M289.945,194.55l-18.685,5.061.027.619,18.74-5.075v-.3Z",
    transform: "translate(-84.716 -60.761)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M290.565,256.66l-16.615,3.322.027.612,16.663-3.328v-.22Z",
    transform: "translate(-85.556 -80.159)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M290.41,241.14l-17.13,3.755.028.612,17.179-3.769V241.5Z",
    transform: "translate(-85.347 -75.312)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M290.256,225.61,272.61,229.8l.028.619,17.694-4.2v-.268Z",
    transform: "translate(-85.138 -70.462)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M291.037,302.73l-15.067,2.015.028.612,15.1-2.029.007-.1Z",
    transform: "translate(-86.187 -94.547)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M291.195,318.25l-14.545,1.589.028.612,14.579-1.6v-.027Z",
    transform: "translate(-86.4 -99.394)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M290.876,287.2,275.3,289.648l.028.612,15.624-2.462v-.151Z",
    transform: "translate(-85.978 -89.697)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M290.722,271.67l-16.092,2.888.028.605,16.14-2.888v-.193Z",
    transform: "translate(-85.769 -84.847)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M291.548,349.915l-.034-.605L278,350.039l.028.605Z",
    transform: "translate(-86.821 -109.094)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M291.356,333.78l-14.036,1.162.027.605,14.056-1.162Z",
    transform: "translate(-86.609 -104.244)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M289.79,178.5l-19.2,5.5.028.619,19.255-5.515V178.8Z",
    transform: "translate(-84.507 -55.749)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M290.1,209.56l-18.169,4.621.028.619,18.217-4.635.007-.282Z",
    transform: "translate(-84.926 -65.449)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M289.945,194.03l-18.685,5.061.027.619,18.74-5.075v-.3Z",
    transform: "translate(-84.716 -60.599)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M290.565,256.14l-16.615,3.322.027.612,16.663-3.328v-.22Z",
    transform: "translate(-85.556 -79.996)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M290.41,240.61l-17.13,3.755.028.619,17.179-3.769v-.241Z",
    transform: "translate(-85.347 -75.146)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M290.256,225.09l-17.646,4.188.028.612,17.694-4.2v-.261Z",
    transform: "translate(-85.138 -70.299)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M312.684,191.755l.007-.5L306.02,194v.488Z",
    transform: "translate(-95.572 -59.734)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M312.869,177.722l.007-.5-6.719,2.916-.007.5Z",
    transform: "translate(-95.613 -55.349)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M323.237,158.784l-.007.5,5.57-2.544.007-.5Z",
    transform: "translate(-100.947 -48.797)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M323.017,173.044l-.007.5,5.618-2.434.007-.5Z",
    transform: "translate(-100.878 -53.285)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M306.28,166.777l6.774-3.095.007-.5-6.774,3.095Z",
    transform: "translate(-95.653 -50.964)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M312.5,205.8l.007-.488-6.616,2.551-.007.488Z",
    transform: "translate(-95.528 -64.122)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M312.119,233.881l.007-.481-6.5,2.187-.007.481Z",
    transform: "translate(-95.447 -72.895)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M312.3,219.838l.014-.488-6.561,2.373-.007.481Z",
    transform: "translate(-95.488 -68.507)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M321.517,273l-.007.468,5.928-1.534.007-.475Z",
    transform: "translate(-100.41 -84.781)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M311.934,247.921l.007-.481-6.451,2.008v.475Z",
    transform: "translate(-95.407 -77.279)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M322.807,187.308l-.007.5,5.66-2.324.007-.488Z",
    transform: "translate(-100.813 -57.776)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M321.737,258.7l-.007.468,5.887-1.678v-.475Z",
    transform: "translate(-100.478 -80.271)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M321.307,287.309l-.007.468,5.976-1.389v-.468Z",
    transform: "translate(-100.344 -89.297)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M327.1,300.841l.007-.461-6.017,1.238-.007.461Z",
    transform: "translate(-100.275 -93.813)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M322.594,201.571l-.014.488,5.708-2.2.007-.488Z",
    transform: "translate(-100.744 -62.267)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M322.167,230.126l-.007.481,5.79-1.946.007-.481Z",
    transform: "translate(-100.613 -71.264)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M322.377,215.847l-.007.488,5.749-2.084.007-.481Z",
    transform: "translate(-100.678 -66.764)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M321.947,244.412l-.007.475,5.845-1.816v-.481Z",
    transform: "translate(-100.544 -75.765)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M345.21,207.32,337.81,210v.488l7.468-2.7.014-.248Z",
    transform: "translate(-105.5 -64.75)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M344.418,237.27l-6.911,2.146-.007.481,6.973-2.173.007-.241Z",
    transform: "translate(-105.403 -74.103)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M344.819,222.3l-7.159,2.407v.481l7.221-2.434.007-.241Z",
    transform: "translate(-105.453 -69.428)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M311.746,261.965l.007-.475-6.4,1.822-.007.474Z",
    transform: "translate(-95.363 -81.667)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M346.8,147.44l-8.383,3.83-.007.5,8.479-3.872.007-.254Z",
    transform: "translate(-105.688 -46.049)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M343.623,267.21l-6.416,1.664-.007.468,6.471-1.678.007-.234Z",
    transform: "translate(-105.31 -83.454)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M345.607,192.35l-7.64,2.95-.007.488,7.723-2.978.007-.248Z",
    transform: "translate(-105.547 -60.074)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M346.4,162.41l-8.135,3.528-.007.5,8.225-3.562.007-.254Z",
    transform: "translate(-105.641 -50.724)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M346,177.38l-7.888,3.239-.007.488,7.97-3.267.014-.248Z",
    transform: "translate(-105.594 -55.399)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M344.021,252.24l-6.664,1.9-.007.468,6.726-1.919.007-.234Z",
    transform: "translate(-105.357 -78.778)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M311,318.141l.007-.461-6.176,1.1-.007.461Z",
    transform: "translate(-95.197 -99.216)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M311.181,304.1l.007-.468-6.23,1.279-.007.468Z",
    transform: "translate(-95.238 -94.828)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M311.376,290.048l.007-.468-6.292,1.465v.468Z",
    transform: "translate(-95.282 -90.44)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M311.561,276l.007-.475-6.341,1.65-.007.468Z",
    transform: "translate(-95.322 -86.052)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M342.835,297.15l-5.935,1.224v.461l5.969-1.224.007-.234Z",
    transform: "translate(-105.216 -92.804)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M326.935,314.85l-6.059,1.08-.007.468,6.065-1.08Z",
    transform: "translate(-100.21 -98.332)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M343.225,282.18l-6.169,1.437-.007.468,6.224-1.444.007-.241Z",
    transform: "translate(-105.263 -88.129)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M342.478,312.35l-.041-.22-5.687,1.011v.461l5.722-1.018Z",
    transform: "translate(-105.169 -97.482)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M312.684,191.415l.007-.5-6.671,2.73v.5Z",
    transform: "translate(-95.572 -59.628)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M312.869,177.375l.007-.5-6.719,2.909-.007.5Z",
    transform: "translate(-95.613 -55.243)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M323.237,158.444l-.007.5,5.57-2.544.007-.5Z",
    transform: "translate(-100.947 -48.691)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M323.017,172.694l-.007.5,5.618-2.434.007-.5Z",
    transform: "translate(-100.878 -53.176)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M306.28,166.43l6.774-3.088.007-.5-6.774,3.095Z",
    transform: "translate(-95.653 -50.858)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M312.5,205.448l.007-.488-6.616,2.551-.007.488Z",
    transform: "translate(-95.528 -64.013)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M312.119,233.531l.007-.481-6.5,2.187-.007.481Z",
    transform: "translate(-95.447 -72.785)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M312.3,219.491l.014-.481-6.561,2.366-.007.488Z",
    transform: "translate(-95.488 -68.4)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M321.517,272.66l-.007.468,5.928-1.54.007-.468Z",
    transform: "translate(-100.41 -84.675)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M311.934,247.575l.007-.475-6.451,2v.481Z",
    transform: "translate(-95.407 -77.173)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M322.807,186.958l-.007.5,5.66-2.318.007-.5Z",
    transform: "translate(-100.813 -57.666)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M321.737,258.358l-.007.475,5.887-1.678v-.475Z",
    transform: "translate(-100.478 -80.165)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M321.307,286.959l-.007.468,5.976-1.389v-.468Z",
    transform: "translate(-100.344 -89.188)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M327.1,300.5l.007-.468-6.017,1.238-.007.468Z",
    transform: "translate(-100.275 -93.704)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M322.594,201.231l-.014.488,5.708-2.2.007-.488Z",
    transform: "translate(-100.744 -62.161)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M322.167,229.783l-.007.481,5.79-1.953.007-.481Z",
    transform: "translate(-100.613 -71.155)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M322.377,215.507l-.007.481,5.749-2.077.007-.481Z",
    transform: "translate(-100.678 -66.658)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M321.947,244.066l-.007.481,5.845-1.822v-.475Z",
    transform: "translate(-100.544 -75.658)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M345.21,206.98l-7.4,2.675v.481l7.468-2.7.014-.248Z",
    transform: "translate(-105.5 -64.643)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M344.418,236.92l-6.911,2.152-.007.475,6.973-2.166.007-.241Z",
    transform: "translate(-105.403 -73.994)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M344.819,221.95l-7.159,2.407v.481l7.221-2.428.007-.248Z",
    transform: "translate(-105.453 -69.319)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M311.746,261.615l.007-.474-6.4,1.829-.007.475Z",
    transform: "translate(-95.363 -81.558)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M346.8,147.1l-8.383,3.824-.007.5,8.479-3.865.007-.254Z",
    transform: "translate(-105.688 -45.942)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M343.623,266.87l-6.416,1.664L337.2,269l6.471-1.678.007-.234Z",
    transform: "translate(-105.31 -83.347)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M345.607,192.01l-7.64,2.95-.007.488,7.723-2.978.007-.248Z",
    transform: "translate(-105.547 -59.968)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M346.4,162.07l-8.135,3.528-.007.5,8.225-3.562.007-.254Z",
    transform: "translate(-105.641 -50.618)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M346,177.04l-7.888,3.232-.007.5,7.97-3.267.014-.254Z",
    transform: "translate(-105.594 -55.293)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M344.021,251.9l-6.664,1.9-.007.475,6.726-1.919.007-.241Z",
    transform: "translate(-105.357 -78.672)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M311,317.8l.007-.461-6.176,1.1-.007.461Z",
    transform: "translate(-95.197 -99.11)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M311.181,303.751l.007-.461-6.23,1.279-.007.461Z",
    transform: "translate(-95.238 -94.722)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M311.376,289.708l.007-.468L305.09,290.7v.468Z",
    transform: "translate(-95.282 -90.334)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M311.561,275.665l.007-.475-6.341,1.644-.007.468Z",
    transform: "translate(-95.322 -85.946)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M342.835,296.81l-5.935,1.217v.468l5.969-1.231.007-.234Z",
    transform: "translate(-105.216 -92.698)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M326.935,314.51l-6.059,1.08-.007.461,6.065-1.08Z",
    transform: "translate(-100.21 -98.226)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M343.225,281.84l-6.169,1.437-.007.468,6.224-1.451.007-.234Z",
    transform: "translate(-105.263 -88.023)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M342.478,312.007l-.041-.227-5.687,1.011v.468l5.722-1.025Z",
    transform: "translate(-105.169 -97.373)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M236.436,356.889l-.626-8.08,3.493,7.977Zm10.13-.371-3.095-9.531.2,9.628Zm7.255-.268-2.331-10.783-.818,10.872Zm7.255-.268-1.32-11.691-1.6.1-.227,11.732Z",
    transform: "translate(-73.645 -107.526)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M225.27,371.885l.144,1.2,83.995.3,20.287-.756.358-1.871-20.514-.454Z",
    transform: "translate(-70.353 -115.652)",
    fill: "#792935",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M365.52,198.353l16.47,9.944.516-5.722-16.8-7.056Z",
    transform: "translate(-114.154 -61.064)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M367.33,170.415l16.924,10.212.5-5.5-17.2-8.025Z",
    transform: "translate(-114.72 -52.189)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M358.29,309.9l14.675,8.864.564-6.23-15.191-3.308Z",
    transform: "translate(-111.896 -96.577)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M369.74,133.216l17.082,15.336.8-8.919L370.015,129Z",
    transform: "translate(-115.472 -40.29)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M363.69,226.546l16.01,9.669.557-6.175-16.4-6.1Z",
    transform: "translate(-113.583 -69.94)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M360.08,282.237l15.115,9.126.578-6.341-15.6-4.222Z",
    transform: "translate(-112.455 -87.698)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M361.88,254.371l15.569,9.4.564-6.251-16-5.151Z",
    transform: "translate(-113.017 -78.819)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M327.021,352.064q.124-2.586.124-5.22c0-38.731-20.507-70.145-45.807-70.145s-45.807,31.4-45.807,70.145q0,2.634.124,5.22Z",
    transform: "translate(-73.558 -86.417)",
    fill: "#792935",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M114.3,385.672H14.49l.949-1.362h98.12Z",
    transform: "translate(-4.525 -120.025)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M112.1,385.672l.64-1.362h31.3l.743,1.362Z",
    transform: "translate(-35.01 -120.025)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M33.125,368.06l.062.076.206,1.8-1.788.165-.076-.055Z",
    transform: "translate(-9.847 -114.95)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 0.475,
    cy: 0.475,
    r: 0.475,
    transform: "translate(19.902 251.343)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M30.779,378.59h-.3v-3.452l-.3-3.294-.763-5.653.3-.041.763,5.66.3,3.315Z",
    transform: "translate(-9.185 -114.353)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M29.17,367.519l1.018-.179-.22.344.358,2.5.3.488-1.293.089.282-.523-.275-2.483Z",
    transform: "translate(-9.11 -114.725)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M30.164,379.158l1.258-.138-.248.392.371,2.881H31.7v.316l-1.774.048v-.3h.261l.144-2.861Z",
    transform: "translate(-9.347 -118.373)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M26.98,368.99l1.41.124.1,1.561-1.32.179Z",
    transform: "translate(-8.426 -115.24)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M28.78,370.115l.729-.055.014.22-.722.083Z",
    transform: "translate(-8.988 -115.574)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M30.41,369.617l.777-.117.034.227-.791.076Z",
    transform: "translate(-9.497 -115.399)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M31.34,368.369l.131,1.678,1.76-.151-.165-1.836Z",
    transform: "translate(-9.788 -114.95)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M27.21,369.23l.11,1.554,1.128-.131-.083-1.368Z",
    transform: "translate(-8.498 -115.315)",
    fill: "#e5bfa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M31.55,368.522l.1,1.437,1.5-.117-.11-1.6Z",
    transform: "translate(-9.853 -115.006)",
    fill: "#f4f7c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M26.93,368.99l-.11.014.172,1.85h.124Z",
    transform: "translate(-8.376 -115.24)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M29.468,366.378a.358.358,0,0,1-.055-.688.475.475,0,0,0-.131.365.509.509,0,0,0,.186.323Z",
    transform: "translate(-9.112 -114.21)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M29.8,367.59l-.447.062.11.144.337,2.469-.193.44.413-.041a.4.4,0,0,1-.131-.2c0-.117-.316-2.682-.316-2.682Z",
    transform: "translate(-9.166 -114.803)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M30.56,379.351l.124.22-.124,2.813h.351l-.055-2.84.055-.234Z",
    transform: "translate(-9.544 -118.463)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M42.15,370.337l.364,9.119H85.076l.337-10.666Z",
    transform: "translate(-13.164 -115.178)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M50.5,368.99l-1.54,10.535h1.32l5.508-10.535Z",
    transform: "translate(-15.291 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M58.528,368.99,54.56,379.519h1.052l4.264-10.529Z",
    transform: "translate(-17.039 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M68.9,368.99l-1.54,10.535h1.32l5.508-10.535Z",
    transform: "translate(-21.037 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M76.928,368.99,72.96,379.519h1.052l4.264-10.529Z",
    transform: "translate(-22.786 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M88.6,368.99l-1.54,10.535h1.32l5.508-10.535Z",
    transform: "translate(-27.189 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M96.631,368.99,92.67,379.519h1.045l4.264-10.529Z",
    transform: "translate(-28.941 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M33.45,219.16l54.782-24.09L83.019,307.5l-45.972,3.383Z",
    transform: "translate(-10.447 -60.924)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M110.743,195.07l31.8,23.547-10.384,91.429L105.53,307.5Z",
    transform: "translate(-32.958 -60.924)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M70.173,198.819l-24,112.383H43.38L50,206.9Zm4.277-1.953L52.85,310.019h2.826L79.511,195.532Zm10.4-2.331L67.023,309.469l1.616-.53L88.761,192.3Z",
    transform: "translate(-13.548 -60.059)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M44.586,216.38l-9.029,49.837-1.946-43.49Z",
    transform: "translate(-10.497 -67.579)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M133.774,203.249,126.5,311.285H122.86V198.93ZM132.4,311.389l3.012.688,12.427-99.812-10.666-6.375Z",
    transform: "translate(-38.37 -62.129)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M104.916,276.92,95.33,335.374l7.014-1.059Z",
    transform: "translate(-29.772 -86.486)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M104.57,379.456h23.739l1.41-9.676-24.812-.99Z",
    transform: "translate(-32.658 -115.178)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M135.233,370.028l-5.8-.248-1.169,9.985h5.845Z",
    transform: "translate(-40.056 -115.487)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 59.843,
    height: 0.44,
    transform: "translate(23.099 158.407) rotate(-23.71)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M88.122,195.246l-.688,14.779-7.1,2.751.509-14.077H80.3l-.516,14.311-7.1,2.751.344-13.616h-.55l-.351,13.843-7.111,2.751.186-13.156h-.55l-.186,13.376-7.111,2.751V209.014H56.8v12.908l-7.118,2.751-.138-12.234h-.55l.138,12.44L42,227.63l-.289-11.78h-.55l.3,11.98-7.125,2.751L33.89,219.26h-.55l3.6,91.725h.55l-.337-8.658,6.134-.756.22,9.009h.55l-.227-9.05,6.134-.756.1,9.332h.55l-.1-9.394,6.141-.756v9.669h.523v-9.738l6.141-.756-.138,10.006h.55l.138-10.082,6.141-.756-.261,10.315h.55l.261-10.432,6.141-.756-.385,10.687h.55l.392-10.776,6.141-.756-.509,11h.55L88.651,195.15Zm-.688,15.129-.688,14.036-6.939,2.421.5-13.685ZM84.119,281.9l-6.313,1.135.488-13.713,6.457-1.417ZM63.908,258.879l-6.629,1.754V248.006l6.774-2.07Zm.736-13.128,6.781-2.063-.337,13.321-6.622,1.754Zm-7.908,15.033-6.629,1.754-.138-12.268,6.788-2.063Zm-7.18,1.9-6.629,1.754-.3-11.911,6.788-2.063Zm0,.344.138,12.248L43.222,276.7l-.3-11.918Zm.55-.144,6.622-1.754v12.605l-6.464,1.424Zm7.18-1.9,6.622-1.754-.179,12.963-6.464,1.424Zm7.173-1.9,6.622-1.754-.337,13.321-6.471,1.417Zm7.159-1.9,6.616-1.754-.5,13.678-6.464,1.424Zm0-.344.337-13.341,6.781-2.063-.5,13.678Zm.344-13.692L72.3,229.81l6.959-2.441-.5,13.685Zm-.557.172-6.788,2.063L64.8,232.4l6.946-2.421Zm-7.338,2.263-6.788,2.063V235.022l6.946-2.428Zm-7.338,2.263L49.934,249.9l-.11-12.22,6.953-2.428Zm-7.317,2.221-6.794,2.063-.3-11.9,6.953-2.428Zm-7.365,2.29-6.8,2.063-.454-11.546,6.959-2.428Zm0,.344.3,11.89-6.636,1.754-.454-11.553Zm.3,12.227.3,11.89L36.2,278.258,35.747,266.7Zm.3,12.227.3,11.89-6.306,1.087-.454-11.56Zm.55-.124,6.464-1.424.138,12.248L43.5,288.938Zm7.042-1.52,6.464-1.424v12.605L50.4,287.775Zm7.014-1.54,6.464-1.417-.179,12.963L57.237,286.6Zm7.014-1.54,6.457-1.417-.337,13.321-6.306,1.087Zm7.014-1.54,6.457-1.417-.5,13.678-6.32,1.066Zm13.486-3.3L78.308,269l.5-13.706,6.616-1.754Zm.688-14.38-6.622,1.754.5-13.7,6.774-2.063Zm.688-14.38-6.781,2.063.5-13.692,6.884-2.428Zm-6.341-25.445-.5,13.664L72.3,229.432l.337-13.334Zm-7.7,2.985-.337,13.307L64.829,232.1l.179-12.984Zm-7.661,2.978-.179,12.949L57.32,234.72V222.1Zm-7.661,2.978v12.6l-6.973,2.393-.138-12.262ZM49.129,225.3l.138,12.241-6.959,2.428-.261-11.911Zm-7.661,2.978.3,11.883L34.8,242.587l-.454-11.546Zm-4.332,73.748-.454-11.56,6.3-1.087.3,11.89Zm6.691-.825-.3-11.938,6.3-1.087.138,12.255Zm6.691-.825-.138-12.282,6.3-1.087v12.612Zm6.657-.8v-12.64l6.354-1.114L63.365,298.8Zm6.691-.825.179-13,6.3-1.087-.337,13.327Zm6.7-.825.364-13.376,6.3-1.087-.5,13.685Zm6.7-.825.543-13.733,6.3-1.087-.653,14.043Z",
    transform: "translate(-10.412 -60.949)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 0.44,
    height: 39.37,
    transform: "matrix(0.594, -0.805, 0.805, 0.594, 77.543, 134.83)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M49.015,379.525l-.275-9.277h.22l.275,9.277Zm2.668,0-.241-9.366h-.22l.241,9.366Zm2.448,0-.206-9.456h-.193l.206,9.456Zm2.448,0-.172-9.545h-.22l.172,9.545Zm2.448,0L58.89,369.9h-.206l.138,9.628Zm2.448,0-.1-9.724h-.22l.138,9.717Zm2.448,0-.041-9.841h-.22l.062,9.813Zm2.448,0v-9.9h-.22v9.9Zm2.489-10h-.22v9.992h.22Zm2.489-.089h-.22l-.041,10.082h.22Zm2.489-.089h-.234l-.076,10.171h.22Zm2.489-.089h-.22l-.117,10.26h.22Zm2.489-.089H78.6l-.151,10.315h.22Zm2.489-.089h-.22L80.9,379.519h.22Zm2.489-.089h-.22L83.3,379.519h.22Z",
    transform: "translate(-15.222 -115.24)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M48.875,379.529l-.275-9.277h.22l.275,9.277Zm2.668,0-.241-9.366h-.22l.241,9.366Zm2.448,0-.206-9.456h-.22l.206,9.456Zm2.448,0-.172-9.545h-.241l.172,9.545Zm2.448,0L58.75,369.9H58.5l.138,9.628Zm2.448,0-.083-9.731h-.22l.1,9.724Zm2.448,0-.076-9.841h-.22l.062,9.813Zm2.448,0v-9.9h-.22v9.9Zm2.462-9.992h-.22v9.985h.22Zm2.489-.089H70.95l-.069,10.075h.22Zm2.489-.089h-.22l-.1,10.164h.22Zm2.489-.089h-.22l-.117,10.26h.22Zm2.489-.089h-.22l-.151,10.315h.165Zm2.489-.089h-.22l-.186,10.439h.22ZM83.631,369h-.22l-.22,10.529h.22Z",
    transform: "translate(-15.178 -115.243)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M142.233,220.489,141.009,231.3l-3.954-2.51,1.183-11.6-.55-.055-1.155,11.326-3.947-2.5,1.107-12.131-.55-.048-1.08,11.849-3.94-2.5,1.032-12.667-.55-.048-1,12.378-3.934-2.5.949-13.2-.55-.041-.928,12.9-3.927-2.5.867-13.754-.55-.034-.846,13.431-3.927-2.489.777-14.27h-.55l-.756,13.96-4.126-2.606-.179.282,4.264,2.71-.743,13.706-4.016-2.331-.165.289,4.126,2.386-.743,13.719-3.906-2-.151.3,4.057,2.063-.75,13.754-3.83-1.705-.138.3,3.947,1.754-.75,13.754L107.38,269.3l-.117.309,3.844,1.437-.75,13.754-3.652-1.1-.1.316,3.734,1.128-.75,13.754-3.569-.8-.076.323,3.624.811L109,309.841h.55l.571-10.522,3.315.743-.571,10.075.55.034.633-10.02,3.315.743-.688,9.628.55.041.688-9.525,3.315.743-.8,9.043.55.048.743-8.988,3.308.743-.784,8.6.55.048.777-8.527,3.3.743-.825,8.1.55.055.818-8.032,3.3.736-.86,7.6.55.062,10.384-91.463Zm-1.265,11.175-1.334,11.766-3.844-2.207,1.231-12.048ZM124.4,262.095l-3.624-1.609.935-13.066,3.727,1.9Zm1.568-12.475,3.727,1.9-1.135,12.42-3.624-1.609Zm-1.6,12.825L123.335,275.2l-3.521-1.32.935-13.066Zm.536.234,3.624,1.609L127.4,276.715l-3.535-1.32Zm4.126,1.85,3.624,1.609-1.231,12.1-3.521-1.32Zm0-.351,1.135-12.378,3.734,1.9-1.238,12.09Zm1.162-12.743,1.135-12.378,3.837,2.207-1.231,12.083Zm-.53-.268-3.734-1.9,1.032-12.709,3.83,2.2Zm-4.264-2.18-3.727-1.9.935-13.066,3.83,2.2Zm-4.264-2.18-3.727-1.9.839-13.362,3.824,2.2Zm0,.358-.942,13.066-3.624-1.609.839-13.369Zm-.922,13.458-.942,13.066-3.521-1.32L116.6,259Zm-.963,13.424-.942,13.066-3.438-1.032.839-13.376Zm.536.2,3.521,1.32-1.038,12.764-3.438-1.032Zm4.071,1.506,3.521,1.32-1.155,12.433-3.438-1.032Zm4.051,1.52,3.521,1.32L130.2,290.7l-3.438-1.032Zm4.051,1.52,3.514,1.32-1.334,11.78-3.438-1.025Zm.034-.344,1.231-12.062L136.855,268l-1.334,11.773Zm1.265-12.378,1.231-12.062,3.734,1.9L136.9,267.679Zm1.265-12.378,1.231-12.055,3.844,2.207-1.334,11.76Zm1.981-24.757L135.28,241.01l-3.851-2.318,1.128-12.378Zm-4.463-2.833-1.135,12.378-3.837-2.2,1.032-12.7Zm-4.463-2.833-1.052,12.6-3.83-2.2.935-13.025Zm-4.456-2.833-.935,13.066-3.83-2.2.839-13.355Zm-8.376-5.323,3.92,2.489-.839,13.383-3.824-2.194Zm-.763,14.05,3.824,2.194-.839,13.389-3.755-2Zm-.763,14.043,3.72,1.9-.839,13.4-3.624-1.609Zm-.763,14.043,3.617,1.609-.846,13.41-3.521-1.32Zm-.763,14.043,3.521,1.32-.846,13.417L110.936,285Zm-1.506,27.748.743-13.706,3.438,1.032-.846,13.424Zm3.837.784.839-13.383,3.438,1.032-.942,13.066Zm3.858.867.935-13.066,3.438,1.032-1.038,12.764Zm3.858.866,1.032-12.722,3.438,1.032-1.135,12.44Zm3.851.867,1.135-12.378,3.438,1.025-1.238,12.11Zm3.851.86,1.231-12.069,3.438,1.025-1.341,11.78Z",
    transform: "translate(-33.089 -62.57)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M142.52,220.122l-1.258,10.824-3.954-2.51,1.183-11.6-.55-.055-1.155,11.326-3.947-2.5,1.107-12.131-.55-.048-1.08,11.849-3.94-2.5,1.032-12.667-.55-.048-1,12.378-3.934-2.489.949-13.2-.55-.041-.928,12.9-3.927-2.5.866-13.754-.55-.034-.846,13.431-3.92-2.5.77-14.256h-.55l-.756,13.96-4.126-2.606-.179.282,4.264,2.71-.743,13.706-4.016-2.3-.165.289,4.126,2.386-.688,13.671-3.927-2.008-.151.3,4.057,2.063-.75,13.754-3.83-1.706-.138.3,3.947,1.754-.75,13.754-3.741-1.375-.117.309,3.837,1.437-.75,13.754-3.652-1.1-.1.316,3.734,1.121-.75,13.754-3.569-.866-.076.323,3.624.811-.578,10.611h.55l.571-10.522,3.315.743-.633,10.109.55.034.633-10.02,3.315.743-.688,9.628.55.041.688-9.525,3.315.743-.743,9.105.55.048.736-9.029,3.308.743-.784,8.6.55.048.777-8.527,3.3.743-.825,8.1.55.055.818-8.032,3.3.736-.86,7.6.55.062,10.384-91.463ZM141.254,231.3l-1.334,11.746-3.844-2.207,1.231-12.048Zm-16.615,30.43-3.624-1.609.935-13.066,3.727,1.9Zm1.568-12.475,3.727,1.9-1.135,12.42-3.624-1.609Zm-1.568,12.825L123.6,274.835l-3.521-1.32.935-13.066Zm.536.234,3.59,1.644-1.121,12.378-3.521-1.32Zm4.126,1.85,3.624,1.609-1.238,12.1-3.521-1.32Zm0-.351,1.135-12.378,3.734,1.9-1.238,12.09Zm1.162-12.743L131.6,238.69l3.837,2.207-1.169,12.055Zm-.53-.268-3.734-1.9,1.032-12.709,3.83,2.2Zm-4.264-2.18-3.727-1.9.935-13.066,3.83,2.2Zm-4.264-2.18-3.645-1.9.839-13.362,3.824,2.2Zm0,.358-.942,13.066-3.624-1.609.839-13.369Zm-.963,13.424-.942,13.066-3.521-1.32.839-13.369Zm-.963,13.424-.942,13.066L115.1,285.68l.839-13.376Zm.536.2,3.521,1.32L122.5,287.928l-3.438-1.032Zm4.057,1.52,3.521,1.32-1.135,12.433-3.438-1.032Zm4.051,1.52,3.521,1.32-1.238,12.1-3.438-1.032ZM132.2,278.4l3.514,1.32-1.334,11.78-3.438-1.025Zm.034-.337,1.231-12.042,3.624,1.609L135.76,279.4Zm1.265-12.378,1.231-12.062,3.734,1.9-1.334,11.766Zm1.265-12.378L136,241.248l3.844,2.207-1.334,11.76Zm1.981-24.757-1.231,12.076-3.844-2.208,1.128-12.378Zm-4.463-2.833-1.135,12.378-3.837-2.2,1.032-12.7Zm-4.463-2.833-1.038,12.729-3.83-2.2.935-13.025Zm-4.463-2.936-.935,13.066-3.83-2.2.839-13.355Zm-8.349-5.309,3.92,2.489-.839,13.383-3.824-2.194Zm-.763,14.05,3.824,2.194-.839,13.389-3.72-1.9Zm-.763,14.043,3.72,1.9-.839,13.4-3.659-1.637Zm-.763,14.043,3.617,1.609-.846,13.41-3.521-1.32Zm-.8,14.063,3.521,1.32L114.6,285.57l-3.438-1.032Zm-1.506,27.748.743-13.706,3.438,1.032-.846,13.424Zm3.865.866.839-13.383,3.438,1.032-.942,13.066Zm3.858.867.935-13.066,3.438,1.032-1.038,12.764Zm3.858.866,1.032-12.722,3.438,1.032L125.327,301.9Zm3.851.867,1.135-12.378,3.438,1.025-1.238,12.11Zm3.851.86,1.231-12.069,3.438,1.025-1.341,11.78Z",
    transform: "translate(-33.176 -62.464)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M87.832,195.038l-.688,14.779-7.1,2.751.509-14.077h-.55L79.49,212.8l-7.1,2.751.344-13.616h-.55l-.351,13.843-7.111,2.751.186-13.156h-.55l-.186,13.376L57.057,221.5V208.805h-.55v12.908l-7.118,2.751-.138-12.234H48.7l.138,12.44-7.125,2.751-.289-11.78h-.55l.3,11.98-7.125,2.751L33.6,219.052h-.55l3.6,91.725h.55l-.344-8.706,6.134-.756.22,8.995h.55l-.22-8.988,6.134-.756.1,9.332h.55l-.117-9.394,6.141-.756v9.669h.55v-9.738l6.141-.756L62.9,308.926h.55l.138-10.082,6.141-.756-.268,10.384h.55l.261-10.432,6.141-.756-.385,10.687h.55l.392-10.776,6.141-.756-.509,11h.55L88.368,195.01Zm-.688,15.129-.653,14.022-6.953,2.448.5-13.685Zm-3.315,71.52-6.32,1.135.5-13.706,6.457-1.417ZM63.611,258.67l-6.629,1.754V247.8l6.788-2.063Zm.736-13.128,6.781-2.063L70.791,256.8l-6.622,1.754Zm-7.908,15.033-6.629,1.754-.138-12.268L56.459,248Zm-7.18,1.9-6.616,1.76-.3-11.911,6.788-2.063Zm0,.344.138,12.248-6.471,1.424-.282-11.918Zm.55-.144,6.622-1.754v12.605l-6.464,1.424Zm7.18-1.9,6.622-1.754-.179,12.963L56.961,273.4Zm7.173-1.9,6.622-1.754-.337,13.321-6.485,1.417Zm7.18-1.9,6.616-1.754-.5,13.678L71,270.326Zm0-.344.337-13.341,6.781-2.063-.5,13.678Zm.344-13.692.337-13.334,6.939-2.421-.5,13.671Zm-.557.172-6.788,2.063.179-12.977,6.946-2.421Zm-7.338,2.263L57,247.44V234.821l6.959-2.414Zm-7.338,2.263L49.658,249.7l-.138-12.248,6.953-2.428Zm-7.338,2.242-6.794,2.063-.3-11.9,6.959-2.4Zm-7.345,2.263-6.8,2.063-.454-11.546,6.959-2.428Zm0,.344.3,11.89-6.636,1.754-.454-11.553Zm.3,12.227.3,11.89L35.9,278.028l-.454-11.553Zm.3,12.227.3,11.89-6.3,1.073-.454-11.56Zm.55-.124,6.464-1.424.138,12.248-6.306,1.087Zm7.014-1.54,6.464-1.424L56.4,286.466l-6.306,1.087Zm7.014-1.54,6.464-1.417-.144,12.963-6.306,1.087Zm7.008-1.54,6.457-1.417L70.082,284.1l-6.306,1.087Zm7.028-1.547,6.457-1.417-.5,13.678L70.653,284Zm13.486-3.3-6.464,1.417.5-13.706,6.616-1.754Zm.688-14.38-6.622,1.754.5-13.7,6.774-2.063Zm.688-14.38-6.781,2.063.5-13.692,6.9-2.386Zm-6.341-25.445-.5,13.664L72.07,229.23l.337-13.334Zm-7.654,2.971-.337,13.307-6.946,2.428.179-12.977Zm-7.7,2.957-.2,12.984-6.953,2.428V221.864ZM56.5,222.05v12.6L49.52,237.1l-.138-12.262Zm-7.668,3.005L48.97,237.3,42.018,239.7l-.3-11.9Zm-7.654,2.957.3,11.883-6.966,2.428-.454-11.546Zm-4.339,73.8-.454-11.56,6.3-1.087.3,11.89Zm6.691-.825-.3-11.918,6.286-1.087.138,12.255Zm6.691-.825-.138-12.282L56.4,286.8v12.612Zm6.691-.825V286.7l6.3-1.087-.179,12.97Zm6.691-.825.179-13,6.306-1.114-.337,13.328Zm6.7-.825.337-13.355,6.3-1.087-.5,13.685Zm6.7-.825.5-13.713,6.3-1.087-.653,14.029Z",
    transform: "translate(-10.322 -60.905)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M32.791,218.3l-1.451-.543,56.7-25.445-.468,1.9Z",
    transform: "translate(-9.788 -60.062)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M31.031,210.337l-.681-11.354L88.694,168.56l-.963,16.333Z",
    transform: "translate(-9.479 -52.645)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M113.578,192.31l32.858,24.7-1.527.743-31.8-23.547Z",
    transform: "translate(-35.325 -60.062)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M114.753,168.56l-.963,16.333,32.858,24.7,1.65-12.942Z",
    transform: "translate(-35.537 -52.645)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 0.44,
    height: 39.37,
    transform: "matrix(0.594, -0.805, 0.805, 0.594, 77.657, 134.512)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M36.44,201.21l2.785-1.76v15.569l-2.2,1.1Z",
    transform: "translate(-11.38 -62.292)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M52.17,192.917,55,191.15l.021,16.278L52.768,208.5Z",
    transform: "translate(-16.293 -59.7)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M67.91,184.614l2.875-1.774.041,17-2.311,1.045Z",
    transform: "translate(-21.209 -57.104)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M83.64,176.314l2.923-1.774.062,17.708-2.366,1.025Z",
    transform: "translate(-26.121 -54.512)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M99.38,168.021l2.964-1.781.083,18.423-2.421.99Z",
    transform: "translate(-31.037 -51.92)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M39.491,199.45,43,203.164l-2.049,1.073L40.735,215.8l1.485,1.389-2.462,1.087L37.29,216.12l2.2-1.1Z",
    transform: "translate(-11.646 -62.292)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M55.275,191.15l3.418,3.8-1.932,1.011-.241,12.351,1.513,1.5-2.448,1.073L53.04,208.5l2.256-1.073Z",
    transform: "translate(-16.565 -59.7)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M71.059,182.84l3.322,3.906-1.809.942-.261,13.135,1.54,1.6L71.41,203.5l-2.62-2.613L71.1,199.84Z",
    transform: "translate(-21.484 -57.104)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M86.844,174.54l3.225,4-1.685.88L88.1,193.335l1.568,1.705-2.434,1.073-2.7-2.84,2.366-1.025Z",
    transform: "translate(-26.402 -54.512)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M102.628,166.24l3.129,4.092-1.561.811-.3,14.7,1.6,1.809-2.428,1.073-2.771-3.074,2.421-.99Z",
    transform: "translate(-31.321 -51.92)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M42.63,371.012l1.726-.062.3,9.181H42.994Z",
    transform: "translate(-13.314 -115.852)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M64.551,370.23l.083,9.676H63.018l-.248-9.614Z",
    transform: "translate(-19.603 -115.627)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M84.649,369.51l-.131,10.171H82.944l-.124-10.1Z",
    transform: "translate(-25.865 -115.403)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M42.15,371.012l1.726-.062.3,9.181H42.514Z",
    transform: "translate(-13.164 -115.852)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M64.071,370.23l.083,9.676H62.538l-.248-9.614Z",
    transform: "translate(-19.454 -115.627)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M84.169,369.51l-.131,10.171H82.457l-.117-10.1Z",
    transform: "translate(-25.715 -115.403)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M104.2,368.79l-1.884.069v10.6h1.547Z",
    transform: "translate(-31.955 -115.178)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M117.283,369.309l-.915,10.288H115l.6-10.357Z",
    transform: "translate(-35.915 -115.318)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M128.369,369.752l-1.162,9.985H125.88l.866-10.047Z",
    transform: "translate(-39.313 -115.459)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M139.463,370.2l-1.417,9.676H136.76l1.128-9.738Z",
    transform: "translate(-42.711 -115.599)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M104.907,368.79l1.74.069-.667,10.6h-1.41Z",
    transform: "translate(-32.658 -115.178)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M117.733,369.309l-.915,10.288H115.45l.605-10.357Z",
    transform: "translate(-36.056 -115.318)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M128.826,369.752l-1.169,9.985H126.33l.866-10.047Z",
    transform: "translate(-39.454 -115.459)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M139.916,370.2l-1.41,9.676H137.22l1.128-9.738Z",
    transform: "translate(-42.855 -115.599)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M83.89,358.56l-47.65,3.48.22,1.884,47.286-2.71Z",
    transform: "translate(-11.318 -111.983)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M39.91,365l.165,3.4,44.638-1.6.179-4.381Z",
    transform: "translate(-12.464 -113.188)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M105.464,358.56l28.072,2.682-.44,1.926-27.776-1.953Z",
    transform: "translate(-32.892 -111.983)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M105.239,362.42l26.394,1.857-.55,3.562L105.06,366.8Z",
    transform: "translate(-32.811 -113.188)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M39.91,365l.055,1.245,44.748-2.008,26.318.818.254-.777L84.892,362.42Z",
    transform: "translate(-12.464 -113.188)",
    fill: "#792935",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M156,191.135a2.18,2.18,0,0,1-1.795,1.685c-.736,0-1.128-.75-.873-1.685a2.18,2.18,0,0,1,1.795-1.685C155.865,189.457,156.257,190.206,156,191.135Z",
    transform: "translate(-47.863 -59.169)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M147.22,193.967l5.8-2.957-4.394,4.133Z",
    transform: "translate(-45.978 -59.656)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M135.32,184.147l5.8-2.957-4.4,4.133Z",
    transform: "translate(-42.261 -56.589)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M144.683,181.125a2.18,2.18,0,0,1-1.795,1.685c-.736,0-1.128-.75-.873-1.685a2.18,2.18,0,0,1,1.795-1.685C144.552,179.44,144.944,180.2,144.683,181.125Z",
    transform: "translate(-44.328 -56.042)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M144.241,234.689h-.22l5.041-46.763h.22Zm-2.111-1.217h-.22l4.718-44.769h.22Zm-8.83-1.939h-.22l5.687-49.349h.22Zm3.562-1.1h-.22L141.2,181.51h.22Z",
    transform: "translate(-41.562 -56.689)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M144.045,180.7a2.269,2.269,0,0,1-1.864,1.747c-.763,0-1.169-.784-.908-1.747a2.263,2.263,0,0,1,1.864-1.747C143.908,178.95,144.314,179.727,144.045,180.7Z",
    transform: "translate(-44.096 -55.889)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M155.365,190.707a2.262,2.262,0,0,1-1.864,1.747c-.763,0-1.169-.784-.908-1.747a2.262,2.262,0,0,1,1.864-1.747C155.221,188.988,155.6,189.744,155.365,190.707Z",
    transform: "translate(-47.631 -59.016)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M132.93,253.534l3.686-1.114-.193,5.811-3.493.935Z",
    transform: "translate(-41.515 -78.835)",
    fill: "#91303e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M138.2,252.42l7.633,4.319-1.52,4.628-6.306-3.136Z",
    transform: "translate(-43.101 -78.835)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M132.93,261.805l3.493-.935,6.306,3.136-3.8.867Z",
    transform: "translate(-41.515 -81.474)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M42.15,370.337l43.263-1.547,24.812.99-.22,1.485-24.688.667-43.118-.5Z",
    transform: "translate(-13.164 -115.178)",
    fill: "#792935",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 59.843,
    height: 0.44,
    transform: "translate(22.989 158.228) rotate(-23.71)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M128.719,380.11l5.144.11-.11.474h-5.1Z",
    transform: "translate(-40.178 -118.713)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M133.3,380c-.1.688-.564,1.307-1.045,1.307s-.8-.585-.688-1.307.564-1.307,1.045-1.307S133.4,379.275,133.3,380Z",
    transform: "translate(-41.083 -118.27)",
    fill: "#bc9eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M132.3,381.243a.5.5,0,0,1-.371-.179,1.293,1.293,0,0,1-.22-1c.089-.688.516-1.21.935-1.21a.5.5,0,0,1,.378.179,1.293,1.293,0,0,1,.22,1c-.083.688-.516,1.21-.935,1.21Z",
    transform: "translate(-41.126 -118.32)",
    fill: "#910046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M132.146,380.2l-.076.523,1,.034.089-.516Z",
    transform: "translate(-41.246 -118.741)",
    fill: "#bc9eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M111.362,378.914h-.151v-.11h0c0-.6.069-1.2.124-1.781h.11c-.055.585-.1,1.19-.124,1.781h.1v.11Zm-.254,0h-.076a.818.818,0,0,0-.309-.034h-.055l-.1-2.008h.069a1.373,1.373,0,0,0,.323,0h.062v.041a1.809,1.809,0,0,0,.041.585h-.11a1.905,1.905,0,0,1-.048-.557h-.213l.041.832h.2v.11h-.2l.041.818h0a.95.95,0,0,1,.206,0v-.33h.11Zm-1.107,0-.069-.048h-.179c-.062,0-.227,0-.282-.055a.282.282,0,0,1-.048-.179h0v-1.678h.062a.487.487,0,0,0,.144,0,.358.358,0,0,1,.275,0,.22.22,0,0,1,.076.089v-.131h.309v.11H110.2a12.449,12.449,0,0,1,.089,1.7h.206a4.887,4.887,0,0,1-.048-.523h.11a4.732,4.732,0,0,0,.055.578v.076h-.076a2.309,2.309,0,0,0-.419,0v-.11h.048a12.283,12.283,0,0,0-.089-1.7h-.11a.447.447,0,0,1,0,.254h.083v.11h-.261v-.11h.062c0-.131,0-.213-.041-.248a.268.268,0,0,0-.2,0h-.117v1.589a.193.193,0,0,0,0,.11c0,.041.11,0,.165,0a.522.522,0,0,1,.2,0,.853.853,0,0,0-.048-.364h-.014v-.11h.241v.11h-.083a.963.963,0,0,1,.034.468Zm1.609,0v-.846h-.165v-.11h.158v-.908h-.248v-.138h.344l.076,1.967Zm.22,0v-.11h0c0-.591,0-1.183-.048-1.767h-.048v-.11a.4.4,0,0,1,.523.461v.5a.5.5,0,0,1-.048.289l-.041.048h0a.344.344,0,0,0,0,.131v.048a2.125,2.125,0,0,0,.165.413l-.1.048a2.256,2.256,0,0,1-.172-.433v-.041a.371.371,0,0,1,0-.193.172.172,0,0,1,.055-.083h0a.412.412,0,0,0,0-.227v-.5a.42.42,0,0,0-.117-.33.241.241,0,0,0-.124-.034c.041.585.062,1.176.048,1.76h.1v.083h-.055Zm0-2.3h-.3v-.11h.089a12.523,12.523,0,0,1-.131-1.829h-.069v-.11a1,1,0,0,1,.323-.041.365.365,0,0,1,.3.186.5.5,0,0,1,.041.206v.571a.688.688,0,0,1-.048.364.309.309,0,0,1-.179.151.22.22,0,0,1-.172,0l.055-.1a.117.117,0,0,0,.089,0,.2.2,0,0,0,.117-.1.6.6,0,0,0,.034-.3v-.571a.413.413,0,0,0,0-.165.261.261,0,0,0-.213-.124h-.1a12.434,12.434,0,0,0,.131,1.857h.1Zm-1.9,0v-.11h.1a3.3,3.3,0,0,0-.516-.756c0,.248,0,.5,0,.75h.083v.11h-.227v-.11h.034a15.277,15.277,0,0,1,0-1.767h-.062v-.1a.447.447,0,0,1,.3,0l-.041.1h-.055v.887l.364-.811h0v-.11l.3.041v.11h-.151l-.385.86a3.4,3.4,0,0,1,.543.818h.117l-.083-1.871h.069a1.1,1.1,0,0,0,.371,0h.083v.083a.55.55,0,0,0,0,.337l-.1.041a.688.688,0,0,1,0-.323,1.177,1.177,0,0,1-.261,0l.076,1.7h.351v-.172h.11v.3l-.578-.034v.048a.825.825,0,0,0-.454-.089Zm1.54-.041h-.083a.812.812,0,0,0-.378,0h-.062v-.062a12.78,12.78,0,0,0-.151-1.774v-.062h.523v.062a.832.832,0,0,0,.048.385l-.1.041a.935.935,0,0,1-.062-.371h-.275c.034.282.069.564.089.846a.833.833,0,0,1,.248-.041v.11a.724.724,0,0,0-.22.041v-.069a6.425,6.425,0,0,0,.048.784.935.935,0,0,1,.289,0v-.2h.11Zm-1.128-.825v-.206h.254v.11Z",
    transform: "translate(-34.148 -116.967)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M122.472,378.914h-.151v-.11h0c0-.6.069-1.2.124-1.781h.11c-.055.585-.1,1.19-.124,1.781h.1v.11Zm-.254,0h-.076a.818.818,0,0,0-.309-.034h-.055l-.1-2.008h.069a1.373,1.373,0,0,0,.323,0h.062v.041a1.809,1.809,0,0,0,.041.585h-.11a1.906,1.906,0,0,1-.048-.557H121.8l.041.832h.2v.11h-.2l.041.818h0a.95.95,0,0,1,.206,0v-.33h.117Zm-1.107,0-.069-.048h-.179c-.062,0-.227,0-.282-.055a.282.282,0,0,1-.048-.179h0v-1.678h.062a.487.487,0,0,0,.144,0,.358.358,0,0,1,.275,0,.22.22,0,0,1,.076.089v-.131h.309v.11h-.089a12.442,12.442,0,0,1,.089,1.7h.206a4.891,4.891,0,0,1-.048-.523h.11a4.733,4.733,0,0,0,.055.578v.076h-.076a2.309,2.309,0,0,0-.419,0v-.11h.048a12.282,12.282,0,0,0-.089-1.7h-.11a.447.447,0,0,1,0,.254h.083v.11H120.9v-.11h.062c0-.131,0-.213-.041-.248a.268.268,0,0,0-.2,0H120.6v1.589a.193.193,0,0,0,0,.11c0,.041.11,0,.165,0a.522.522,0,0,1,.2,0,.853.853,0,0,0-.048-.364h-.048v-.11h.241v.11h-.083a.963.963,0,0,1,.034.468Zm1.609,0v-.846h-.165v-.11h.158v-.908h-.248v-.138h.344l.076,1.967Zm.22,0v-.11h0c0-.591,0-1.183-.048-1.767h-.048v-.11a.4.4,0,0,1,.523.461v.5a.5.5,0,0,1-.048.289l-.041.048h0a.344.344,0,0,0,0,.131v.048a2.125,2.125,0,0,0,.165.413l-.1.048a2.256,2.256,0,0,1-.172-.433v-.041a.371.371,0,0,1,0-.193.172.172,0,0,1,.055-.083h0a.413.413,0,0,0,0-.227v-.5a.419.419,0,0,0-.117-.33.241.241,0,0,0-.124-.034c.041.585.062,1.176.048,1.76h.1v.083h-.055Zm0-2.3h-.3v-.11h.089a12.521,12.521,0,0,1-.131-1.829h-.069v-.11a1,1,0,0,1,.323-.041.365.365,0,0,1,.3.186.5.5,0,0,1,.041.206v.571a.688.688,0,0,1-.048.364.309.309,0,0,1-.179.151.22.22,0,0,1-.172,0l.055-.1a.117.117,0,0,0,.089,0,.2.2,0,0,0,.117-.1.605.605,0,0,0,.034-.3v-.571a.413.413,0,0,0,0-.165.261.261,0,0,0-.213-.124h-.1a12.439,12.439,0,0,0,.131,1.857h.1Zm-1.9,0v-.11h.1a3.293,3.293,0,0,0-.516-.757v.75h.083v.11h-.227v-.11h.034a15.309,15.309,0,0,1,0-1.767h-.062v-.1a.447.447,0,0,1,.3,0l-.041.1h-.055v.887l.364-.811h0v-.11l.3.041v.11h-.151l-.385.86a3.4,3.4,0,0,1,.543.818h.117l-.083-1.871h.069a1.1,1.1,0,0,0,.371,0h.083v.083a.543.543,0,0,0,0,.337l-.1.041a.688.688,0,0,1-.034-.323,1.177,1.177,0,0,1-.261,0l.076,1.7h.351v-.172h.11v.3l-.578-.034v.048a.825.825,0,0,0-.413-.089Zm1.54-.041h-.083a.812.812,0,0,0-.378,0h-.062v-.062a12.778,12.778,0,0,0-.151-1.774v-.062h.523v.062a.825.825,0,0,0,.048.385l-.1.041a.935.935,0,0,1-.062-.371h-.275c.034.282.069.564.089.846a.833.833,0,0,1,.248-.041v.11a.724.724,0,0,0-.22.041v-.069a6.425,6.425,0,0,0,.048.784.935.935,0,0,1,.289,0v-.2h.11Zm-1.128-.825v-.206h.254v.11Z",
    transform: "translate(-37.617 -116.967)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M448.074,385.372H300.33l1.4-2.022H446.967Z",
    transform: "translate(-93.795 -119.725)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M444.81,385.372l.949-2.022h46.33l1.107,2.022Z",
    transform: "translate(-138.917 -119.725)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M327.919,359.31l.083.1.309,2.675-2.641.241-.11-.083Z",
    transform: "translate(-101.675 -112.217)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 0.708,
    cy: 0.708,
    r: 0.708,
    transform: "translate(221.238 244.473)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M324.449,374.893h-.454v-5.11l-.447-4.876-1.128-8.362.447-.055,1.128,8.369.454,4.9Z",
    transform: "translate(-100.694 -111.336)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M322.06,358.508l1.513-.268-.33.516.53,3.693.44.715-1.919.144.419-.784-.406-3.672Z",
    transform: "translate(-100.581 -111.883)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M323.527,375.733l1.864-.193-.365.578.55,4.257h.241v.468l-2.627.069v-.433h.385l.206-4.236Z",
    transform: "translate(-100.934 -117.286)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M318.82,360.68l2.091.186.138,2.311-1.953.261Z",
    transform: "translate(-99.57 -112.645)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M321.49,362.343l1.073-.083.028.33-1.073.131Z",
    transform: "translate(-100.403 -113.138)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M323.89,361.612l1.155-.172.048.33-1.169.117Z",
    transform: "translate(-101.153 -112.882)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M325.27,359.764l.2,2.483,2.606-.227-.248-2.71Z",
    transform: "translate(-101.584 -112.217)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M319.16,361.04l.165,2.3,1.664-.2-.117-2.022Z",
    transform: "translate(-99.676 -112.757)",
    fill: "#e5bfa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M325.58,359.99l.144,2.125,2.221-.172-.158-2.373Z",
    transform: "translate(-101.681 -112.298)",
    fill: "#f4f7c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M318.745,360.68l-.165.028.254,2.73h.186Z",
    transform: "translate(-99.495 -112.645)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M322.481,356.8a.536.536,0,0,1-.083-1.052.688.688,0,0,0-.193.536A.75.75,0,0,0,322.481,356.8Z",
    transform: "translate(-100.563 -111.105)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M322.978,358.62l-.688.1.158.213.5,3.659-.282.646.612-.055a.585.585,0,0,1-.2-.289c-.034-.172-.468-3.968-.468-3.968Z",
    transform: "translate(-100.653 -112.002)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M324.12,376.025l.179.323-.179,4.161h.516l-.083-4.2.083-.337Z",
    transform: "translate(-101.225 -117.42)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M447.341,112.09l40.072,26.916L468.728,280.7l-29.6-3.837Z",
    transform: "translate(-137.143 -35.009)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M441.5,236.26l7.867,80.8-12.846-.811Z",
    transform: "translate(-136.328 -73.788)",
    fill: "#114258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M480.93,124.14l11.347,7.922L482.814,284.71l-4.614.55Z",
    transform: "translate(-149.345 -38.772)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M467.153,120.654l.839,161.223-2.9-.729L459.41,114.74Z",
    transform: "translate(-143.477 -35.836)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M337.56,143.068l71.08-32.748-7.1,165.9-58.873,5.708Z",
    transform: "translate(-105.422 -34.456)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M376.164,121.044l-22.35,160.164-9.724,1.5,9.724-153.039Zm7.812-5.5L365.408,280.225h3.81l22.474-166.938Zm20.5-5.942L385.785,278.189l1.926.543,20.782-170.8Z",
    transform: "translate(-107.462 -33.709)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M404.523,205.808,400.5,289.073l-8.864.557ZM331.38,154.354l5.5,85.205,4.745-91.67Z",
    transform: "translate(-103.492 -46.189)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M341.953,280.915l-.089-.612,62.621-9.153.089.612Zm-.406-11.182-.1-.605,63.6-11.141.1.605Zm-.406-11.182-.124-.605,64.574-13.135.124.605Zm-.406-11.182-.138-.6,65.551-15.129.138.6Zm-.406-11.182-.151-.6L406.7,218.465l.151.6Zm-.406-11.182-.165-.591L407.235,205.3l.165.591Zm-.406-11.182-.179-.591,68.467-21.126.179.591Zm-.365-11.182-.193-.585,69.457-23.1.193.585Zm-.406-11.182-.206-.578,70.406-25.094.206.578Zm-.406-11.182-.22-.578L409.5,152.619l.22.578Zm-.406-11.182-.227-.571,72.345-29.076.227.571Zm-.406-11.182-.241-.564,73.322-31.07.241.564Z",
    transform: "translate(-105.338 -39.44)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M342.556,279.889l-.089-.612,62.635-9.153.089.612Zm-.406-11.182-.1-.605,63.6-11.141.1.605Zm-.406-11.182-.124-.605L406.2,243.785l.124.605Zm-.406-11.182-.138-.6,65.551-15.129.138.6Zm-.406-11.182-.151-.6L407.3,217.44l.151.6Zm-.406-11.182-.165-.591,67.49-19.111.165.591Zm-.406-11.182-.179-.591,68.474-21.119.179.591Zm-.406-11.182-.193-.585,69.457-23.1.193.585Zm-.378-11.216-.206-.578,70.406-25.094.206.578Zm-.406-11.182-.22-.578,71.376-27.081.22.578Zm-.406-11.182-.227-.571,72.345-29.076.227.571Zm-.406-11.182-.241-.564L411.2,125.22l.241.564Z",
    transform: "translate(-105.522 -39.109)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M468.444,278.976,435.6,271.363l.138-.6,32.844,7.613Zm1.52-11.615-33.821-9.174.158-.591,33.821,9.174Zm1.52-11.622-34.79-10.728.179-.585,34.763,10.728Zm1.527-11.615-35.76-12.268.2-.585,35.76,12.289Zm1.52-11.622-36.737-13.843.22-.578,36.737,13.843Zm1.527-11.65-37.706-15.37.234-.571,37.706,15.4Zm1.527-11.622L438.9,192.306l.248-.564L477.824,208.7Zm1.527-11.622-39.659-18.478.261-.557,39.652,18.513Zm1.527-11.622L440,165.953l.275-.55,40.629,20.074Zm1.527-11.615-41.6-21.6.282-.543,41.6,21.628Zm1.527-11.622L441.122,139.56l.3-.543,42.6,23.237Zm1.527-11.615-43.545-24.757.3-.536L485.52,150.6Z",
    transform: "translate(-136.041 -39.303)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M468.444,278.349,435.6,270.736l.138-.6,32.844,7.6Zm1.52-11.615-33.821-9.174.158-.591,33.821,9.174Zm1.52-11.622-34.79-10.728.179-.585,34.763,10.721Zm1.527-11.622L437.25,231.2l.2-.585L473.21,242.9Zm1.52-11.622-36.737-13.843.22-.578L474.75,231.29Zm1.527-11.615-37.706-15.411.234-.571,37.706,15.4Zm1.527-11.622L438.9,191.679l.248-.564,38.676,16.959Zm1.527-11.622L439.451,178.5l.261-.557,39.652,18.513Zm1.527-11.622L440,165.326l.275-.55,40.629,20.074Zm1.527-11.615-41.6-21.628.282-.543,41.6,21.607Zm1.527-11.622L441.122,138.96l.3-.543,42.6,23.2Zm1.527-11.636-43.545-24.757.3-.536,43.545,24.757Z",
    transform: "translate(-136.041 -39.109)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M335.41,122.988,411.854,82.84l-.681,16.03-75.351,35.169Z",
    transform: "translate(-104.751 -25.874)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M336.01,141.319l1.066.447,74.182-34.11.1-1.506Z",
    transform: "translate(-104.938 -33.154)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M341.07,373.291h63.6l.688-22.151L340.3,357.446Z",
    transform: "translate(-106.278 -109.666)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M433.91,373.291h32.934l2.139-17.687L434.6,351.14Z",
    transform: "translate(-135.513 -109.666)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M359.521,269.189l-3.074.3L353.38,105.662l3.046-1.623ZM335.452,271.5l3.067-.3-8.507-153.136L327,119.657Zm7.764-160.48-3.019,1.6,5.777,157.812,3.067-.3Zm52.952-28.2-3.15,1.726-5.206,181.888,3.088-.3Zm-26.531,14.16-3.046,1.657.33,169.86,3.074-.3ZM409.413,75.83l-3.15,1.678-8.018,187.94,3.095-.3Zm-26.5,14.1-3.1,1.65-2.441,175.864,3.081-.3Z",
    transform: "translate(-102.124 -23.684)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M446.261,82.84l45.67,36.991-1.389,9.848L445.58,98.87Z",
    transform: "translate(-139.158 -25.874)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M335.465,139.292l-4.085-2.042,8.534,153.115.825-.028-5.11-138.859-1.066-.447-.413-11.051Z",
    transform: "translate(-103.492 -42.866)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M354.321,129.344l-3.741-2.3L356.4,286.165l.715-.021-3.273-143.473-.915-.605-.371-11.794Z",
    transform: "translate(-109.488 -39.678)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M369.8,116.82l3.493,2.524-1.121.591.083,12.722,1.038.64.172,148.652-.578.021Z",
    transform: "translate(-115.491 -36.486)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M389.04,106.59l3.438,2.641-1.4.736.076,13.479.956.646-2.146,153.644-.6.028Z",
    transform: "translate(-121.5 -33.291)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M407.182,96.34l3.48,2.71-1.465.77-.069,14.325,1.142.77-5.055,158.617-.5.028Z",
    transform: "translate(-126.397 -30.09)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M425.188,86.09l2.964,3.067-.894.468-.33,15.226.915.963-7.3,163.492-.619.048Z",
    transform: "translate(-131.144 -26.889)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M445.533,106.15l44.961,30.809-1.114.193-43.951-29.5Z",
    transform: "translate(-139.111 -33.154)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M370.72,358.8l22.185-2.077v18.313H371.373Z",
    transform: "translate(-115.778 -111.408)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M372.66,382.669v-1.231l20.851-.268v1.5Z",
    transform: "translate(-116.384 -119.044)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M376.76,380.767v-1.252l18.031-.385v1.4Z",
    transform: "translate(-117.665 -118.407)",
    fill: "#a35100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M378.758,372.813l-.358-13.279,16.9-1.754v14.682Z",
    transform: "translate(-118.177 -111.739)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M353.479,361.8l7.18-.543.3,9.222-7.035.131Zm-3.438.392-5.9.481.523,8.321,5.777-.172Zm43.325-3.576-6.567.529-.062,10.934,6.471-.1Zm3.081-.248-.172,11.567,7.069-.11.385-12.048Z",
    transform: "translate(-107.477 -111.739)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M345,363.561l5.281-.433.4,7.991-5.165.151Zm9.366-.873,6.561-.5.282,8.589-6.43.124Zm33.271-2.655,5.955-.481-.158,10.735-5.852.089Zm9.628-.777,6.664-.536-.364,11.409-6.457.1Z",
    transform: "translate(-107.746 -112.033)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M457.859,370.406,454,370.275l.688-10.659,3.858.433Zm-14.043-.481,3.858.131.688-11.147-3.865-.433Zm9.662-10.446-3.858-.433-.688,11.051,3.858.131Zm-10.171-1.142-4.986-.557-.591,11.938,4.855.165Zm20.342,2.283-3.858-.433-.688,10.26,3.858.131Zm1.224.138-.688,9.868,2.985.1,1.114-9.586Z",
    transform: "translate(-136.706 -111.739)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M464.2,370.913l.653-9.229,2.751.309-1.045,9Zm-5.089-.172.688-9.628,3.246.364-.688,9.373Zm-5.089-.172.688-10.02,3.246.364-.688,9.765Zm-5.089-.172.688-10.419,3.246.364-.688,10.164Zm-5.089-.172.688-10.811,3.253.364-.688,10.556Zm-6.086-.206.557-11.3,4.367.488L442,370.163Z",
    transform: "translate(-136.715 -112.033)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M339.33,357.457l65.86-6.327-.083,1.788-65.716,6.141Z",
    transform: "translate(-105.975 -109.662)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M435.063,351.13l35.2,4.573-.172,1.368-35.114-4.154Z",
    transform: "translate(-135.847 -109.662)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M451.209,88.889l2.875-2.359L442.524,269.2h-.454l8.741-163.355,1.087-.736.873-14.95Z",
    transform: "translate(-138.061 -27.026)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M464.286,95.93l-2.93,2.049L462.622,99l-1.032,13.933-1.052.66L450.23,272.8l.364.041Z",
    transform: "translate(-140.61 -29.962)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M474.439,105.34l-3.218,1.547,1.485,1.2-.949,13.032-1.142.5L458.23,276.459l.385.041Z",
    transform: "translate(-143.108 -32.901)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M481.655,116.225l2.964-1.485-17.963,165.4h-.316l14.242-150.6,1.031-.468,1.128-11.973Z",
    transform: "translate(-145.641 -35.836)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M491.947,125.46l2.84-1.32L474.672,283.795h-.282l16.236-146.259s1.018-.371.99-.385,1.3-10.9,1.3-10.9Z",
    transform: "translate(-148.155 -38.772)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M501.845,134.438l3.019-.908L482.6,287.436l-.426-.041L500.855,145.7l1.114-.193,1.389-9.848Z",
    transform: "translate(-150.585 -41.704)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M448.863,266.961l-3.053-.392L459.5,89.653l2.9,2.448Zm5.907-181.3-2.923-2.476-11.56,182.672,3.06.392Zm-7.627-6.444-4.009-3.383-7.18,165.28L434.91,265.18l2.9.378Zm22.9,19.331-2.868-2.421L451.36,267.284l3.053.392Zm22.068,18.664-2.008-1.7L467.844,269.416l2.407.31Zm-6.877-5.79-2.813-2.366L462.342,268.707l3.053.392Zm-7.627-6.437-2.833-2.393-17.935,165.4,3.053.392Z",
    transform: "translate(-135.825 -23.684)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M348.391,366.146l2.214-.144.131,2.565-2.2.083Zm9.786-1.018,3.019-.213-.076-2.283-3.033.227Zm-9.807.688,2.214-.158-.1-2.063-2.228.179Zm-.433,3.17-2.063.069.158,2.338,2.063-.062Zm-.158-2.806-2.111.138.158,2.421,2.063-.076Zm-.138-2.379-2.132.172.138,2.063,2.111-.151Zm.915,5.158.138,2.352,2.18-.062-.117-2.359Zm51.893-9.5-2.641.213-.041,2.675,2.634-.186ZM358.3,368.264l3.005-.11-.1-2.868-3.019.2Zm42.094-5.577-2.634.172-.055,3.913,2.62-.1Zm-9.937.688-2.318.151v3.638l2.338-.089Zm0-3.088-2.3.186v2.565l2.311-.165Zm.612,6.767,2.627-.1.055-3.8-2.682.179Zm0-4.216,2.689-.186.041-2.627-2.751.22Zm9.243,4.374-2.62.089-.048,3.067,2.613-.041Zm.564,3.108,2.923-.048.1-3.191-2.971.1Zm-43.407-7.386-2.6.2.11,2.249,2.579-.179Zm43.586-3.5-.048,2.71,3.053-.213.089-2.751Zm-.124,7.248,2.978-.11.131-4.126-3.04.2Zm-9.868,3.789,2.579-.041.041-2.991-2.62.089Zm-33.5-4.917-2.572.172.138,2.689,2.544-.1Zm.124,3.115-2.544.089.117,2.29,2.517-.048Zm.612,0,.089,2.338,2.991-.055-.076-2.386Zm32.143-1.1-2.338.083v2.888l2.359-.034Z",
    transform: "translate(-107.905 -112.176)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M346.309,369.512l1.781-.062.117,2.063-1.76.055Zm2.7-.089,1.884-.062.1,2.063-1.871.055Zm6.6-.227,2.235-.076.076,2.015-2.214.041Zm3.157-.11,2.7-.089.069,2.063-2.682.048Zm29.8-1.025,2.063-.069v2.62h-2.063Zm2.957-.1,2.311-.083-.041,2.682-2.269.034Zm6.622-.227,2.311-.083-.048,2.806-2.3.034Zm3.239-.11,2.661-.089-.089,2.875-2.62.041Zm-55.263-.86,1.8-.117.138,2.18-1.788.069Zm2.751-.179,1.9-.124.11,2.249-1.891.069Zm6.609-.44,2.263-.151.1,2.448-2.242.083Zm3.184-.213,2.71-.179.083,2.551-2.7.1Zm29.942-1.987,2.008-.131v3.39l-2.063.076Zm2.93-.193,2.373-.158-.048,3.487-2.324.089Zm6.684-.44,2.324-.151-.062,3.672-2.318.089Zm3.246-.213,2.751-.179L404.1,366.7l-2.675.1ZM346,364.416l1.822-.151.1,1.747-1.809.131Zm2.751-.227,1.919-.158.089,1.781-1.912.131Zm6.616-.646,2.29-.172.076,1.953-2.269.158Zm3.212-.241,2.751-.206.069,1.974-2.716.193Zm30.059-2.407,1.994-.158v2.283l-2,.138Zm2.916-.234,2.421-.193v2.318l-2.386.165Zm6.733-.543,2.331-.186-.041,2.386-2.324.165Zm3.253-.261,2.751-.227-.076,2.434-2.751.193Z",
    transform: "translate(-108.058 -112.317)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M386.435,372.945l-6.781.144-.344-12.695,6.973-.722Zm.461-13.334.158,13.321,8.541-.179V358.71Z",
    transform: "translate(-118.461 -112.03)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M379.76,360.84l6.664-.688.151,12.949-6.478.138Zm7.565-.784,8.39-.867v13.754l-8.252.179Z",
    transform: "translate(-118.602 -112.18)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M388.338,368.437l-.089-7.565,7.152-.743v8Zm-2.152.082-.089-7.406-5.426.564.193,7.056Zm-5.3.825.1,3.548,5.261-.11-.041-3.652Zm7.461-.3.041,3.686,7.008-.151v-3.81Z",
    transform: "translate(-118.886 -112.473)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M381.336,369.846l5-.2.041,3.335-4.951.1Zm7.461-.3,6.746-.268v3.507l-6.705.144Zm-7.668-7.379,5.116-.53.083,7.083-5.013.2Zm7.565-.784,6.843-.688v7.682l-6.753.268Z",
    transform: "translate(-119.029 -112.651)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M451.143,363.4l1.19.089-.261,3.913-1.21-.062Zm4.683.358-1.375-.1-.254,3.858,1.307.069Zm.034-.461.165-2.152-1.375-.151-.144,2.2Zm.461.034,1.135.089.144-2.063-1.114-.124Zm-5.639,0-1.293-.1-.254,3.989,1.272.062Zm.5-.426,1.19.089.151-2.276-1.176-.131Zm-3.934.158-1.245-.1-.261,4.078,1.245.062Zm3.438-.2.165-2.331-1.238-.117-.151,2.379Zm5.281,4.7,1.169.062.261-3.782-1.142-.089Zm9.676-3.555.165-1.8-1-.11-.131,1.843Zm-.041.461-.963-.076-.254,3.59.9.048Zm.144,3.59.853.041.413-3.521-.894-.034Zm.358-4.009.956.076.206-1.747-1-.11Zm-5.123-.392.165-1.967-1.43-.158-.138,2.022Zm-.041.461-1.375-.11-.254,3.727,1.375.069Zm.158,3.707,1.135.055.254-3.652-1.087-.083Zm.344-4.126,1.08.083.138-1.919-1.052-.117Zm-15.4-1.148,1.245.1.158-2.455-1.245-.138Zm-.316,5-.186,2.861,1.238.041.186-2.84Zm5.123.261-.193,2.751,1.224.041.186-2.751Zm5.123.261-.206,2.689,1.2.041.186-2.675Zm-5.584-.282-1.272-.062-.186,2.8,1.258.041Zm5.123.261-1.307-.069-.179,2.751,1.279.041Zm9.765.5-.887-.048-.179,2.558h.846Zm-4.642-.234-1.341-.069-.179,2.641,1.307.041Zm5.1.254L465.5,371.1h.777l.3-2.517Zm-20.156-6.086.158-2.517-1.238-.138-.158,2.558Zm15.521,5.811-.22,2.606,1.169.041.186-2.593Zm-15.549-5.35-1.238-.1-.261,4.126,1.238.062Zm-5.144-.86,1.788.138.165-2.634-1.795-.2Zm-.461-.034.158-2.716-1.809-.2-.138,2.751Zm2.214.633-1.781-.138-.241,4.229,1.76.089Zm-2.51,4.525-1.754-.089-.151,2.991,1.726.062Zm.461,0-.172,2.957,1.747.062.186-2.923Zm5.151.261-1.238-.062-.179,2.888,1.238.041Zm-7.338-.777,1.754.089.241-4.236-1.788-.138Z",
    transform: "translate(-136.709 -112.161)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M465.58,371.2l.2-2.221h.53l-.254,2.214Zm-1.307-.048.158-2.249h.578l-.2,2.235Zm-3.322-.11.193-2.3.86.062-.158,2.283Zm-1.767-.062.158-2.331,1.032.055-.193,2.311Zm-3.37-.11.179-2.386.866.041-.165,2.373Zm-1.74-.062.158-2.414,1,.048-.172,2.428Zm-3.377-.117.172-2.469.9.048-.165,2.455Zm-1.719-.062.158-2.5.963.048-.172,2.483Zm-3.4-.117.165-2.551.935.048-.165,2.538Zm-1.7-.055.165-2.579.928.048-.165,2.565Zm-3.9-.131.151-2.648,1.451.076-.165,2.62Zm-2.194-.076.131-2.682,1.444.076-.151,2.655Zm28.037-2.063.289-3.239.633.048-.378,3.218Zm-1.375-.069.234-3.28.688.048-.3,3.26Zm-3.28-.165.282-3.363.777.062L462,368Zm-1.809-.089.234-3.438,1.087.083-.282,3.383Zm-3.322-.165.268-3.5.832.062-.241,3.48Zm-1.774-.089.234-3.548,1.038.083-.268,3.521Zm-3.356-.172.254-3.631.887.069-.241,3.61Zm-1.733-.089.241-3.679.983.076-.227,3.686Zm-3.39-.172.241-3.769.935.069-.241,3.741Zm-1.7-.083.241-3.81.935.069-.241,3.789Zm-3.913-.2.227-3.913,1.479.117-.241,3.879Zm-2.214-.11.2-3.975,1.479.11-.227,3.934Zm28.2-2.6.131-1.472.688.076-.172,1.444Zm-1.437-.11.11-1.527.688.076-.138,1.5Zm-3.225-.248.138-1.637.75.083-.117,1.616Zm-1.871-.144.117-1.706,1.121.124-.138,1.664Zm-3.28-.254.138-1.822.811.089-.124,1.795Zm-1.809-.138.124-1.884,1.059.117-.144,1.85Zm-3.335-.254.138-2,.873.1-.131,1.974Zm-1.754-.138.131-2.063,1,.11-.144,2.063Zm-3.39-.261.138-2.187.935.1-.138,2.152Zm-1.7-.131.144-2.249.935.1-.138,2.214Zm-3.934-.3.138-2.386,1.485.165-.144,2.331Zm-2.249-.172.124-2.469,1.5.165-.138,2.414Z",
    transform: "translate(-136.725 -112.295)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M340.41,361.686l.062,1.272,20.885-.75-.1-2.469Z",
    transform: "translate(-106.312 -112.351)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M370.823,361.266l5.371,5.041,16.711-.681V356.72L370.72,358.8Z",
    transform: "translate(-115.778 -111.408)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M424.986,353.73l-22.006,2.056.083,3.088h21.662Z",
    transform: "translate(-125.853 -110.474)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M469,357.767l-34.137-4.037-.261,5.144,34.1,1.65Z",
    transform: "translate(-135.728 -110.474)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M463.556,366.241l-.206-.021.138.88Z",
    transform: "translate(-144.707 -114.375)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M471.7,373.274l.22,1.946.481.021.158-2.29-.832-.041Z",
    transform: "translate(-147.315 -116.464)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M463.559,362.4l-.839-.089.309,1.912.385.027Z",
    transform: "translate(-144.511 -113.154)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M464.638,366.33l-.268,3.5.867.041.234-3.48Z",
    transform: "translate(-145.026 -114.409)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M465.175,372.581l-.825-.041.385,2.4.275.007Z",
    transform: "translate(-145.02 -116.349)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M471.139,363.249l-.619-.069.2,1.712.282.021Z",
    transform: "translate(-146.946 -113.426)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M471.83,370.27l.825.041.241-3.349-.784-.062Z",
    transform: "translate(-147.356 -114.587)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M478,364.018l-.419-.048.124,1.534.165.014Z",
    transform: "translate(-149.151 -113.672)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M477.884,367.337l-.034-.007.014.186Z",
    transform: "translate(-149.236 -114.722)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M479.77,365.69l.165-1.444-.688-.076-.138,1.472Z",
    transform: "translate(-149.629 -113.735)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M472.33,365.047l.77.062.117-1.616-.75-.083Z",
    transform: "translate(-147.512 -113.498)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M471.071,366.814l-.131-.014.076.66Z",
    transform: "translate(-147.078 -114.556)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M478.879,367.42l-.289,3.246.55.027.378-3.225Z",
    transform: "translate(-149.467 -114.75)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M478.74,375.492l.254-2.214-.53-.028-.055.612.131,1.623Z",
    transform: "translate(-149.411 -116.571)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M464.85,364.385l.825.069.124-1.795-.812-.089Z",
    transform: "translate(-145.176 -113.235)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M450.636,365.256l-.935-.076-.241,3.769.935.048Z",
    transform: "translate(-140.369 -114.05)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M440.292,359.794l-1.052-.124.509,2.5.406.027Z",
    transform: "translate(-137.178 -112.329)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M449.88,363.077l.935.069.138-2.152-.935-.1Z",
    transform: "translate(-140.5 -112.711)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M440.409,364.464l-.2-.014.158.777Z",
    transform: "translate(-137.48 -113.822)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M442.806,371.445l-1.176-.055.543,2.661.468.014Z",
    transform: "translate(-137.924 -115.99)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M441.68,362.356l1.479.117.151-2.338-1.492-.165Z",
    transform: "translate(-137.94 -112.423)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M441.523,364.56l-.213,3.645.062.268,1.382.076.241-3.879Z",
    transform: "translate(-137.824 -113.857)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M456.25,361.578l-.44-.048.151,2.07.151.014Z",
    transform: "translate(-142.352 -112.91)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M456.7,373.432l.089,1.2.743.028.165-2.455-.908-.041Z",
    transform: "translate(-142.63 -116.23)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M456.151,365.67h-.041l.021.289Z",
    transform: "translate(-142.446 -114.203)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M458.052,365.829l-.887-.069-.254,3.631.9.048Z",
    transform: "translate(-142.696 -114.231)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M448.38,360.7l.206,2.256h.055l.144-2.214Z",
    transform: "translate(-140.032 -112.651)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M449.38,371.794l.234,2.551.543.021.165-2.538-.935-.048Z",
    transform: "translate(-140.344 -116.112)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M457.36,363.731l.88.069.131-1.974-.866-.1Z",
    transform: "translate(-142.837 -112.973)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M410.054,374.4v-2.62l-1.479.048-.275,2.6Z",
    transform: "translate(-127.515 -116.112)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M412.19,361.058v2.29l1.4-.1.488-2.345Z",
    transform: "translate(-128.73 -112.714)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M410.216,365.72l-1.045.069-.351,3.377,1.4-.055Z",
    transform: "translate(-127.677 -114.219)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M412.19,373.46l.358-1.74-.358.007Z",
    transform: "translate(-128.73 -116.093)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M412.19,365.593v3.418l.523-.021.715-3.48Z",
    transform: "translate(-128.73 -114.153)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M409.45,363.585l.963-.069V361.24l-.722.055Z",
    transform: "translate(-127.874 -112.82)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M424.628,364.76l-1.073.076-.385,3.652,1.4-.048Z",
    transform: "translate(-132.159 -113.919)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M424.335,374.1l.048-2.806-1.465.048-.289,2.785Z",
    transform: "translate(-131.99 -115.959)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M426.7,359.884l-.041,2.4,1.389-.1.5-2.448Z",
    transform: "translate(-133.249 -112.351)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M423.86,362.522l1-.069.041-2.393-.791.062Z",
    transform: "translate(-132.374 -112.451)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M426.6,364.643l-.062,3.7.516-.021.777-3.762Z",
    transform: "translate(-133.211 -113.857)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M426.48,373.132l.392-1.912-.365.014Z",
    transform: "translate(-133.193 -115.937)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M348.119,369.83l-1.245.083-.254,2.152,1.623-.062Z",
    transform: "translate(-108.252 -115.503)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M347.1,368.2l1.135-.076-.1-1.747-.825.069Z",
    transform: "translate(-108.402 -114.425)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M348.354,375.942l-.117-2.042-1.74.062-.027.241.117,1.788Z",
    transform: "translate(-108.205 -116.774)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M350.14,369.731l.117,2.029.481-2.07Z",
    transform: "translate(-109.351 -115.459)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M351.254,366.11l-1.314.11.1,1.754.791-.055Z",
    transform: "translate(-109.289 -114.341)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M362.587,371.338l-.089-2.448-.928.062-.289,2.434Z",
    transform: "translate(-112.83 -115.209)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M362.546,375.435l-.076-2.015-1.417.048-.234,2Z",
    transform: "translate(-112.686 -116.624)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M362.051,365.111l-.241,1.974.825-.055-.076-1.96Z",
    transform: "translate(-112.996 -114.016)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M364.56,373.367l.041.977.227-.983Z",
    transform: "translate(-113.854 -116.605)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M364.24,364.914l.076,1.953,1.327-.089.468-2.008Z",
    transform: "translate(-113.755 -113.922)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M364.93,371.228l.591-2.538-1.142.076.1,2.476Z",
    transform: "translate(-113.798 -115.146)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M394.773,361.191l-.743,7.406,2.847-.11,1.506-7.668Z",
    transform: "translate(-123.058 -112.689)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M395.814,376.793l.681-3.473-2.751.11-.344,3.411Z",
    transform: "translate(-122.861 -116.592)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M382.982,362.411l-.722,6.891,2.868-.117,1.465-7.124v-.021Z",
    transform: "translate(-119.382 -113.07)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M384.745,373.79l-2.778.11-.337,3.26,2.428-.048Z",
    transform: "translate(-119.186 -116.739)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M250.96,385.619H128.11l1.169-1.479H250.045Z",
    transform: "translate(-40.01 -119.972)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M248.25,385.619l.791-1.479h38.525l.915,1.479Z",
    transform: "translate(-77.53 -119.972)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M151.66,369.067l1.506,9.752h91.25l1.767-10.419-33.656-1.3Z",
    transform: "translate(-47.364 -114.65)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M273.492,368.4l-33.656-1.3-.736,11.718h32.624Z",
    transform: "translate(-74.672 -114.65)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M273.942,367.713l-1.974,10.934-3.342-10.934Zm-11.505-.158,3.322,10.921,1.981-10.921Zm-6.334,0,3.322,10.921,1.981-10.921Zm-6.279-.406,3.322,11.326,1.981-11.326Zm-6.244-.289,3.322,11.615,1.981-11.615Z",
    transform: "translate(-76.072 -114.575)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M244.277,237.84l29.433,20.782L263,324.861l-22.653-1.135Z",
    transform: "translate(-75.063 -74.281)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M162.779,367.788s-3.308,11.134-3.48,11.134h-2.6l1.265-11.134Zm7.957,0-1.265,11.134h2.565c.172,0,3.48-11.134,3.48-11.134Zm11.519,0-1.279,11.1h2.6c.172,0,3.48-11.134,3.48-11.134Zm12.028.055-1.265,11.079h2.6c.172,0,3.48-11.237,3.48-11.237Zm11.264-.351-1.465,11.429h2.6c.172,0,3.672-11.6,3.672-11.6Z",
    transform: "translate(-48.938 -114.719)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M148.126,326.442l-7.276-58.007,72.352-30.6-3.927,85.886Z",
    transform: "translate(-43.988 -74.281)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M204.131,250.88l-5.4,2.283c-4.126,16.959-16.959,68.15-19.042,76.492l4.436-.2Z",
    transform: "translate(-56.118 -78.354)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M153.1,332.709l12.461-.557,18.6-74.092-26.2,11.072Z",
    transform: "translate(-47.814 -80.596)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M232.645,238.76l-5.048,2.132L207.84,325l2.441-.11Z",
    transform: "translate(-64.91 -74.569)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M238.13,281.4,225.6,338.465h10.143Z",
    transform: "translate(-70.456 -87.885)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M150.637,275.14l-9.717,4.3,4.656,36.764Z",
    transform: "translate(-44.01 -85.93)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M212.94,263.545l-.117-.323-13,4.539.3-11.512,13.4-5.364-.131-.316-13.266,5.309.248-9.628h-.344l-.248,9.745-4.649,1.857v-9.366h-.344v9.525l-8.7,3.48-.041-9.153h-.344l.041,9.284-4.4,1.76-.275-8.94h-.344l.275,9.078-9.972,3.989-.33-8.555h-.344l.337,8.679-4.126,1.657-.557-8.362h-.344l.564,8.534-10.205,4.085-.688-8.252h-.344l.688,8.335-3.892,1.589-.873-8.046-.344.034.887,8.142-8.94,3.569.131.316,8.837-3.535.935,8.61-8.837,3.088.117.323,8.775-3.053.942,8.624-8.741,2.586.1.33,8.679-2.565.942,8.637-8.644,2.063.083.337,8.6-2.063.942,8.658-8.555,1.547.062.337,8.534-1.547.942,8.672-8.465,1.011.041.344,8.459-1.011.9,8.252.344-.034-.9-8.252,2.654-.316.646,8.328h.344l-.688-8.314,9.8-1.169.612,9.194h.344l-.612-9.215,2.806-.337.358,9.318h.344l-.358-9.346,9.628-1.148.309,10.137h.344l-.309-10.171,2.964-.351.041,10.315h.344l-.041-10.37,8.479-1.011V327.02h.344v-11l3.122-.371-.289,11.23h.344l.289-11.278,12.035-1.437-.041-.344-11.938,1.424.3-11.519,12.268-2.221-.062-.337-12.2,2.207.3-11.519,12.557-3.012-.083-.337-12.447,3.012.3-11.512,12.839-3.8-.1-.33-12.729,3.769.3-11.512Zm-13.162-7.152-.3,11.491-4.339,1.513V258.243Zm-4.979,1.994v11.134l-8.658,3.026-.048-10.652ZM171.836,288.2l9.841-2.923.316,10.37L172.215,298Zm.034,9.889-3.356.8-.633-9.525,3.61-1.066Zm10.178-12.908,3.824-1.128.041,10.666-3.576.873Zm0-.358-.316-10.364,4.126-1.437.041,10.666Zm-.344.1-9.848,2.916-.378-9.8,9.9-3.438Zm-10.185,3.012-3.617,1.073-.633-9.5,3.872-1.375Zm-3.954,1.169-10.04,2.971-.688-8.94,10.082-3.514Zm0,.351.633,9.5-9.958,2.386-.688-8.94Zm.688,9.855.633,9.525L159,310.625l-.688-8.94Zm.337-.083,3.342-.8.378,9.786-3.088.557Zm3.686-.887L182.056,296l.316,10.391-9.717,1.76Zm10.123-2.428,3.535-.846.041,10.673-3.26.591Zm3.879-.928,8.569-2.063v11.2l-8.527,1.54Zm0-.351-.1-10.694,8.61-2.544V292.58Zm-.1-11.051L186.14,272.9l8.658-3.019V281.04ZM185.742,262l.041,10.659-4.126,1.437-.316-10.315Zm-4.731,1.891.316,10.315-9.91,3.438-.371-9.765Zm-10.315,4.126.378,9.779-3.885,1.375-.633-9.483Zm-4.463,1.788.633,9.463L156.742,282.8l-.688-8.94Zm-14.442,5.77,3.885-1.554.688,8.906-3.652,1.272Zm.977,8.974,3.645-1.272.688,8.906-3.438,1.011Zm1.011,8.981,3.4-1,.688,8.906-3.163.756Zm.983,9,3.15-.756.688,8.906-2.916.53Zm1.932,17.715-.949-8.692,2.9-.523.688,8.906Zm3.005-.358-.688-8.94,9.875-1.788.633,9.545Zm10.143-1.21-.64-9.566,3.074-.557.378,9.786Zm3.163-.378-.378-9.807,9.717-1.76.323,10.419Zm10-1.19-.323-10.439,3.253-.591.041,10.673Zm3.315-.4-.041-10.694,8.521-1.54V315.7Zm11.952-1.424-3.129.371V304.422l3.438-.619Zm.3-11.842-3.438.619V292.841l3.727-.894Zm.3-11.849-3.762.9v-11.2l4.03-1.19Zm.3-11.856-4.064,1.2V269.762l4.332-1.513Z",
    transform: "translate(-44.51 -76.908)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M148.21,326.344l-7.29-58.138,72.724-30.747-.014.275L209.7,323.614l-.344-.014,3.913-85.611-71.981,30.43,7.262,57.883Z",
    transform: "translate(-44.01 -74.163)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M137.35,253.507l75.474-36.627-.6,12.213L138.045,261.25Z",
    transform: "translate(-42.895 -67.735)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M138.36,266.8l74.182-32.157-.117,2.2-72.352,30.6Z",
    transform: "translate(-43.211 -73.282)",
    fill: "#e5aa87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M261.5,247.548l-4.443,79.236h-2.29V242.39Zm3.982,2.4-5.268,76.829h5.268l9.8-69.78Z",
    transform: "translate(-79.566 -75.702)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M246.06,236.841l.117-2.2,30.692,22.584-1.375.4Z",
    transform: "translate(-76.846 -73.282)",
    fill: "#921941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M284,267.879l1.375-.4-10.79,66.679-1.293-.041Z",
    transform: "translate(-85.35 -83.538)",
    fill: "#921941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M264.657,324.826l-.337-.062,10.687-66.129L245.67,237.922l.2-.282,29.516,20.837Z",
    transform: "translate(-76.724 -74.219)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M272.348,269.241l.186-.289-3.542-2.269,1.142-8.039-.344-.048-1.121,7.888-1.128-.688,1.107-8.163-.344-.048-1.08,8-4.986-3.2.928-8.637-.344-.034-.915,8.465-1.534-.983.9-8.775-.344-.034-.887,8.6-5.818-3.727.722-9.3h-.344l-.688,9.119-1.946-1.32.688-9.463h-.344l-.688,9.277-7.73-4.958-.179.289,7.888,5.055-.866,11.45-7.427-4.195-.172.3,7.565,4.277-.86,11.519-7.125-3.438-.151.309,7.241,3.5-.866,11.533-6.822-2.7-.124.316,6.918,2.751-.853,11.581-6.519-1.953-.1.33,6.595,1.974-.887,11.539-6.189-1.21-.069.337,6.265,1.224-.853,11.141h.344l.832-11.134,1.843.358-.853,10.927h.344l.846-10.886,4.642.908-1.045,10.185.344.034,1.045-10.15,1.375.261-1.073,9.951.344.034,1.066-9.923,3.8.743-1.32,9.38.344.048,1.258-9.3.853.165-1.258,9.084.344.048,1.286-9.071,2.751.53.069-.337-2.751-.536,1.375-9.889,2.854.853.1-.33-2.9-.867,1.375-9.889,2.991,1.183.124-.316-3.067-1.21,1.375-9.889,3.129,1.513.151-.309-3.225-1.561,1.375-9.882,3.267,1.85.172-.3-3.383-1.912,1.375-9.875Zm-5.171-3.315-1.375,10.04-4.752-2.689,1.135-10.542Zm-9.078,17.4,1.1-10.707,1.5.846-1.162,10.57Zm1.437,1.073L258.4,294.961l-1.424-.564,1.1-10.707Zm-1.754-1.231-5.35-2.586.88-11.3,5.577,3.15Zm-.034.364-1.107,10.735-5.116-2.022.88-11.3Zm-1.142,11.092L255.5,305.366l-4.883-1.458.88-11.3Zm.33.131,1.424.564-1.135,10.563-1.375-.413Zm1.754.688,4.277,1.685-1.375,10.054-4.051-1.21Zm.041-.358,1.135-10.535,4.484,2.187-1.375,10.054Zm1.176-10.9,1.135-10.542,4.745,2.682-1.375,10.047Zm1.987-21.662-1.135,10.563-1.52-.86,1.1-10.7Zm-1.857-1.19-1.1,10.728-5.591-3.15.88-11.292Zm-8.087-5.185L253.9,257.4l-.88,11.319-1.926-1.087ZM251.064,268l1.926,1.087-.88,11.319-1.9-.922Zm-.887,11.856,1.9.922-.88,11.326-1.884-.743Zm-.887,11.863,1.884.743-.88,11.333-1.864-.557ZM247.536,315.1l.86-11.526,1.864.557-.88,11.326Zm2.18.426.88-11.271,4.876,1.458-1.107,10.742Zm4.993.97,1.1-10.707,1.375.413-1.135,10.556Zm1.685.33,1.135-10.522,4.037,1.21-1.375,10.061Zm5.006.977-.86-.165,1.375-10.027.908.275Zm1.458-10.267-.915-.275,1.375-10.027.963.378Zm1.458-10.267-.963-.378,1.375-10.027,1,.488Zm1.41-10.247-1.018-.5,1.375-10.02,1.073.605Zm1.458-10.274-1.073-.605,1.375-10.013,1.121.688Z",
    transform: "translate(-75.235 -76.923)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M155.057,371.861l-.007-.254,3.005-.041-.323-2.544.254-.034.33,2.572,3.026-.041-.3-2.613.254-.028.3,2.634,8.094-.11-.206-2.771.261-.021.206,2.785,2.971-.041-.186-2.833.261-.021.186,2.854,8.149-.117-.089-2.991.261-.007.083,2.991,2.923-.041-.076-3.053.261-.007.076,3.06,8.2-.117.028-3.218.261.007-.034,3.212,2.868-.041.041-3.28.254.007-.034,3.267,8.252-.117.151-3.438.261.007-.151,3.432,2.813-.041.151-3.493.254.007-.151,3.48,3.218-.041.007.254Z",
    transform: "translate(-48.423 -114.734)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M154.847,371.861l-.007-.254,3.005-.041-.323-2.544.261-.034.323,2.572,3.033-.041-.3-2.613.254-.028.3,2.634,8.094-.11-.206-2.771.261-.021.206,2.785,2.971-.041-.186-2.833.261-.021.186,2.854,8.149-.117-.089-2.991.261-.007.089,2.991,2.916-.041-.069-3.053.254-.007.076,3.06,8.2-.117.027-3.218.261.007-.034,3.212,2.868-.041.041-3.28.254.007-.034,3.267,8.252-.117.158-3.438.254.007-.151,3.432,2.813-.041.151-3.493.261.007-.158,3.48,3.218-.041.007.254Z",
    transform: "translate(-48.358 -114.734)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M212.63,263.545l-.11-.323-13,4.539.3-11.512,13.4-5.364-.131-.316-13.266,5.309.248-9.628h-.344l-.248,9.745-4.649,1.857v-9.366h-.344v9.525l-8.7,3.48-.034-9.078h-.371l.034,9.215-4.4,1.76-.268-8.878h-.344l.268,9L170.7,267.5l-.33-8.555h-.344l.337,8.679-4.126,1.657-.557-8.362h-.344l.564,8.479L155.7,273.483l-.688-8.252h-.344l.688,8.335-3.892,1.554-.873-8.046-.344.034.887,8.142-8.94,3.569.131.316,8.837-3.535.935,8.61-8.837,3.088.11.323,8.761-3.06.935,8.727-8.741,2.586.1.33,8.679-2.565.942,8.637-8.644,2.063.083.337,8.6-2.063.942,8.658-8.555,1.547.062.337,8.534-1.547.942,8.672-8.445,1.025.041.344,8.459-1.011.9,8.252.344-.034-.9-8.252,2.654-.316.688,8.3h.344l-.688-8.314,9.8-1.169.612,9.194h.344l-.612-9.215,2.806-.337.358,9.318h.344l-.358-9.346,9.628-1.148.309,10.068h.344l-.309-10.171,2.964-.351.041,10.315h.344l-.041-10.37,8.479-1.011V327.02h.344v-11l3.122-.371-.289,11.23h.344l.289-11.278,12.014-1.437-.041-.344L198.3,315.239l.3-11.519,12.268-2.221-.062-.337-12.2,2.207.3-11.519,12.557-3.012-.083-.337L198.9,291.493l.3-11.512,12.839-3.8-.1-.33-12.729,3.769.3-11.512Zm-13.162-7.152-.33,11.484-4.339,1.513V258.243Zm-4.979,1.994v11.134l-8.658,3.026-.048-10.652ZM171.527,288.2l9.841-2.923.316,10.37L171.905,298Zm.034,9.889-3.37.791-.633-9.525,3.61-1.066Zm10.143-12.9,3.824-1.128.041,10.666-3.542.866Zm0-.358-.316-10.364,4.126-1.437.041,10.666Zm-.344.1-9.848,2.916-.378-9.8,9.9-3.438Zm-10.185,3.012-3.617,1.073-.633-9.5,3.872-1.375Zm-3.954,1.169-10.033,2.964-.688-8.94,10.116-3.535Zm0,.351.633,9.5-9.978,2.386-.688-8.94Zm.688,9.855.633,9.525-9.882,1.788-.688-8.94Zm.337-.083,3.342-.8.378,9.786-3.088.557Zm3.686-.887L181.712,296l.316,10.391-9.71,1.76Zm10.123-2.428,3.535-.846.041,10.673-3.26.591Zm3.879-.928,8.569-2.063v11.2l-8.527,1.54Zm0-.351-.041-10.687,8.61-2.544v11.182Zm-.041-11.044-.062-10.7,8.658-3.019V281.04Zm-.433-21.587.041,10.659-4.126,1.437-.316-10.315Zm-4.731,1.891.316,10.315-9.91,3.438-.378-9.8Zm-10.315,4.126.378,9.779-3.885,1.375-.633-9.483Zm-4.477,1.788.633,9.463L156.432,282.8l-.688-8.94Zm-14.442,5.77,3.885-1.554.688,8.906-3.652,1.272Zm.977,8.974,3.645-1.272.688,8.906-3.438,1.011Zm1,8.968,3.4-1,.688,8.906-3.163.756Zm.97,9.009,3.15-.756.688,8.906-2.916.53Zm1.932,17.715-.949-8.692,2.9-.523.688,8.906Zm3.005-.358-.688-8.94,9.875-1.788.633,9.545Zm10.143-1.21-.64-9.566,3.074-.557.378,9.786Zm3.163-.378-.364-9.807,9.717-1.76.323,10.419Zm10-1.19-.323-10.439,3.253-.591.041,10.673Zm3.322-.4-.041-10.694,8.521-1.54v11.223Zm11.952-1.424-3.129.371V304.422l3.438-.619Zm.3-11.842-3.438.619v-11.23l3.727-.894Zm.3-11.849-3.734.894v-11.2l4.03-1.19Zm.3-11.856-4.037,1.2V269.762l4.332-1.513Z",
    transform: "translate(-44.407 -76.908)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M272.379,371.63l-30.7-.591.007-.254,1.685.034.344-3.548.254.028-.344,3.521,1.451.028.3-3.514.261.021-.3,3.5,4.408.083.378-3.418.254.028-.378,3.4,1.451.028.344-3.4.261.028-.351,3.377,4.415.083.413-3.3.254.034-.406,3.273,1.437.027.4-3.273.261.027-.4,3.253,4.415.083.447-3.177.254.034-.44,3.15,1.437.027.447-3.156.261.034-.447,3.122,4.415.089.481-3.06.254.041-.475,3.026,1.437.027.5-3.04.254.041-.5,3,1.554.034Z",
    transform: "translate(-75.478 -114.703)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M201.221,367.66l-.323,11.333h-2.063l.11-11.264Zm-13.891.454.3,10.886h1.953l-.069-10.955Zm-11.691.378L176.327,379h1.836l-.468-10.577Zm-11.691.378,1.1,10.13h1.726l-.949-10.2ZM153.736,379h1.609l-1.265-9.813-1.85.062Z",
    transform: "translate(-47.542 -114.825)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M272.6,371.63l-30.7-.591.007-.254,1.685.034.344-3.548.254.028-.344,3.521,1.451.028.3-3.514.261.021-.3,3.5,4.415.083.378-3.418.254.028-.378,3.4,1.451.028.344-3.4.261.028-.351,3.377,4.415.083.413-3.3.254.034-.413,3.273,1.444.027.4-3.273.254.027L258.3,371.1l4.415.083.44-3.177.261.034-.44,3.15,1.437.027.447-3.156.261.034-.447,3.122,4.415.089.475-3.06.254.041-.468,3.026,1.437.027.5-3.04.254.041-.488,3,1.554.034Z",
    transform: "translate(-75.547 -114.703)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M264.907,324.826l-.337-.062,10.687-66.129L245.92,237.922l.2-.282,29.516,20.837Z",
    transform: "translate(-76.802 -74.219)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M272.592,269.254l.186-.289-3.542-2.269,1.142-8.039-.344-.048-1.121,7.888-1.128-.688,1.107-8.163-.344-.048-1.08,8-4.986-3.2.928-8.637-.364-.1-.915,8.466-1.534-.983.9-8.775-.344-.034-.86,8.624-5.818-3.727.722-9.3h-.344l-.688,9.119-1.953-1.252.688-9.463h-.344l-.688,9.277-7.73-4.958-.186.289L251.844,256l-.86,11.423-7.427-4.195-.172.3,7.565,4.277-.86,11.519-7.125-3.438-.151.309,7.241,3.5-.866,11.533-6.822-2.7-.124.316,6.918,2.751-.853,11.581-6.519-1.953-.1.33,6.595,1.974-.866,11.56-6.224-1.21-.069.337,6.265,1.224-.853,11.12h.344l.832-11.134,1.843.358-.853,10.927h.344l.846-10.886,4.642.908-1.045,10.185.344.034,1.045-10.15,1.375.261-1.073,9.951.344.034,1.066-9.923,3.8.743-1.279,9.38.344.048,1.258-9.3.853.165-1.279,9.084.344.048,1.286-9.071,2.751.53.069-.337-2.751-.536L263.37,308l2.854.853.1-.33-2.9-.867,1.375-9.889,2.991,1.183.124-.316-3.067-1.21,1.375-9.889,3.129,1.513.151-.309-3.225-1.561,1.375-9.882,3.267,1.85.172-.3-3.383-1.912,1.375-9.875Zm-5.171-3.315-1.375,10.04-4.752-2.689,1.135-10.542Zm-9.078,17.4,1.1-10.707,1.5.846-1.135,10.563Zm1.424,1.066-1.135,10.563-1.424-.564,1.1-10.707Zm-1.747-1.231-5.35-2.586.88-11.3,5.577,3.15Zm-.034.365-1.128,10.749-5.116-2.022.88-11.3Zm-1.128,11.1-1.107,10.742-4.883-1.458.88-11.3Zm.33.131,1.424.564-1.135,10.563-1.375-.413Zm1.754.688,4.277,1.685-1.375,10.054-4.051-1.21Zm.041-.358,1.135-10.535,4.511,2.18L263.253,296.8Zm1.176-10.9,1.135-10.542,4.745,2.682-1.375,10.047Zm1.987-21.662-1.162,10.577-1.5-.873,1.1-10.7Zm-1.857-1.19-1.1,10.728-5.584-3.156.88-11.292ZM252.2,256.16l1.953,1.252-.88,11.319-1.926-1.087Zm-.887,11.856,1.926,1.087-.88,11.319-1.9-.922Zm-.887,11.856,1.9.922-.88,11.326-1.884-.743Zm-.887,11.863,1.884.743-.88,11.333-1.864-.557Zm-1.754,23.382.818-11.505,1.864.557-.88,11.326Zm2.18.426.88-11.292,4.876,1.458-1.107,10.742Zm4.993.97,1.1-10.707,1.375.413L256.3,316.774Zm1.685.33,1.135-10.522,4.037,1.21-1.375,10.061Zm5.006.977-.86-.165,1.375-10.027.908.275Zm1.458-10.267-.915-.275,1.375-10.027.963.378Zm1.458-10.267-.963-.378,1.375-10.027,1.018.488Zm1.458-10.274-1.018-.5,1.375-10.02,1.073.605Zm1.458-10.274-1.073-.605,1.375-10.013,1.121.688Z",
    transform: "translate(-75.306 -76.936)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M147.87,326.344l-7.29-58.138L213.3,237.46l-.014.275-3.927,85.879-.344-.014,3.913-85.611-71.981,30.43,7.262,57.883Z",
    transform: "translate(-43.904 -74.163)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M238.849,367.1l-.736,11.718H235.94l.509-11.643Z",
    transform: "translate(-73.686 -114.65)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M221.883,367.66l-.33,11.333H219.49l.11-11.264Z",
    transform: "translate(-68.548 -114.825)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M204.943,368.21l.069,10.955h-1.946l-.3-10.886Z",
    transform: "translate(-63.326 -114.997)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M187.8,368.76l.468,10.577h-1.836l-.7-10.508Z",
    transform: "translate(-58.005 -115.168)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M170.653,369.32l.873,10.192H169.8l-1.1-10.13Z",
    transform: "translate(-52.686 -115.343)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M151.66,369.932l1.85-.062,1.265,9.813h-1.609Z",
    transform: "translate(-47.364 -115.515)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M211.668,362.73l-63.158,2.806.254,2.228,62.78-2.029Z",
    transform: "translate(-46.381 -113.285)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M244.936,216.88l42.41,35.423-12.516,69.2-34.66-1.32.124-3.005,23.945,1.176,10.79-66.679-30.692-22.584Z",
    transform: "translate(-75.007 -67.735)",
    fill: "#ba8ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M286.681,295.89l6.244,3.837-7.771,43.813-6.024-.337Z",
    transform: "translate(-87.174 -92.411)",
    fill: "#921941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M279.13,343.4l7.475-46.873,5.928,3.645L284.81,343.72Z",
    transform: "translate(-87.174 -92.61)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M287.956,324.314l-.688,3.748-5.433-1.472.64-4Zm-6.155,2.62-.64,4.009,5.405,1.21.688-3.748Zm3.315,13.4.688-3.755-5.378-.949-.64,4.009Zm-1.939-22.089-.64,4L288,323.977l.688-3.748Zm2.9-17.756,5.57,3.019.516-2.916-5.612-3.438-.557,3.493Zm-4.958,30.795-.64,4.009,5.371.956.688-3.748Zm2.751-17.392-.64,4.009h0l5.5,1.987.688-3.741Zm-4.126,26.084-.578,3.624,5.337.3.571-3.225Zm6.237-39.13-.688,4.126.062-.131,5.55,2.751.688-3.734Zm-.688,4.346-.688,4.126.048-.1,5.5,2.5.688-3.734Zm-.688,4.346-.646,4.071v-.062l5.5,2.249.688-3.741Z",
    transform: "translate(-87.183 -92.804)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M279.13,343.706l.55-3.438,5.158.688-.543,3.06Zm.633-3.954.612-3.83,5.192.922-.633,3.59Zm.688-4.339.612-3.83,5.226,1.176-.633,3.583Zm.688-4.346.612-3.83,5.261,1.424-.633,3.583Zm.688-4.346.612-3.83,5.3,1.678-.633,3.583Zm.688-4.346.612-3.83,5.323,1.926-.633,3.576Zm.688-4.346.612-3.824,5.357,2.18-.633,3.576Zm.688-4.346.612-3.824,5.392,2.441-.633,3.569Zm.688-4.346.612-3.817,5.419,2.7-.633,3.562Zm.688-4.353.605-3.81,5.453,2.957-.591,3.549Zm.688-4.353.5-3.129,5.447,3.349-.488,2.751Z",
    transform: "translate(-87.174 -92.913)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M274.227,378.931h-.97l1.41-10.474,1.32.048Zm-7.3,0h.99l1.637-10.666-1.375-.055Zm-6.334,0h1.045l1.506-10.914-1.41-.055Zm-6.334,0h1.08l1.375-11.168-1.458-.055Zm-6.334,0h1.121l1.252-11.416-1.506-.055Z",
    transform: "translate(-77.43 -114.762)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M271.721,378.8h-.97l1.41-10.474,1.32.048Zm-7.3,0h1l1.637-10.666-1.375-.055Zm-6.334,0h1.045l1.506-10.914-1.41-.055Zm-6.334,0h1.08l1.375-11.168-1.458-.055Zm-6.334,0h1.121l1.252-11.416-1.506-.055Zm-6.334,0h1.162l1.121-11.691-1.554-.062Z",
    transform: "translate(-74.669 -114.634)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M291.482,327.918l.633-3.576-3.342-1.362-.3,3.844Z",
    transform: "translate(-90.091 -100.871)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M292.36,321.821l.633-3.569-3.727-1.692-.3,3.872Z",
    transform: "translate(-90.247 -98.866)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M295.49,301.036l-4.773-2.936-.248,3.218,4.539,2.455Z",
    transform: "translate(-90.716 -93.101)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M290.6,334l.633-3.576-2.957-1.073-.3,3.817Z",
    transform: "translate(-89.938 -102.86)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M294.124,309.583l.633-3.555-4.484-2.428-.3,3.92Z",
    transform: "translate(-90.56 -94.818)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M293.242,315.7l.633-3.562-4.112-2.042-.3,3.9Z",
    transform: "translate(-90.4 -96.848)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M289.728,340.064l.633-3.576-2.572-.818-.289,3.8Z",
    transform: "translate(-89.788 -104.834)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M287.1,358.18l.633-3.583-1.382-.248-.289,3.7Z",
    transform: "translate(-89.338 -110.668)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M286.335,363.661l.543-3.06-.99-.131-.248,3.157Z",
    transform: "translate(-89.207 -112.579)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M287.967,352.159l.64-3.59-1.788-.4-.289,3.734Z",
    transform: "translate(-89.485 -108.738)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M288.846,346.124l.633-3.59-2.173-.585-.3,3.762Z",
    transform: "translate(-89.635 -106.795)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M483.357,385.359H362.35l1.148-2.049h118.95Z",
    transform: "translate(-113.164 -119.712)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M480.68,385.359l.777-2.049H519.4l.908,2.049Z",
    transform: "translate(-150.12 -119.712)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M398.361,319.443,392.11,206.75l61.074-27.92-7.853,140.613Z",
    transform: "translate(-122.459 -55.852)",
    fill: "#70c5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M469.5,319.443h24.062l18.43-116.076L477.353,178.83Z",
    transform: "translate(-146.628 -55.852)",
    fill: "#065275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 2.18,
    height: 25.988,
    transform: "matrix(0.984, -0.177, 0.177, 0.984, 332.259, 150.158)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 2.18,
    height: 25.988,
    transform: "translate(330.171 177.488) rotate(-10.19)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 4.36,
    height: 25.988,
    transform: "matrix(0.984, -0.177, 0.177, 0.984, 341.373, 155.105)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 1.747,
    height: 25.988,
    transform: "matrix(0.984, -0.177, 0.177, 0.984, 351.945, 160.598)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M478.127,354.67l-1.747.316,3.48,19.372h1.8Z",
    transform: "translate(-148.777 -110.768)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M488.93,354.45l-3.48.626L488.9,374.29h3.6Z",
    transform: "translate(-151.609 -110.699)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M510.439,272.85l-1.719.309,4.594,25.575.461-.083.612-3.83Z",
    transform: "translate(-158.877 -85.215)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M502.819,288.246l-.8.144-4.353-24.221-4.291.77,4.594,25.575,3.383-.612,4.353,24.227.406-.076.633-3.989Z",
    transform: "translate(-154.083 -82.504)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 2.18,
    height: 23.306,
    transform: "translate(327.404 223.291) rotate(-11.1)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M499.483,318.257l-1.54.3-3.954-22.013-4.3.77,4.6,25.575,4.174-.75,3.769,19.207.791-5.013Z",
    transform: "translate(-152.933 -92.614)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M496.509,355.093l-3.37-18.76-.578.1-4-20.418-3.8.743L480.8,294.72l-2.146.385,4.594,25.582,1.719-.316,3.8,19.352,3.432-.674,2.978,16.587h1.252Z",
    transform: "translate(-149.486 -92.045)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M415.594,360.666,405.98,376.2h1.953l9.676-15.631Z",
    transform: "translate(-126.79 -112.611)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M460.382,358.5,449.84,375.524h1.96L462.4,358.4Z",
    transform: "translate(-140.488 -111.933)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M408.545,361.059,400.96,373.32l.117,2.173,8.981-14.5Z",
    transform: "translate(-125.222 -112.742)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M453.845,358.785l-10.4,16.807h3.425l10.508-16.972Z",
    transform: "translate(-138.489 -112.002)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M427.848,359.976l-9.868,15.941h6.354L434.4,359.66Z",
    transform: "translate(-130.538 -112.326)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 31.544,
    height: 5.673,
    transform: "translate(286.3 206.925) rotate(-56.45)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 31.544,
    height: 1.747,
    transform: "matrix(0.553, -0.834, 0.834, 0.553, 275.944, 211.777)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 31.544,
    height: 3.053,
    transform: "translate(303.971 173.789) rotate(-56.45)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 31.544,
    height: 5.673,
    transform: "translate(285.44 179.745) rotate(-56.45)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M407.722,272.59,396.43,289.617l.124,2.187,12.262-18.492Z",
    transform: "translate(-123.808 -85.134)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M461.62,292.18l-16.8,23.368,2.448,1.5,16.807-23.368Z",
    transform: "translate(-138.92 -91.252)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M418.84,323.245l4.559,2.785,16.8-23.375-4.553-2.785Z",
    transform: "translate(-130.807 -93.654)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M461.994,323.644l-2.51-1.424L442.34,344.343l2.5,1.417Z",
    transform: "translate(-138.146 -100.634)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M415.83,350.49l4.649,2.558,17.151-21.47-4.649-2.558Z",
    transform: "translate(-129.866 -102.757)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 31.544,
    height: 1.747,
    transform: "matrix(0.553, -0.834, 0.834, 0.553, 275.089, 184.58)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M452.968,279.143l15.769-23.78.186-3.452L451.51,278.18Z",
    transform: "translate(-141.01 -78.675)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M465.665,324.1l-15.2,19.606,1.437.812,13.63-17.591Z",
    transform: "translate(-140.682 -101.221)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M419.6,335.326l-1.43-.756L401.03,355.215l1.43.756Z",
    transform: "translate(-125.244 -104.491)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M409.49,337.394l-1.073-.564-8.857,10.659.089,1.754Z",
    transform: "translate(-124.785 -105.196)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M452.78,314.855l1.4.86,13.348-18.575.172-3.04Z",
    transform: "translate(-141.406 -91.852)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M422.543,307.01l-1.4-.86-16.8,23.368,1.4.86Z",
    transform: "translate(-126.278 -95.615)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 31.544,
    height: 3.053,
    transform: "translate(304.831 200.975) rotate(-56.45)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M410.16,308.71,398.38,325.1l.11,1.953,12.722-17.7Z",
    transform: "translate(-124.417 -96.414)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 31.544,
    height: 1.747,
    transform: "translate(309.658 172.338) rotate(-56.45)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M394.434,253.189,407.3,233.782l-1.093-.722L394.31,251Z",
    transform: "translate(-123.146 -72.788)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M411.416,313.976l-3.136-78.1h.688l3.136,78.1Zm9.807-.963-1.375-81.739h.688l1.375,81.739Zm10.46-.956h-.688l.378-85.377h.688Zm9.807-.949H440.8l2.132-89.008h.688Z",
    transform: "translate(-127.509 -69.365)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M410.936,314.086l-3.136-78.1h.688l3.136,78.1Zm9.807-.963-1.375-81.739h.688l1.375,81.739Zm10.46-.977h-.688l.378-85.377h.688Zm9.807-.949h-.688l2.132-89.008h.688Z",
    transform: "translate(-127.359 -69.394)",
    fill: "#5d5996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M400.13,366.028l1.6-.131.818,11.732h-1.726Zm8.507,11.6h1.795l-.481-12.509-1.74.144Z",
    transform: "translate(-124.963 -114.032)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M399.1,366.381l1.6-.131.818,11.725h-1.726Z",
    transform: "translate(-124.642 -114.384)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M424,364.131l1.884-.151.144,13.286h-1.864Z",
    transform: "translate(-132.418 -113.676)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M410.86,365.254l1.74-.144.481,12.509h-1.795Z",
    transform: "translate(-128.314 -114.028)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M423.05,364.131l1.884-.151.144,13.286h-1.864Z",
    transform: "translate(-132.121 -113.676)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M440.736,363.015l2.036-.165-.2,14.063H440.64Z",
    transform: "translate(-137.615 -113.323)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M454.238,361.9l2.18-.186-.53,14.847H453.88Z",
    transform: "translate(-141.75 -112.967)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M440.066,363.015l2.036-.165-.2,14.063H439.97Z",
    transform: "translate(-137.406 -113.323)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M453.561,361.9l2.187-.186-.536,14.847h-2Z",
    transform: "translate(-141.54 -112.967)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M467.1,360.773,466.49,376.2h2.07l.873-15.624Z",
    transform: "translate(-145.688 -112.614)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M470.373,360.58l1.74.151L471.24,376.2H469.5Z",
    transform: "translate(-146.628 -112.614)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M483.059,361.61l1.685.144-1.3,14.772H481.78Z",
    transform: "translate(-150.463 -112.935)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M496.149,362.64l1.616.144-1.719,14.063h-1.6Z",
    transform: "translate(-154.42 -113.257)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M496.437,313.524l-.646-.089,11.12-78,.646.089Zm-6.279-.811-.653-.076,9.332-82.523.653.076Zm-7.805-.908-.653-.055L489.471,224l.653.055Z",
    transform: "translate(-150.438 -69.959)",
    fill: "#1b194e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M496.888,313.524l-.646-.089,11.12-78,.646.089Zm-6.3-.811-.653-.076,9.332-82.523.653.076Zm-7.805-.908-.653-.055L489.935,224l.653.055Z",
    transform: "translate(-150.572 -69.959)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M504.4,363.67l-2.111,13.5h1.527l2.146-13.362Z",
    transform: "translate(-156.868 -113.579)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M483.9,361.61l1.678.144-1.293,14.772H482.61Z",
    transform: "translate(-150.722 -112.935)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M496.979,362.64l1.623.144-1.726,14.063h-1.6Z",
    transform: "translate(-154.679 -113.257)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M505.231,363.67l-2.111,13.5h1.527l2.146-13.362Z",
    transform: "translate(-157.128 -113.579)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M450.517,200.47l34.708,22.8,3.693-23.01-36.207-30L387.93,202.217l1.382,22.536Z",
    transform: "translate(-121.153 -53.176)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M449.53,283.26l-56.26,14.07.66,10.728,54.85-11.271,30.589,8.672,1.341-8.362Z",
    transform: "translate(-122.821 -88.466)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M447.993,350.12l-51.433,4.993.392,6.341,50.642-4.14,27.446,2.393.977-6.072Z",
    transform: "translate(-123.848 -109.347)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M450.483,240.69l-59.4,18.822.688,11.182,57.924-15.865,32.679,14.345,1.513-9.4Z",
    transform: "translate(-122.137 -75.171)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M395.11,329.481l.461,7.523,52.609-7.661,28.945,5.02,1.2-7.29-29.64-6.774Z",
    transform: "translate(-123.395 -100.034)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M508.989,269.174l1.513-9.4L477.1,240.69l-.791,14.139Z",
    transform: "translate(-148.755 -75.171)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M502.428,327.074l-29.64-6.774-.509,9.043,28.945,5.02Z",
    transform: "translate(-147.496 -100.034)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M499.192,353.637l-28-3.507-.426,7.186,27.446,2.393Z",
    transform: "translate(-147.025 -109.35)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M474.74,283.26l-.75,13.527,30.589,8.672,1.341-8.362Z",
    transform: "translate(-148.03 -88.466)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M513.648,223.267l3.693-23.01-36.207-30-2.194,30.21Z",
    transform: "translate(-149.576 -53.176)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M389.94,238.472l61.2-24.282,34.708,22.8-2.414.756-32.686-20.535-58.131,22.185Zm4,24.633,55.215-14.263,30.561,12.378,2.3-.3-32.679-14.345-57.924,15.865Zm1.334,24.069,52.361-10.233L476,284.582l2.318-.688-30.575-8.679L392.9,286.487Zm51.247,10.68,26.82,4.037,2.173-.688L446.633,296.2l-52.684,7.647,2.29.646ZM396.26,319.228l49.218-3.576,25.885,1.987,1.609-.371-27.446-2.393L394.885,319Z",
    transform: "translate(-121.781 -66.895)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M502.217,312.283l2.318-.681-30.589-8.672h0l-.1,1.712Z",
    transform: "translate(-147.986 -94.609)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M472.2,335.093l26.813,4.037,2.173-.653-28.869-5.006-.076.007-.089,1.623Z",
    transform: "translate(-147.456 -104.147)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M513.57,236.987l-34.708-22.8h0l-.172,3.15,32.473,20.4Z",
    transform: "translate(-149.498 -66.895)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M476.13,263.554,506.636,275.9l2.3-.3L476.254,261.25Z",
    transform: "translate(-148.699 -81.592)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M498.194,362.973l-27.446-2.393-.048.777,25.885,1.987Z",
    transform: "translate(-147.003 -112.614)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M426.78,367.216l9.146-.626v.481l-9.146.578Z",
    transform: "translate(-133.286 -114.491)",
    fill: "#5d5996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M432.98,367.491v10.866h.186l.124-10.886Z",
    transform: "translate(-135.223 -114.765)",
    fill: "#5d5996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M388.04,217.918l3.892-1.348-3.851,2.042Z",
    transform: "translate(-121.187 -67.638)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M388.38,224.056l1.712-.186-1.664.949Z",
    transform: "translate(-121.294 -69.918)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M388.87,231.691l2.875-.811-2.833,1.41Z",
    transform: "translate(-121.447 -72.108)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M389.23,237.776l1.981-.406-1.946.908Z",
    transform: "translate(-121.559 -74.134)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M389.68,244.94l2.613-.75-2.572,1.437Z",
    transform: "translate(-121.7 -76.264)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M391.2,269.7l3.1-.578-3.074,1.025Z",
    transform: "translate(-122.174 -84.05)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M391.46,274.135l1.369-.165-1.341.578Z",
    transform: "translate(-122.256 -85.565)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M391.74,278.768l.963-.158-.935.6Z",
    transform: "translate(-122.343 -87.014)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M391.94,281.757l2.936-.557-2.916.928Z",
    transform: "translate(-122.405 -87.823)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M393.37,305.18l1.568-.22-1.547.585Z",
    transform: "translate(-122.852 -95.243)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M393.66,309.79l3.445-.66-3.418,1.093Z",
    transform: "translate(-122.943 -96.546)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M393.77,311.91h.75l-.736.22Z",
    transform: "translate(-122.977 -97.414)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M394,315.489l2.242-.289-2.214.674Z",
    transform: "translate(-123.049 -98.441)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M395.2,335.118l1.327-.138-1.313.385Z",
    transform: "translate(-123.424 -104.619)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M395.31,336.925l.591-.055-.578.261Z",
    transform: "translate(-123.458 -105.209)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M395.51,340.125l1.774-.165-1.76.358Z",
    transform: "translate(-123.52 -106.174)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M395.62,341.883l1.142-.083-1.135.261Z",
    transform: "translate(-123.555 -106.749)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M395.74,343.63h.488l-.488.213Z",
    transform: "translate(-123.592 -107.32)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M396.62,358.3l2.228-.124-2.208.385Z",
    transform: "translate(-123.867 -111.864)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M396.73,360.1h.695l-.674.3Z",
    transform: "translate(-123.901 -112.464)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M396.92,363.21h1.623l-1.609.248Z",
    transform: "translate(-123.961 -113.435)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M397,364.58h1.513c-.083,0-1.5.227-1.5.227Z",
    transform: "translate(-123.986 -113.863)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M397.08,365.77h.385l-.378.151Z",
    transform: "translate(-124.011 -114.235)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M477.932,173.02l-8.8,4.36,8.713-3.095Z",
    transform: "translate(-146.512 -54.037)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M480.477,178.04l-2.407,1.417,2.318-.213Z",
    transform: "translate(-149.304 -55.605)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M479.088,185.33l-4.3,2.07,4.216-1.032Z",
    transform: "translate(-148.28 -57.882)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M479.231,193.75l-2.641.97h2.565Z",
    transform: "translate(-148.842 -60.512)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M477.4,200.24l-5.618,2.544,5.529-1.272Z",
    transform: "translate(-147.34 -62.538)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M477.792,209.22,474.47,210.9l3.246-.619Z",
    transform: "translate(-148.18 -65.343)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M476.163,243.86l-2.483.9,2.455-.454Z",
    transform: "translate(-147.933 -76.161)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M475.425,247.52l-3.645,1.107,3.6-.282Z",
    transform: "translate(-147.34 -77.304)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M475.862,255.48l-1.712.653h1.712Z",
    transform: "translate(-148.08 -79.79)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M474.638,259.02l-3.968,1.2,3.934-.6Z",
    transform: "translate(-146.993 -80.896)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M473.262,285.24l-3.762,1.272,3.727-.633Z",
    transform: "translate(-146.628 -89.085)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M474.026,289.89l-1.506.653h1.472Z",
    transform: "translate(-147.571 -90.537)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M473.045,293.49l-3.225.908,3.191-.3Z",
    transform: "translate(-146.728 -91.661)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M471.923,299.04l-5.013,1.341,4.979-.674Z",
    transform: "translate(-145.819 -93.394)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M472.282,322.22l-1.382.351,1.355.2Z",
    transform: "translate(-147.065 -100.634)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M471.338,325.31l-3.088.571H471.3Z",
    transform: "translate(-146.238 -101.599)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M472.062,327.93l-1.162.378,1.135.165Z",
    transform: "translate(-147.065 -102.417)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M470.858,331.06l-3.438.818,3.4-.22Z",
    transform: "translate(-145.978 -103.394)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M469.89,351.32l-3.15.488h3.122Z",
    transform: "translate(-145.766 -109.722)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M470.737,354.37l-.887.206.866.11Z",
    transform: "translate(-146.737 -110.674)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M470.114,355.7l-2.084.179,2.063.165Z",
    transform: "translate(-146.169 -111.09)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M470.177,358.71l-1.547.33h1.527Z",
    transform: "translate(-146.356 -112.03)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M487.409,185.72a48.7,48.7,0,0,0,11,9.3C494.506,192.006,491.06,189.1,487.409,185.72ZM503.515,198.1a29.028,29.028,0,0,0,5.02,4.47,32.227,32.227,0,0,0-5.027-4.491Zm-17.33-8.631a31.509,31.509,0,0,0,5.57,4.25,34.969,34.969,0,0,0-5.57-4.271Zm-2.311,2.538a11.952,11.952,0,0,0,3.72,2.159,13.258,13.258,0,0,0-3.72-2.18Zm12.255,5.4a56.193,56.193,0,0,0,7.53,5.557,62.388,62.388,0,0,0-7.53-5.577Zm10.886,7.338a10.068,10.068,0,0,0,4.814,3.906,40.624,40.624,0,0,1-4.814-3.927Zm-7.5-1.671a72.961,72.961,0,0,0,8.479,6.464,81.053,81.053,0,0,0-8.479-6.485Zm-9.071-5.467c1.864,1.375,3.535,2.531,5.46,3.81A16.883,16.883,0,0,0,490.442,197.6Zm-6.148,1.142a78.789,78.789,0,0,0,8.995,6.471,87.428,87.428,0,0,0-9-6.444Zm12.042,8.486a12.082,12.082,0,0,0,3.6,2.4A13.4,13.4,0,0,0,496.335,207.231Zm7.4,4.718a40.985,40.985,0,0,0,8.507,5.24c-2.861-1.884-5.522-3.514-8.514-5.254Zm-5.969-.371a63.179,63.179,0,0,0,8.294,5.447,70.092,70.092,0,0,0-8.294-5.467Zm-9.181-5.316a20,20,0,0,0,4.814,2.833,22.2,22.2,0,0,0-4.814-2.854Zm-6.127-3.562a7.6,7.6,0,0,0,2.964,1.712,8.425,8.425,0,0,0-2.964-1.733Zm.227,26.82a45.482,45.482,0,0,0,7.207,4.346,50.481,50.481,0,0,0-7.207-4.374Zm4.044,5.22a16.587,16.587,0,0,0,4.594,2.159A18.4,18.4,0,0,0,486.728,234.739Zm8.08,1.829c2.861,1.795,5.453,3.363,8.376,5.055a37.053,37.053,0,0,0-8.376-5.082Zm10.535,6.506a3.06,3.06,0,0,0,1.87,1.059,3.376,3.376,0,0,0-1.864-1.087Zm-10.088-2.586a30.471,30.471,0,0,0,6,3.383,33.816,33.816,0,0,0-6-3.383Zm-13.4-4.5a14.621,14.621,0,0,0,4.477,1.623,16.216,16.216,0,0,0-4.5-1.623Zm20.8,9.985a5.584,5.584,0,0,0,2.62,1.307,6.189,6.189,0,0,0-2.641-1.307Zm-21.786,11.388a49.627,49.627,0,0,0,8.053,3.514,55.1,55.1,0,0,0-8.067-3.514Zm7.386,5.192a19.682,19.682,0,0,0,5.13,2.063,21.834,21.834,0,0,0-5.144-2.063Zm8.534,2a24.866,24.866,0,0,0,5.777,2.3,27.586,27.586,0,0,0-5.783-2.3Zm-1.417,2.751a15.487,15.487,0,0,0,4.587,1.726,17.191,17.191,0,0,0-4.6-1.747Zm-7.434-1.706a3.831,3.831,0,0,0,2.29.763,4.236,4.236,0,0,0-2.3-.784Zm-8.252-4.718a19.853,19.853,0,0,0,5.233,1.857,22,22,0,0,0-5.268-1.864Zm2.751,3.514a2.324,2.324,0,0,0,1.747.653,2.558,2.558,0,0,0-1.815-.674Zm-3.177,16.732a30,30,0,0,0,6.567,1.891,33.291,33.291,0,0,0-6.636-1.9Zm4.264,3.438a10.315,10.315,0,0,0,3.927.763,11.472,11.472,0,0,0-4-.777Zm6.01,2.579a17.146,17.146,0,0,0,5.013,1.217,19.012,19.012,0,0,0-5.082-1.231Zm3.143-1.637a19.765,19.765,0,0,0,5.46.942,21.93,21.93,0,0,0-5.529-.956Zm-14.6-.309a8.176,8.176,0,0,0,3.487.688,9.057,9.057,0,0,0-3.555-.7Zm10.006-1.692a1.974,1.974,0,0,0,2.063.688,19.368,19.368,0,0,0-2.132-.7Zm9.071,5.206a2.063,2.063,0,0,0,1.747.213,2.29,2.29,0,0,0-1.809-.227ZM478.338,300.4a11.745,11.745,0,0,0,5.839.791Zm3.872,2.242a5.8,5.8,0,0,0,2.943.481,6.43,6.43,0,0,0-3.005-.461Zm-4.47,1.671a5.88,5.88,0,0,0,2.943.6,6.513,6.513,0,0,0-3.005-.578ZM476,302.036a3.775,3.775,0,0,0,2.345.5,4.167,4.167,0,0,0-2.345-.5Zm12.048,3a30.4,30.4,0,0,0,6.877.4,33.744,33.744,0,0,0-6.884-.392Zm-.165-2.283a22.864,22.864,0,0,0,4.092.77,7.991,7.991,0,0,0-4.1-.763Zm-4.69,1.32a12.226,12.226,0,0,0,3.652.426,7.406,7.406,0,0,0-3.659-.419Zm11.56-.179a3.734,3.734,0,0,0,1.747.323,1.637,1.637,0,0,0-1.754-.316Z",
    transform: "translate(-148.658 -58.004)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M407.3,200.774a63.019,63.019,0,0,1-9.105,3.913,69.966,69.966,0,0,1,9.105-3.913Zm9.765-4.814c6.877-3.081,13.018-6.079,19.668-9.628-6.829,3.081-13,6.114-19.689,9.641Zm23.382-10.212a39.067,39.067,0,0,0,7.331-2.668,43.366,43.366,0,0,0-7.372,2.7Zm-45.7,23.409a19.943,19.943,0,0,0,5.1-2.235,22.164,22.164,0,0,0-5.1,2.235Zm11.429-4.525c4.271-1.788,8.1-3.438,12.317-5.364a70.9,70.9,0,0,0-12.317,5.4Zm17.536-7.565a39.8,39.8,0,0,0,4.126-1.609,8.253,8.253,0,0,0-4.119,1.644Zm10.315-4.126c3.624-1.609,6.925-2.936,10.652-4.284A34.742,34.742,0,0,0,434.035,193Zm-32.672,18.3a14.5,14.5,0,0,0,4.36-1.857,16.072,16.072,0,0,0-4.346,1.919Zm11.691-3.714,6.767-2.751a17.749,17.749,0,0,0-6.774,2.813Zm11.45-6.485A58.57,58.57,0,0,0,433.547,198a65.007,65.007,0,0,0-9.057,3.046Zm11.773-1.644c2.813-.956,5.309-1.85,8.08-2.909a28.3,28.3,0,0,0-8.087,2.909Zm4.264-5.323a10,10,0,0,0,3.707-1.314,11.086,11.086,0,0,0-3.714,1.314Zm-43.18,24.571a56.186,56.186,0,0,0,8.686-3.487,62.357,62.357,0,0,0-8.686,3.487Zm12.42-5.921a42.589,42.589,0,0,0,7.627-2.881,47.271,47.271,0,0,0-7.627,2.881Zm-5.027,5.742a60.728,60.728,0,0,0,9.16-3.273,67.392,67.392,0,0,0-9.167,3.273Zm18.568-7.31a53.523,53.523,0,0,0,12.667-3.438c-4.346,1.217-8.3,2.3-12.695,3.438Zm-.736-3.734c2.544-.77,4.814-1.527,7.283-2.455a24.18,24.18,0,0,0-7.31,2.455Zm13.713-2.7a48.63,48.63,0,0,0,8.4-2.269,54,54,0,0,0-8.431,2.269Zm-35.024,37.7a60.263,60.263,0,0,0,9.174-3.129,66.923,66.923,0,0,0-9.2,3.129Zm9.3,0,10.687-2.751a41.191,41.191,0,0,0-10.714,2.716Zm11.691-4.924a15.13,15.13,0,0,0,4.69-1.2,16.76,16.76,0,0,0-4.745,1.162Zm6.368-4.2c2.751-.736,5.171-1.458,7.874-2.338a27.02,27.02,0,0,0-7.874,2.338Zm10.584-2.517a10.316,10.316,0,0,0,3.934-.729,11.47,11.47,0,0,0-3.934.736Zm-6.877,5.158a30.163,30.163,0,0,0,6.643-1.671,33.487,33.487,0,0,0-6.629,1.678Zm-28.464,9.394a12.447,12.447,0,0,0,4.257-1.087A13.809,13.809,0,0,0,403.859,245.33Zm19.194-3.487a29.248,29.248,0,0,0,6.547-1.637,32.451,32.451,0,0,0-6.533,1.637Zm-27.061,4.126a14.861,14.861,0,0,0,4.47-1.747,16.5,16.5,0,0,0-4.456,1.733Zm6,20.5a52.042,52.042,0,0,0,8.617-2.606,57.769,57.769,0,0,0-8.6,2.586Zm9.7-1.093c3.679-.811,6.973-1.637,10.6-2.675a52.454,52.454,0,0,0-10.577,2.654Zm14.517-2.366a39.8,39.8,0,0,0,7.73-1.485,44.166,44.166,0,0,0-7.709,1.465Zm5.13-3.672a48.66,48.66,0,0,0,8.507-1.871,54,54,0,0,0-8.479,1.85Zm-30.451,11.691a49.81,49.81,0,0,0,8.514-2.256,55.3,55.3,0,0,0-8.493,2.221Zm12.887-2.751a11.292,11.292,0,0,0,4.037-1.093,12.522,12.522,0,0,0-4.016,1.052Zm9.05-1.664a41.3,41.3,0,0,0,7.853-1.719,45.858,45.858,0,0,0-7.833,1.678Zm11.333-2a8.252,8.252,0,0,0,3.493-.736,9.168,9.168,0,0,0-3.473.695Zm-17,4.972a13.417,13.417,0,0,0,5.777-1.093c-1.974.268-3.755.612-5.756,1.045Zm-18.086,17.88a49.955,49.955,0,0,0,8.706-1.417,55.471,55.471,0,0,0-8.686,1.382Zm7.069,1.073a27.718,27.718,0,0,0,6.43-1.334,30.762,30.762,0,0,0-6.409,1.3Zm7.523-3.28a38.191,38.191,0,0,0,7.633-1.08,42.4,42.4,0,0,0-7.613,1.052Zm4.814.777a15.316,15.316,0,0,0,3.273-.688,5.13,5.13,0,0,0-3.267.66Zm-5.557,3.06c2.531-.213,4.814-.454,7.31-.77a20.521,20.521,0,0,0-7.3.743Zm-9.5.811a6.189,6.189,0,0,0,3.06-.406,6.877,6.877,0,0,0-3.053.378ZM424.7,284.7c2.689-.351,5.089-.743,7.75-1.279a25.8,25.8,0,0,0-7.75,1.252Zm-1.52,1.967a23.64,23.64,0,0,0,6-.873,26.23,26.23,0,0,0-6,.853ZM432,286.3a18.148,18.148,0,0,0,5.24-.86,20.13,20.13,0,0,0-5.24.832Zm2.62-2.71a22.269,22.269,0,0,0,5.783-1.066,24.7,24.7,0,0,0-5.783,1.038Zm-1.3-1.932a10.721,10.721,0,0,0,4.037-.543,11.883,11.883,0,0,0-4.037.516Zm-30.754,23.78a34.576,34.576,0,0,0,7.3-.688A38.375,38.375,0,0,0,402.566,305.434Zm4.477-2.228a43.023,43.023,0,0,0,8.177-.337,47.765,47.765,0,0,0-8.177.309Zm7.31,1.513a12.379,12.379,0,0,0,4.36-.468,13.755,13.755,0,0,0-4.367.44Zm6.65.825a33.484,33.484,0,0,0,7.193-.564,37.137,37.137,0,0,0-7.2.536Zm-12.33,1.066a7.489,7.489,0,0,0,3.383-.309A8.294,8.294,0,0,0,408.673,306.61Zm13.754-3.92a15.817,15.817,0,0,0,4.9-.688,17.524,17.524,0,0,0-4.9.681Zm6.107.543c2.379-.041,4.5-.138,6.877-.323a18.829,18.829,0,0,0-6.891.323Zm4.9-2.3a13.067,13.067,0,0,0,4.47-.55,14.525,14.525,0,0,0-4.477.557Zm2.51,3.514a9.277,9.277,0,0,0,3.707-.777,10.315,10.315,0,0,0-3.714.777Z",
    transform: "translate(-123.28 -57.179)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M389.946,361.54l.083.1.282,2.428-2.407.227-.1-.076Z",
    transform: "translate(-121.112 -112.914)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 0.64,
    cy: 0.64,
    r: 0.64,
    transform: "translate(264.281 246.247)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M386.79,375.722h-.413v-4.649l-.413-4.436-1.025-7.613.406-.055,1.025,7.62.413,4.463Z",
    transform: "translate(-120.219 -112.111)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M384.62,360.808,386,360.56l-.3.475.481,3.356.4.653-1.747.131.385-.708-.371-3.349Z",
    transform: "translate(-120.119 -112.607)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M385.953,376.489l1.7-.179-.337.523.5,3.879h.22v.426l-2.386.062v-.4h.344l.193-3.851Z",
    transform: "translate(-120.441 -117.526)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M381.67,362.79l1.9.165.131,2.1-1.781.241Z",
    transform: "translate(-119.198 -113.304)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M384.1,364.306l.97-.076.027.3-.977.117Z",
    transform: "translate(-119.957 -113.754)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M386.28,363.635l1.052-.165.041.309-1.059.1Z",
    transform: "translate(-120.638 -113.516)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M387.54,361.953l.179,2.262,2.373-.206-.227-2.469Z",
    transform: "translate(-121.031 -112.914)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M381.97,363.11l.158,2.1,1.513-.179-.11-1.843Z",
    transform: "translate(-119.292 -113.404)",
    fill: "#e5a076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M387.82,362.158l.131,1.932,2.022-.151-.144-2.159Z",
    transform: "translate(-121.119 -112.988)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M381.6,362.79l-.151.021.234,2.489h.165Z",
    transform: "translate(-119.129 -113.304)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M384.994,359.253a.488.488,0,0,1-.076-.963.646.646,0,0,0-.172.488A.688.688,0,0,0,384.994,359.253Z",
    transform: "translate(-120.094 -111.899)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M385.458,360.91l-.6.083.144.2.454,3.328-.254.591.557-.048a.536.536,0,0,1-.179-.268c0-.151-.426-3.61-.426-3.61Z",
    transform: "translate(-120.194 -112.717)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M386.49,376.748l.165.3-.165,3.789h.475l-.083-3.824.083-.309Z",
    transform: "translate(-120.703 -117.648)",
    fill: "#7c78b5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "adsgfdfsgsdf",
    transform: "translate(-70.042 2079.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(0.043 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer_1-2",
    "data-name": "layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M19.33,18.175C26.9,3.651,45.8-3.721,61.128,1.87S86.256,25.306,82.8,41.329a15.23,15.23,0,0,1,16.731-.22,15.61,15.61,0,0,1,6.32,15.7c.688-4.229,2.152-8.527,5.165-11.56s7.723-4.594,11.691-3.046,6.437,6.677,4.442,10.467c-.915-4.387,3.2-8.562,7.654-8.658a8.017,8.017,0,0,1,7.723,8.878c6.781.88,10.625,9.153,8.644,15.727s-9.579,10.632-16.271,9.215c5.9,6.457,5.543,16.188.784,23.539s-13.375,11.567-22.04,12.5-17.419-1.093-25.6-4.071c-2.751,8.1-9.566,14.806-17.068,18.863s-16.085,5.763-24.6,6.12c-10.907.461-22.4-1.437-31.015-8.177C6.89,119.987,2.193,109.383.7,98.71S.495,77.172,2.159,66.519c.818-5.206,1.747-10.5,4.216-15.129s6.774-8.61,11.966-9.325c-4.236-2.751-7.785-8.369-7.7-13.43S15.012,20.781,19.33,18.175Z",
    transform: "translate(-0.043 0.001)",
    fill: "#f7fbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M381.917,277.953l4.958-34.659-16.236-7.95-14.077,3.83-23.512-1.747,6.891-108.84-21.958-14.668-24.667,12.867,11.2,104.294-26.531-5.563,6.87-83.588-35.01-13.341-19.063,8.238,5.735,82.715-25.623-.86,9.676-108.861L182.832,92l2.826-29.385L154,47.86,119.311,66.531l-6.3,70.3H67.961L75.333,85.7l-19.9-13.259L37.9,89.974l-6.4,193.26,348.712,1.712Z",
    transform: "translate(-9.867 -14.946)",
    fill: "#aceff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M388.466,322.34,380.51,218.513,340.569,205.77l-27.239,9.965,14.208,112.8,60.929,2.091Z",
    transform: "translate(-97.887 -64.264)",
    fill: "#52b4b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M148.08,385.416h141l-1.341-1.926h-138.6Z",
    transform: "translate(-46.277 -119.769)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M194.258,385.416l-.908-1.926H149.132l-1.052,1.926Z",
    transform: "translate(-46.277 -119.769)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M266.743,122.982l.688-11-2.063-.406.481-.688,4.47,1.21-.158.371-2.111-.358-.653,10.9ZM264.206,102l-2.868,1.293.688.853-.282.172-.963-.763-1.424.646-.248-.55,1.286-.585-1.286-1.114.88-.378.977,1.231,5.907-2.675-1.5-1.657.921-.433,1.142,1.836,3.026-1.375-.131.722-2.572,1.162,1.032,1.657h-.309l-1.279-1.375-2.372,1.073v20.294h-.605Zm-3.4,17.777.309-6.588-1.093-.234.33-.371h2.964l.234.956-1.836-.351-.309,6.616Z",
    transform: "translate(-80.953 -30.618)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M200.47,370.31l.378,9.064h82.976l.908-7.489Z",
    transform: "translate(-62.639 -115.652)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M272.087,133.258,245.9,118.92v12.351l1.011,156.538h18.973Z",
    transform: "translate(-76.827 -37.139)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M240.157,118.92l-12.647,5.006,12.647,10.948Z",
    transform: "translate(-71.084 -37.139)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M283.333,370.482l.557,8.624h-1.038l-2.62-8.809Zm-11.876-.186,2.95,8.809h1.135l-.688-8.809Zm-8.342-.254s3,9.064,3.115,9.064h1.059s-.8-8.94-.908-9.064Zm-8.548-.44,2.985,9.5H258.8l-.784-9.064Zm-13.066.193,6.877,9.311h1.946l-1.135-9.311Zm-10.9-.193,2.875,9.5h1.135l-.646-9.311Zm-7.915,0,2.8,9.5h1.1l-.873-9.311Zm-7.344,0L218,379.071h.949l-.688-9.5ZM207,369.34l2.95,9.731h1.176l-.908-9.5Z",
    transform: "translate(-64.678 -115.349)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M282.824,343.214,197.75,335.45l5.2,16,75.762,2.771Z",
    transform: "translate(-61.79 -104.765)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M229.543,127.96,185.71,90l8.28,168.792,36.344,4.442Z",
    transform: "translate(-58.029 -28.107)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M278.273,159.29l42.2,6.464-10.7,122.752-37.149-2.221Z",
    transform: "translate(-85.173 -49.748)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M191.529,379.374H172.267l-1.637-8.61,20.521-.454Z",
    transform: "translate(-53.32 -115.652)",
    fill: "#a96e92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M187.627,358.5l-25.2,1.293,1.589,7.372,23.808-.543Z",
    transform: "translate(-50.759 -111.964)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M322.443,347.049l-5.983,10.762-3.26-.117,4.009-10.955Z",
    transform: "translate(-97.846 -108.291)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M305.981,346.04l-3.191,11.175,3.156.11,4.821-11Z",
    transform: "translate(-94.595 -108.072)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M294.743,345.35l-2.373,11.381,3.067.117,3.652-11.237Z",
    transform: "translate(-91.341 -107.857)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M283.511,344.66l-1.561,11.594,2.971.11,2.489-11.471Z",
    transform: "translate(-88.086 -107.641)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M272.283,343.96l-.743,11.814,2.875.11,1.32-11.718Z",
    transform: "translate(-84.835 -107.423)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M249.132,341.729v12.7l-2.73-.1-.5-13Z",
    transform: "translate(-76.827 -106.601)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M233.86,339.86l1.678,13.754,2.792.1-.667-13.382Z",
    transform: "translate(-73.067 -106.142)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M221.82,338.39l2.854,14.5,2.854.1-1.334-14.07Z",
    transform: "translate(-69.307 -105.683)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M209.79,336.92l4.023,15.253,2.923.11-2.008-14.758Z",
    transform: "translate(-65.55 -105.224)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M197.75,335.45l5.2,16,2.985.11-2.675-15.439Z",
    transform: "translate(-61.79 -104.765)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M180.579,258.792l-23.5,2.826L142.77,113.677,172.3,90Z",
    transform: "translate(-44.618 -28.107)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M163.58,338.276l6.175,13.96,22.522-.784-5.2-16Z",
    transform: "translate(-51.118 -104.765)",
    fill: "#a96e92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M320.836,372.578l-2.3-.048-.832,7.537h2.235Z",
    transform: "translate(-99.252 -116.346)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M308.535,372.348l-2.249-.048-.626,7.7h2.077Z",
    transform: "translate(-95.491 -116.274)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M296.226,372.118l-2.194-.048-.413,7.853h1.926Z",
    transform: "translate(-91.731 -116.202)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M283.922,371.888l-2.139-.048-.213,8.012h1.774Z",
    transform: "translate(-87.968 -116.13)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M271.614,371.658l-.468,8.122H269.53v-8.17Z",
    transform: "translate(-84.207 -116.058)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M321.573,372.578l-2.3-.048-.839,7.537h2.235Z",
    transform: "translate(-99.48 -116.346)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M309.265,372.348l-2.249-.048-.626,7.7h2.084Z",
    transform: "translate(-95.719 -116.274)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M296.963,372.118l-2.194-.048-.419,7.853h1.926Z",
    transform: "translate(-91.959 -116.202)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M284.655,371.888l-2.139-.048-.206,8.012h1.767Z",
    transform: "translate(-88.199 -116.13)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M272.354,371.658l-.468,8.122H270.27v-8.17Z",
    transform: "translate(-84.439 -116.058)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M247.944,371.215l-.3,8.424h-1.513l-.378-8.479Z",
    transform: "translate(-76.781 -115.918)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M236.547,370.991l-.227,8.575-1.6.007-.378-8.624Z",
    transform: "translate(-73.217 -115.852)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M225.147,370.774l-.151,8.72-1.678.014-.378-8.768Z",
    transform: "translate(-69.657 -115.787)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M213.751,370.554l-.076,8.864-1.76.021-.385-8.919Z",
    transform: "translate(-66.093 -115.718)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M248.281,371.215l-.3,8.424h-1.52l-.378-8.479Z",
    transform: "translate(-76.884 -115.918)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M236.881,370.991l-.227,8.575-1.6.007-.378-8.624Z",
    transform: "translate(-73.323 -115.852)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M225.484,370.774l-.151,8.72-1.685.014-.378-8.768Z",
    transform: "translate(-69.76 -115.787)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M214.084,370.554l-.076,8.864-1.76.021-.378-8.919Z",
    transform: "translate(-66.199 -115.718)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M200.47,370.31l2.221.027v9.009l-1.843.027Z",
    transform: "translate(-62.639 -115.652)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M277.658,159.29l-.756.605L270.65,298.079l.612.021L272,286.285Z",
    transform: "translate(-84.557 -49.748)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M269.947,168.538l-20.4-7.118.722,136.822,13.788.5Z",
    transform: "translate(-77.967 -50.413)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M269.335,169.367l-19.785-6.9.722,136.1,13.2.481Z",
    transform: "translate(-77.967 -50.741)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M175.366,212.817l.8,12.172-16.381,4.436-1.025-11.264Zm-13.891,35.278,15.975-3.48-.811-12.234-16.2,4.387Zm-4.381-48.53.977,11.175,16.78-5.405-.791-12.09Zm5.041,55.826.97,10.79,15.6-2.428-.77-11.794Zm-6.712-74.408,1,11.079,17.192-6.389-.784-11.993Zm15.61-34.646-1.21-18.478-18.2,11,1.43,15.879Zm-17.3,16.085.99,11,17.577-7.379-.777-11.89Z",
    transform: "translate(-47.382 -39.932)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M163.972,266.441l-.921-10.219,15.191-3.308.75,11.2Zm-1.63-18.093-.97-10.735,15.6-4.222L177.726,245Zm-1.685-18.7L159.7,218.99l16-5.151.756,11.532Zm-1.685-18.7-.956-10.563,16.4-6.093.75,11.443Zm-1.7-18.684-.942-10.46,16.8-7.056.743,11.347Zm-1.664-18.7-.935-10.315,17.192-8.025.736,11.23Zm-1.685-18.684-1.375-15.26L170.141,129l1.162,17.777Z",
    transform: "translate(-47.673 -40.288)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M285.605,285.275l-6.505-.433L285.647,174.2l7.386,1.038Zm19.461-108.359-7.826-1.1-7.406,109.741,6.753.454Zm-4.25,109.342,6.815.454,8.809-108.2-7.152-1.011Z",
    transform: "translate(-87.196 -54.404)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M307.024,286.98l-6.189-.413,8.4-108.159,6.567.921Zm-11.044-.743-6.155-.413,7.365-109.108,7.221,1.011Zm-11-.736-5.907-.392,6.512-110.03,6.787.949Z",
    transform: "translate(-87.187 -54.679)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M310.69,325.435,312.7,299.53l.42,26.07Z",
    transform: "translate(-97.062 -93.547)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M288.176,175.1l2.709.385,1.568,37.692-1.4,20.686-3.727-44.5Z",
    transform: "translate(-89.767 -54.685)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M303.94,192.578l1.025-15.108,4.291.605.509,31.537-3.851,49.513Z",
    transform: "translate(-94.954 -55.426)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M298.345,323.556,296.66,303.49l.564-8.28,1.176,28.346Z",
    transform: "translate(-92.681 -92.197)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M273.45,170.81l1.767,36.117,1.582-34.955Z",
    transform: "translate(-85.432 -53.345)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M250.31,305.82l4.05,37.658-3.851-.138Z",
    transform: "translate(-78.205 -95.511)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M322.6,260.064l-1.1,13.52,1.829-93.484,3.679.516Z",
    transform: "translate(-100.438 -56.247)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M279.1,316.97l2.359-39.9,3.865,35.56L285,317.361Z",
    transform: "translate(-87.196 -86.532)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M218.588,266l-6.712-.97-1.334-128.817,6.141,3.755ZM196.85,127.86l4.669,135.667,6.107.887-1.375-130.791Zm25.988,138.747,6.732.977L228.408,147.15l-7.441-4.552Z",
    transform: "translate(-61.508 -39.932)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M228.984,267.857l-6.127-.887L221,143.771l6.829,4.174Zm-11-1.589-6.1-.88L210.554,137.4l5.5,3.383Zm-10.955-1.589-5.5-.8L196.89,129l8.8,5.378Z",
    transform: "translate(-61.521 -40.288)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M206.76,207.22l.289,27.576L197.91,129.67l5.075,3.1Zm4.848-69.174-.729-.447.44,42.52,6.671,65.254-.213-14.208Zm12.667,7.743-2.648-1.616,7.413,97.706-.124-11.856Zm2.682,121.934c-.55-7.565-2.661-36.667-4.766-65.33l.743,49.4.763,15.473Zm-25.114-3.638,2.366.344-4.064-49.568Z",
    transform: "translate(-61.84 -40.497)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M287.451,361.725,199.07,358.5l.2,8.122,87.377,1.616Z",
    transform: "translate(-62.202 -111.964)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M300.05,257.174l.027-.454,6.691.674-.034.454Z",
    transform: "translate(-93.739 -80.176)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M296.17,314.644l.027-.454,6.3.5-.034.454Z",
    transform: "translate(-92.528 -98.125)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M302.38,222.694l.027-.454,6.925.777-.034.454Z",
    transform: "translate(-94.467 -69.408)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M301.6,234.184l.027-.454,6.849.75-.034.447Z",
    transform: "translate(-94.223 -72.996)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M303.15,211.194l.027-.454,7.008.818-.034.454Z",
    transform: "translate(-94.708 -65.816)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M296.94,303.154l.034-.454,6.375.53-.034.454Z",
    transform: "translate(-92.768 -94.537)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M299.27,268.664l.027-.454,6.616.64-.034.454Z",
    transform: "translate(-93.496 -83.765)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M297.72,291.654l.027-.454,6.457.571-.034.454Z",
    transform: "translate(-93.012 -90.945)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M298.5,280.164l.027-.454,6.533.605-.034.454Z",
    transform: "translate(-93.255 -87.357)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M300.82,245.674l.034-.454,6.767.715-.034.454Z",
    transform: "translate(-93.98 -76.585)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M311.006,200.557l-7.076-.853.027-.454,7.083.853Z",
    transform: "translate(-94.951 -62.228)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M290.191,255.723l-.034.454-6.327-.633.048-.454Z",
    transform: "translate(-88.674 -79.667)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M289.436,267.265l-.034.454-6.272-.612.048-.447Z",
    transform: "translate(-88.455 -83.281)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M290.939,244.187l-.028.454-6.382-.667.048-.454Z",
    transform: "translate(-88.892 -76.054)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M282.44,278.677l.041-.447,6.2.571-.027.454Z",
    transform: "translate(-88.239 -86.894)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M293.2,209.573l-.034.454-6.547-.763.048-.454Z",
    transform: "translate(-89.545 -65.213)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M293.946,198.038l-.028.454-6.609-.8.055-.454Z",
    transform: "translate(-89.76 -61.6)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M292.446,221.109l-.027.454-6.5-.729.048-.454Z",
    transform: "translate(-89.326 -68.827)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M291.691,232.651l-.028.454-6.444-.7.048-.454Z",
    transform: "translate(-89.108 -72.44)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M313.23,304.514l.041-.454,6.285.53-.041.454Z",
    transform: "translate(-97.856 -94.961)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M315.01,281.687l.034-.447,6.34.585-.034.454Z",
    transform: "translate(-98.412 -87.834)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M315.89,270.274l.041-.454,6.361.612-.034.454Z",
    transform: "translate(-98.686 -84.268)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M314.12,293.1l.034-.454,6.313.557-.034.454Z",
    transform: "translate(-98.134 -91.398)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M316.78,258.864l.034-.454,6.4.64-.041.454Z",
    transform: "translate(-98.964 -80.704)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M311.46,327.344l.034-.454,6.237.468-.041.454Z",
    transform: "translate(-97.303 -102.092)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M312.35,315.934l.034-.454,6.258.5-.034.454Z",
    transform: "translate(-97.581 -98.528)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M295.424,325.69l6.224.461-.041.454-6.217-.468Z",
    transform: "translate(-92.284 -101.717)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M279.727,324.51l5.962.447-.034.454-5.955-.447Z",
    transform: "translate(-87.384 -101.348)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M317.67,247.444l.034-.454,6.416.674-.034.454Z",
    transform: "translate(-99.242 -77.138)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M311.859,189.1,304.7,188.2l.034-.454,7.159.894Z",
    transform: "translate(-95.192 -58.636)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M280.408,312.94l6.031.474-.034.454-6.024-.475Z",
    transform: "translate(-87.596 -97.735)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M281.784,289.8l6.148.536-.027.454-6.155-.543.014-.2Z",
    transform: "translate(-88.024 -90.508)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M294.674,186.956l-6.664-.832.055-.454,6.636.832Z",
    transform: "translate(-89.979 -57.986)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M287.184,301.879l-.028.454-6.086-.509.027-.454Z",
    transform: "translate(-87.812 -94.121)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M320.33,213.2l.034-.454,6.5.763-.034.454Z",
    transform: "translate(-100.073 -66.444)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M328.657,191.2l-6.547-.811.034-.454,6.547.818Z",
    transform: "translate(-100.629 -59.317)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M319.44,224.614l.041-.454,6.464.736-.034.454Z",
    transform: "translate(-99.795 -70.007)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M318.56,236.034l.034-.454,6.444.7-.034.454Z",
    transform: "translate(-99.52 -73.574)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M321.22,201.794l.034-.454,6.526.791-.041.454Z",
    transform: "translate(-100.351 -62.88)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M249.77,203.325l-.22-40.855,3.04,1.059,7.468,135.4-2.228-.083Z",
    transform: "translate(-77.967 -50.741)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M268.385,263.212l-1.671,36.97-.234-.007L259.94,166.09l7.166,2.5Z",
    transform: "translate(-81.212 -51.871)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M300.05,256.924l.027-.454,6.691.674-.034.454Z",
    transform: "translate(-93.739 -80.098)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M296.17,314.394l.027-.454,6.3.5-.034.454Z",
    transform: "translate(-92.528 -98.047)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M302.38,222.444l.027-.454,6.925.784-.034.454Z",
    transform: "translate(-94.467 -69.33)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M301.6,233.934l.027-.454,6.849.75-.034.454Z",
    transform: "translate(-94.223 -72.918)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M303.15,210.944l.027-.454,7.008.825-.034.447Z",
    transform: "translate(-94.708 -65.738)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M296.94,302.9l.034-.454,6.375.536-.034.454Z",
    transform: "translate(-92.768 -94.459)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M299.27,268.424l.027-.454,6.616.64-.034.447Z",
    transform: "translate(-93.496 -83.69)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M297.72,291.411l.027-.461,6.457.571-.034.454Z",
    transform: "translate(-93.012 -90.867)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M298.5,279.914l.027-.454,6.533.605-.034.454Z",
    transform: "translate(-93.255 -87.278)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M300.82,245.434l.034-.454,6.767.708-.034.454Z",
    transform: "translate(-93.98 -76.51)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M311.006,200.307l-7.076-.853.027-.454,7.083.86Z",
    transform: "translate(-94.951 -62.15)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M290.191,255.473l-.034.461-6.327-.64.048-.454Z",
    transform: "translate(-88.674 -79.589)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M289.436,267.015l-.034.454-6.272-.605.048-.454Z",
    transform: "translate(-88.455 -83.203)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M290.939,243.937l-.028.454-6.382-.667.048-.454Z",
    transform: "translate(-88.892 -75.976)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M282.44,278.434l.041-.454,6.2.571-.027.454Z",
    transform: "translate(-88.239 -86.816)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M293.2,209.323l-.034.454-6.547-.763.048-.454Z",
    transform: "translate(-89.545 -65.135)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M293.946,197.791l-.028.454-6.609-.8.055-.447Z",
    transform: "translate(-89.76 -61.525)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M292.446,220.866l-.027.454-6.5-.736.048-.454Z",
    transform: "translate(-89.326 -68.749)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M291.691,232.4l-.028.454-6.444-.7.048-.454Z",
    transform: "translate(-89.108 -72.362)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M313.23,304.264l.041-.454,6.285.53-.041.454Z",
    transform: "translate(-97.856 -94.883)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M315.01,281.437l.034-.447,6.34.585-.034.454Z",
    transform: "translate(-98.412 -87.756)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M315.89,270.024l.041-.454,6.361.619-.034.454Z",
    transform: "translate(-98.686 -84.19)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M314.12,292.854l.034-.454,6.313.557-.034.454Z",
    transform: "translate(-98.134 -91.32)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M316.78,258.614l.034-.454,6.4.646-.041.447Z",
    transform: "translate(-98.964 -80.626)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M311.46,327.094l.034-.454,6.237.468-.041.454Z",
    transform: "translate(-97.303 -102.013)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M312.35,315.684l.034-.454,6.258.5-.034.454Z",
    transform: "translate(-97.581 -98.45)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M295.424,325.44l6.224.468-.041.447-6.217-.461Z",
    transform: "translate(-92.284 -101.639)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M279.727,324.26l5.962.447-.034.454-5.955-.447Z",
    transform: "translate(-87.384 -101.27)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M317.67,247.2l.034-.447,6.416.667-.034.454Z",
    transform: "translate(-99.242 -77.063)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M311.859,188.848l-7.159-.894.034-.454,7.159.894Z",
    transform: "translate(-95.192 -58.558)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M280.408,312.69l6.031.474-.034.454-6.024-.475Z",
    transform: "translate(-87.596 -97.657)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M281.784,289.55l6.148.543-.027.454L281.75,290l.014-.206Z",
    transform: "translate(-88.024 -90.43)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M294.674,186.709l-6.664-.832.055-.447,6.636.825Z",
    transform: "translate(-89.979 -57.912)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M287.184,301.629l-.028.454-6.086-.509.027-.454Z",
    transform: "translate(-87.812 -94.043)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M320.33,212.954l.034-.454,6.5.763-.034.454Z",
    transform: "translate(-100.073 -66.366)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M328.657,190.952l-6.547-.818.034-.454,6.547.818Z",
    transform: "translate(-100.629 -59.239)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M319.44,224.374l.041-.454,6.464.729-.034.454Z",
    transform: "translate(-99.795 -69.933)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M318.56,235.784l.034-.454,6.444.7-.034.454Z",
    transform: "translate(-99.52 -73.496)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M321.22,201.544l.034-.454,6.526.791-.041.454Z",
    transform: "translate(-100.351 -62.802)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M250.369,303.25l15.06,2.022-.027.605-15.1-2.029v-.1Z",
    transform: "translate(-78.202 -94.708)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M250.442,318.77l14.545,1.6-.027.605-14.579-1.6v-.028Z",
    transform: "translate(-78.227 -99.556)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M250.286,287.72l15.576,2.455-.028.605-15.617-2.455-.007-.158Z",
    transform: "translate(-78.174 -89.858)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M250.206,272.19l16.092,2.888-.021.612-16.147-2.9V272.6Z",
    transform: "translate(-78.149 -85.008)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M250.57,350.435l.034-.605,13.52.729-.027.605Z",
    transform: "translate(-78.286 -109.256)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M250.525,334.3l14.029,1.162-.028.605-14.056-1.162Z",
    transform: "translate(-78.255 -104.406)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M249.723,179.03l19.207,5.495-.034.626-19.255-5.515v-.316Z",
    transform: "translate(-77.996 -55.913)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M249.883,210.08l18.169,4.628-.027.619-18.217-4.642-.007-.282Z",
    transform: "translate(-78.046 -65.61)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M249.8,194.55l18.684,5.061-.028.619-18.739-5.075v-.3Z",
    transform: "translate(-78.021 -60.76)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M250.126,256.66l16.614,3.322-.027.612-16.663-3.328v-.22Z",
    transform: "translate(-78.124 -80.158)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M250.046,241.14l17.13,3.755-.027.612-17.178-3.769V241.5Z",
    transform: "translate(-78.099 -75.311)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M249.966,225.61l17.653,4.188-.028.619-17.7-4.2v-.268Z",
    transform: "translate(-78.074 -70.46)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M250.369,302.73l15.06,2.015-.027.612-15.1-2.029v-.1Z",
    transform: "translate(-78.202 -94.546)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M250.442,318.25l14.545,1.589-.027.612-14.579-1.6v-.028Z",
    transform: "translate(-78.227 -99.393)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M250.286,287.2l15.576,2.448-.028.612L250.217,287.8l-.007-.151Z",
    transform: "translate(-78.174 -89.696)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M250.206,271.67l16.092,2.888-.021.605-16.147-2.888v-.193Z",
    transform: "translate(-78.149 -84.846)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M250.57,349.915l.034-.605,13.52.729-.027.605Z",
    transform: "translate(-78.286 -109.094)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M250.525,333.78l14.029,1.162-.028.605-14.056-1.162Z",
    transform: "translate(-78.255 -104.243)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M249.723,178.5,268.93,184l-.034.619-19.255-5.515V178.8Z",
    transform: "translate(-77.996 -55.747)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M249.883,209.56l18.169,4.621-.027.619-18.217-4.635-.007-.282Z",
    transform: "translate(-78.046 -65.448)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M249.8,194.03l18.684,5.061-.028.619-18.739-5.075v-.3Z",
    transform: "translate(-78.021 -60.597)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M250.126,256.14l16.614,3.322-.027.612-16.663-3.328v-.22Z",
    transform: "translate(-78.124 -79.995)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M250.046,240.61l17.13,3.755-.027.619-17.178-3.769v-.241Z",
    transform: "translate(-78.099 -75.145)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M249.966,225.09l17.653,4.188-.028.612-17.7-4.2v-.261Z",
    transform: "translate(-78.074 -70.298)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M232.557,191.755l-.007-.5L239.221,194v.488Z",
    transform: "translate(-72.658 -59.732)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M232.347,177.722l-.007-.5,6.726,2.916v.5Z",
    transform: "translate(-72.593 -55.347)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M222.5,158.784l.007.5-5.57-2.544-.007-.5Z",
    transform: "translate(-67.78 -48.795)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M222.7,173.044l.007.5-5.618-2.434-.007-.5Z",
    transform: "translate(-67.827 -53.283)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M238.911,166.777l-6.774-3.095-.007-.5,6.774,3.095Z",
    transform: "translate(-72.527 -50.963)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M232.774,205.8l-.014-.488,6.616,2.551.007.488Z",
    transform: "translate(-72.724 -64.12)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M233.2,233.881l-.007-.481,6.505,2.187v.481Z",
    transform: "translate(-72.858 -72.893)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M232.987,219.838l-.007-.488,6.554,2.373.007.481Z",
    transform: "translate(-72.792 -68.505)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M224.058,273l.007.468-5.928-1.534-.007-.474Z",
    transform: "translate(-68.155 -84.78)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M233.407,247.921l-.007-.481,6.45,2.008v.475Z",
    transform: "translate(-72.924 -77.278)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M222.89,187.307l.007.5-5.66-2.324-.007-.488Z",
    transform: "translate(-67.873 -57.774)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M223.86,258.7l.007.468-5.88-1.678-.007-.474Z",
    transform: "translate(-68.108 -80.27)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M224.249,287.309l.007.468-5.969-1.389-.007-.468Z",
    transform: "translate(-68.201 -89.296)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M218.437,300.841l-.007-.461,6.017,1.238.007.461Z",
    transform: "translate(-68.248 -93.812)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M223.088,201.571l.007.488-5.708-2.2-.007-.488Z",
    transform: "translate(-67.92 -62.265)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M223.477,230.126l.007.481-5.8-1.946-.007-.481Z",
    transform: "translate(-68.014 -71.263)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M223.279,215.847l.007.488-5.749-2.084-.007-.481Z",
    transform: "translate(-67.967 -66.763)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M223.668,244.412l.007.474-5.838-1.815-.007-.481Z",
    transform: "translate(-68.061 -75.763)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M199.666,207.32l7.4,2.675v.488l-7.468-2.7-.007-.248Z",
    transform: "translate(-62.364 -64.748)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M200.689,237.27l6.9,2.146.007.481-6.973-2.173-.007-.241Z",
    transform: "translate(-62.686 -74.102)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M200.176,222.3l7.152,2.407.007.481-7.228-2.434-.007-.241Z",
    transform: "translate(-62.523 -69.427)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M233.617,261.964l-.007-.474,6.4,1.822.007.474Z",
    transform: "translate(-72.989 -81.666)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M197.616,147.44,206,151.27l.007.5-8.472-3.872-.014-.254Z",
    transform: "translate(-61.718 -46.047)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M201.705,267.21l6.416,1.664.007.468-6.471-1.678-.007-.234Z",
    transform: "translate(-63.008 -83.453)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M199.153,192.35l7.647,2.95v.488l-7.723-2.978-.007-.248Z",
    transform: "translate(-62.202 -60.073)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M198.129,162.41l8.135,3.528.007.5-8.225-3.562-.007-.254Z",
    transform: "translate(-61.88 -50.722)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M198.643,177.38l7.895,3.239v.488l-7.97-3.266-.007-.248Z",
    transform: "translate(-62.043 -55.397)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M201.192,252.24l6.664,1.9.007.468-6.726-1.919-.007-.234Z",
    transform: "translate(-62.845 -78.777)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M234.467,318.141l-.007-.461,6.175,1.1.007.461Z",
    transform: "translate(-73.255 -99.215)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M234.257,304.1l-.007-.468,6.23,1.279.007.468Z",
    transform: "translate(-73.189 -94.827)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M234.047,290.048l-.007-.468,6.285,1.465v.468Z",
    transform: "translate(-73.123 -90.439)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M233.834,276l-.014-.475,6.34,1.65.007.468Z",
    transform: "translate(-73.055 -86.051)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M202.728,297.15l5.928,1.224.007.461-5.976-1.224-.007-.234Z",
    transform: "translate(-63.329 -92.803)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M218.58,314.85l6.059,1.08.007.468-6.059-1.08Z",
    transform: "translate(-68.295 -98.331)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M202.215,282.18l6.175,1.437v.468l-6.217-1.444-.014-.241Z",
    transform: "translate(-63.167 -88.128)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M203.19,312.35l.041-.22,5.687,1.011.007.461-5.722-1.018Z",
    transform: "translate(-63.489 -97.482)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M232.557,191.415l-.007-.5,6.671,2.73v.5Z",
    transform: "translate(-72.658 -59.626)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M232.347,177.375l-.007-.5,6.726,2.909v.5Z",
    transform: "translate(-72.593 -55.241)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M222.5,158.444l.007.5-5.57-2.544-.007-.5Z",
    transform: "translate(-67.78 -48.689)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M222.7,172.694l.007.5-5.618-2.434-.007-.5Z",
    transform: "translate(-67.827 -53.174)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M238.911,166.43l-6.774-3.088-.007-.5,6.774,3.095Z",
    transform: "translate(-72.527 -50.856)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M232.774,205.448l-.014-.488,6.616,2.551.007.488Z",
    transform: "translate(-72.724 -64.011)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M233.2,233.531l-.007-.481,6.505,2.187v.481Z",
    transform: "translate(-72.858 -72.784)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M232.987,219.491l-.007-.481,6.554,2.366.007.488Z",
    transform: "translate(-72.792 -68.399)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M224.058,272.66l.007.468-5.928-1.54-.007-.468Z",
    transform: "translate(-68.155 -84.674)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M233.407,247.574l-.007-.474,6.45,2v.481Z",
    transform: "translate(-72.924 -77.172)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M222.89,186.957l.007.5-5.66-2.317-.007-.5Z",
    transform: "translate(-67.873 -57.665)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M223.86,258.358l.007.475-5.88-1.678-.007-.474Z",
    transform: "translate(-68.108 -80.164)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M224.249,286.959l.007.468-5.969-1.389-.007-.468Z",
    transform: "translate(-68.201 -89.187)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M218.437,300.5l-.007-.468,6.017,1.238.007.468Z",
    transform: "translate(-68.248 -93.703)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M223.088,201.231l.007.488-5.708-2.2-.007-.488Z",
    transform: "translate(-67.92 -62.159)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M223.477,229.783l.007.481-5.8-1.953-.007-.481Z",
    transform: "translate(-68.014 -71.154)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M223.279,215.507l.007.481-5.749-2.077-.007-.481Z",
    transform: "translate(-67.967 -66.656)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M223.668,244.065l.007.481-5.838-1.822-.007-.474Z",
    transform: "translate(-68.061 -75.657)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M199.666,206.98l7.4,2.675v.481l-7.468-2.7-.007-.248Z",
    transform: "translate(-62.364 -64.642)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M200.689,236.92l6.9,2.152.007.475-6.973-2.166-.007-.241Z",
    transform: "translate(-62.686 -73.993)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M200.176,221.95l7.152,2.407.007.481-7.228-2.428-.007-.248Z",
    transform: "translate(-62.523 -69.317)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M233.617,261.615l-.007-.474,6.4,1.829.007.474Z",
    transform: "translate(-72.989 -81.557)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M197.616,147.1,206,150.924l.007.5-8.472-3.865-.014-.254Z",
    transform: "translate(-61.718 -45.941)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M201.705,266.87l6.416,1.664.007.468-6.471-1.678-.007-.234Z",
    transform: "translate(-63.008 -83.346)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M199.153,192.01l7.647,2.95v.488l-7.723-2.978-.007-.248Z",
    transform: "translate(-62.202 -59.967)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M198.129,162.07l8.135,3.528.007.5-8.225-3.562-.007-.254Z",
    transform: "translate(-61.88 -50.616)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M198.643,177.04l7.895,3.232v.5l-7.97-3.266-.007-.254Z",
    transform: "translate(-62.043 -55.291)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M201.192,251.9l6.664,1.9.007.475-6.726-1.919-.007-.241Z",
    transform: "translate(-62.845 -78.671)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M234.467,317.8l-.007-.461,6.175,1.1.007.461Z",
    transform: "translate(-73.255 -99.109)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M234.257,303.751l-.007-.461,6.23,1.279.007.461Z",
    transform: "translate(-73.189 -94.721)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M234.047,289.708l-.007-.468,6.285,1.465v.468Z",
    transform: "translate(-73.123 -90.333)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M233.834,275.664l-.014-.474,6.34,1.644.007.468Z",
    transform: "translate(-73.055 -85.945)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M202.728,296.81l5.928,1.217.007.468-5.976-1.231-.007-.234Z",
    transform: "translate(-63.329 -92.697)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M218.58,314.51l6.059,1.08.007.461-6.059-1.08Z",
    transform: "translate(-68.295 -98.225)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M202.215,281.84l6.175,1.437v.468l-6.217-1.451-.014-.234Z",
    transform: "translate(-63.167 -88.022)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M203.19,312.007l.041-.227,5.687,1.011.007.468-5.722-1.025Z",
    transform: "translate(-63.489 -97.372)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M297.5,356.769,301,348.792l-.626,8.08Zm-4.36-.158.2-9.628-3.095,9.531Zm-7.008-.254-.818-10.9-2.331,10.755Zm-7.269-.268-.193-11.732-1.6-.1-1.32,11.691Z",
    transform: "translate(-86.153 -107.516)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M275.413,371.885l-.144,1.2-83.994.3-20.287-.756-.358-1.871,20.521-.454Z",
    transform: "translate(-53.32 -115.652)",
    fill: "#792935",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M175.036,198.353l-16.47,9.944-.516-5.722,16.8-7.056Z",
    transform: "translate(-49.391 -61.063)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M173.032,170.415l-16.917,10.212-.5-5.5,17.192-8.025Z",
    transform: "translate(-48.632 -52.187)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M183.059,309.9l-14.675,8.864-.564-6.23,15.191-3.308Z",
    transform: "translate(-52.442 -96.576)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M170.407,133.216l-17.082,15.335-.8-8.919L170.132,129Z",
    transform: "translate(-47.664 -40.288)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M177.063,226.546l-16.016,9.669-.557-6.175,16.4-6.1Z",
    transform: "translate(-50.153 -69.939)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M181.066,282.237l-15.115,9.126-.571-6.34,15.6-4.222Z",
    transform: "translate(-51.68 -87.697)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M179.063,254.371l-15.569,9.4-.564-6.251,16-5.151Z",
    transform: "translate(-50.915 -78.818)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M179.644,352.063q-.124-2.586-.124-5.22c0-38.73,20.507-70.144,45.807-70.144s45.807,31.4,45.807,70.144q0,2.634-.124,5.22Z",
    transform: "translate(-56.096 -86.416)",
    fill: "#792935",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M388.64,385.672h99.811l-.949-1.362H389.383Z",
    transform: "translate(-121.407 -120.025)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M421.333,385.672l-.646-1.362h-31.3l-.743,1.362Z",
    transform: "translate(-121.407 -120.025)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M514.3,368.06l-.055.076-.213,1.8,1.788.165.076-.055Z",
    transform: "translate(-160.568 -114.95)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 0.475,
    cy: 0.475,
    r: 0.475,
    transform: "translate(356.157 251.343)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M516.87,378.59h.3v-3.452l.3-3.294.763-5.653-.3-.041-.763,5.66-.3,3.315Z",
    transform: "translate(-161.455 -114.353)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M518.441,367.519l-1.018-.179.22.344-.358,2.5-.3.488,1.293.089-.282-.523.275-2.483Z",
    transform: "translate(-161.493 -114.725)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M517.3,379.158l-1.252-.138.248.392-.371,2.881h-.165v.316l1.774.048v-.3h-.261l-.138-2.861Z",
    transform: "translate(-161.109 -118.373)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M520.606,368.99l-1.41.124-.1,1.561,1.32.179Z",
    transform: "translate(-162.152 -115.24)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M519.153,370.115l-.729-.055-.014.22.722.083Z",
    transform: "translate(-161.936 -115.574)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M517.5,369.617l-.784-.117-.034.227.791.076Z",
    transform: "translate(-161.396 -115.399)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M516.071,368.369l-.131,1.678-1.76-.151.165-1.836Z",
    transform: "translate(-160.615 -114.95)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M520.5,369.23l-.11,1.554-1.128-.131.083-1.368Z",
    transform: "translate(-162.202 -115.315)",
    fill: "#e5bfa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M516,368.522l-.1,1.437-1.5-.117.11-1.6Z",
    transform: "translate(-160.684 -115.006)",
    fill: "#f4f7c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M521.206,368.99l.11.014-.172,1.85h-.124Z",
    transform: "translate(-162.751 -115.24)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M518.67,366.378a.358.358,0,0,0,.055-.688.474.474,0,0,1,.131.364.509.509,0,0,1-.186.323Z",
    transform: "translate(-162.018 -114.209)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M518.17,367.59l.447.062-.11.144-.337,2.469.193.44-.413-.041a.4.4,0,0,0,.131-.2c0-.117.316-2.682.316-2.682Z",
    transform: "translate(-161.793 -114.803)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M517.551,379.351l-.124.22.124,2.813H517.2l.055-2.84-.055-.234Z",
    transform: "translate(-161.558 -118.463)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M486.472,370.337l-.364,9.119H443.547l-.337-10.666Z",
    transform: "translate(-138.45 -115.178)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M494.668,368.99l1.54,10.535h-1.32L489.38,368.99Z",
    transform: "translate(-152.87 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M487.328,368.99l3.968,10.528h-1.045L485.98,368.99Z",
    transform: "translate(-151.808 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M476.268,368.99l1.54,10.535h-1.32L470.98,368.99Z",
    transform: "translate(-147.123 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M468.928,368.99l3.968,10.528h-1.045L467.58,368.99Z",
    transform: "translate(-146.061 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M456.568,368.99l1.54,10.535h-1.32L451.28,368.99Z",
    transform: "translate(-140.971 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M449.228,368.99l3.968,10.528h-1.052L447.88,368.99Z",
    transform: "translate(-139.909 -115.24)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M489.948,219.16,435.16,195.07l5.213,112.43,45.972,3.383Z",
    transform: "translate(-135.936 -60.922)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M420.719,195.07l-31.8,23.546L399.3,310.044l26.627-2.544Z",
    transform: "translate(-121.495 -60.922)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M477.634,206.9l6.643,104.3h-2.792l-24-112.382Zm-29.488-11.367,23.828,114.486H474.8L453.208,196.856Zm-9.256-3.239,20.122,116.638,1.616.53L442.8,194.525Z",
    transform: "translate(-137.101 -60.054)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M498.7,216.38l9.036,49.837,1.939-43.489Z",
    transform: "translate(-155.781 -67.578)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M414.064,198.93V311.284h-3.638l-7.276-108.035Zm-14.338,6.98-10.666,6.375L401.486,312.1l3.012-.688Z",
    transform: "translate(-121.538 -62.128)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M439.01,276.92l9.579,58.453-7.014-1.059Z",
    transform: "translate(-137.139 -86.485)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M432.279,379.456H408.547l-1.417-9.676,24.812-.99Z",
    transform: "translate(-127.182 -115.178)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M409.87,370.028l5.8-.248,1.169,9.985H411Z",
    transform: "translate(-128.038 -115.487)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 0.44,
    height: 59.842,
    transform: "translate(298.911 134.724) rotate(-66.29)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M434.47,195.314l5.178,112.43h.55l-.509-11,6.141.756.392,10.776h.55l-.358-10.721,6.141.756.261,10.432h.55l-.261-10.315,6.141.756.138,10.081h.55l-.138-10.006,6.141.756v9.738h.55v-9.669l6.141.756-.1,9.394h.55l.1-9.332,6.134.756-.227,8.961h.55l.22-8.995,6.134.756-.344,8.706h.55l3.6-91.723h-.55l-.447,11.319-7.124-2.751.3-11.979h-.55l-.289,11.78-7.124-2.751.138-12.44h-.55l-.138,12.234-7.118-2.751V209.116h-.557v12.695l-7.111-2.751-.186-13.375h-.55l.186,13.155-7.111-2.751-.358-13.912h-.55l.344,13.616-7.1-2.751-.516-14.311h-.55l.509,14.077-7.1-2.751L435,195.28Zm8.349,17.88.5,13.685-6.939-2.421-.653-14.022Zm-4.429,54.754,6.457,1.417.5,13.706-6.3-1.087Zm20.672-22.006L465.849,248v12.626l-6.629-1.754Zm-.371,12.812-6.664-1.733-.337-13.32,6.781,2.063ZM466.4,248.2l6.787,2.063-.138,12.268-6.629-1.754Zm7.338,2.256,6.787,2.063-.3,11.966-6.629-1.754Zm6.485,14.366-.3,11.918-6.471-1.423.138-12.248Zm-7.31,10.37-6.464-1.424V261.16l6.622,1.754Zm-7.021-1.54-6.464-1.424-.179-12.963,6.622,1.754Zm-6.987-1.54-6.464-1.424-.337-13.32,6.622,1.754Zm-7.021-1.54-6.464-1.423-.5-13.678,6.616,1.754Zm-7-15.445-.5-13.678,6.781,2.063.337,13.341Zm-.509-14.022-.488-13.692,6.939,2.421.337,13.334Zm7-11.051,6.946,2.421.179,12.977-6.787-2.063Zm7.5,2.62,6.946,2.428v12.619l-6.787-2.063Zm7.5,2.62,6.98,2.434-.138,12.261-6.794-2.063Zm7.5,2.62,6.952,2.428-.3,11.9-6.794-2.063Zm7.5,2.62,6.959,2.428-.454,11.546-6.8-2.063Zm6.492,14.318L487.4,266.4l-6.636-1.754.3-11.89Zm-.468,11.89-.454,11.553-6.471-1.424.3-11.89Zm-.468,11.89-.454,11.56L480.16,289.1l.3-11.89ZM479.61,289l-6.265-1.08.138-12.248,6.464,1.424Zm-6.877-1.183-6.265-1.107V274.109l6.464,1.423Zm-6.877-1.183-6.265-1.107-.179-12.963,6.464,1.417Zm-6.877-1.183-6.306-1.087-.337-13.32,6.457,1.417Zm-6.877-1.183-6.3-1.087-.5-13.678,6.457,1.417Zm-14.379-30.733,6.615,1.754.5,13.706-6.464-1.417Zm-.688-14.38,6.774,2.063.5,13.7-6.622-1.754Zm-.688-14.38,6.939,2.421.5,13.692L437,238.831Zm14.084-8.644.337,13.334-6.946-2.421-.5-13.664Zm7.7,3.019.179,12.977-6.973-2.448-.31-13.279Zm7.647,2.957v12.619l-6.953-2.428-.179-12.949Zm7.661,2.978-.138,12.261-6.953-2.428v-12.6Zm7.688,3.005-.3,11.9-6.959-2.428.138-12.241Zm7.668,2.978-.454,11.546-6.966-2.428.3-11.883Zm-8.94,70.261.3-11.89,6.3,1.087L486,302.091Zm-6.691-.825.138-12.255,6.3,1.087-.3,11.918Zm-6.691-.825V287.072l6.3,1.087-.138,12.282Zm-6.691-.825-.193-13,6.3,1.087v12.64Zm-6.691-.825-.337-13.327,6.3,1.087.179,13Zm-6.7-.825-.5-13.685,6.3,1.087.337,13.355Zm-6.7-.825-.653-14.043,6.3,1.087.5,13.712Z",
    transform: "translate(-135.721 -60.988)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 39.37,
    height: 0.44,
    transform: "matrix(0.805, -0.594, 0.594, 0.805, 267.521, 157.824)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M483.126,379.522l.275-9.277h.22l-.275,9.277Zm-2.228,0,.241-9.366h-.22l-.241,9.366Zm-2.448,0,.206-9.456h-.213l-.206,9.456Zm-2.448,0,.172-9.545h-.22l-.172,9.545Zm-2.448,0,.138-9.628h-.22l-.138,9.628Zm-2.448,0,.1-9.724h-.22l-.1,9.724Zm-2.448,0,.062-9.813h-.22l-.062,9.813Zm-2.448,0v-9.9h-.22v9.9Zm-2.668,0h.22V369.53h-.22Zm-2.448,0h.22l-.062-10.081h-.22Zm-2.448,0h.22l-.076-10.171h-.22Zm-2.448,0h.22l-.117-10.26h-.22Zm-2.448,0h.22l-.151-10.315h-.22Zm-2.448,0h.22l-.186-10.439h-.22Zm-2.448,0h.22L448.81,369h-.22Z",
    transform: "translate(-140.131 -115.243)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M483.316,379.522l.275-9.277h.22l-.275,9.277Zm-2.228,0,.241-9.366h-.22l-.241,9.366Zm-2.448,0,.206-9.456h-.22l-.206,9.456Zm-2.448,0,.172-9.545h-.22l-.172,9.545Zm-2.448,0,.138-9.628h-.22l-.138,9.628Zm-2.448,0,.1-9.724h-.22l-.1,9.724Zm-2.448,0,.027-9.834h-.22l-.062,9.813Zm-2.448,0v-9.9h-.22v9.9Zm-2.668,0h.22V369.53h-.22Zm-2.448,0h.22l-.041-10.081h-.22Zm-2.448,0h.22l-.076-10.171h-.22Zm-2.448,0h.22l-.117-10.26h-.22Zm-2.448,0h.22l-.151-10.315h-.261Zm-2.448,0h.193l-.186-10.439h-.22Zm-2.448,0h.22L449,369h-.22Z",
    transform: "translate(-140.19 -115.243)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M388.76,220.5l10.384,91.462.55-.062-.86-7.6,3.3-.736.818,8.032.55-.055-.825-8.135,3.3-.743.777,8.527.55-.048-.791-8.624,3.308-.743.736,9.029.55-.048-.743-9.1,3.315-.715.688,9.524.55-.041-.688-9.628,3.315-.743.633,10.02.55-.034-.633-10.109,3.315-.743.571,10.522h.55l-.6-10.625,3.624-.811-.076-.323-3.548.8L421.184,285l3.734-1.128-.1-.316-3.652,1.1-.75-13.754,3.844-1.437-.117-.309-3.741,1.375-.75-13.754,3.947-1.754-.138-.3-3.83,1.705-.75-13.754,4.057-2.063-.151-.3-3.927,2.008-.743-13.719,4.126-2.386-.165-.289-4.016,2.3-.743-13.706,4.264-2.709-.179-.282-4.126,2.606-.756-13.96h-.55l.777,14.269-3.927,2.489-.846-13.43-.55.034L412.3,217.3l-3.927,2.5-.88-12.8-.55.041.949,13.2-3.947,2.517-1-12.378-.55.048,1.032,12.667-3.94,2.5-1.08-11.849-.55.048,1.107,12.131-3.947,2.5L393.856,217.1l-.55.055,1.183,11.6-3.954,2.51-1.224-10.81Zm5.763,8.6,1.231,12.048-3.844,2.228-1.334-11.746Zm11.594,20.19,3.727-1.9.935,13.066-3.624,1.609Zm.5,12.983L403,263.887l-1.135-12.42,3.727-1.9Zm4.181-1.5.935,13.066-3.555,1.3-1.038-12.757Zm-3.122,14.565-3.521,1.32-1.135-12.426,3.624-1.609Zm-4.057,1.52-3.521,1.32-1.245-12.11,3.624-1.609Zm-4.814-11.127-1.238-12.089,3.734-1.9,1.135,12.378Zm-1.272-12.447L396.3,241.207,400.141,239l1.135,12.378Zm3.129-14.593,3.83-2.2,1.032,12.708-3.734,1.9Zm4.36-2.5,3.83-2.2.935,13.066-3.727,1.9Zm4.36-2.5,3.824-2.2.839,13.362-3.727,1.9Zm4.69,11.519.839,13.369-3.624,1.609-.942-13.066Zm.86,13.719.839,13.369-3.507,1.341-.942-13.066Zm.86,13.719.86,13.369-3.438,1.032-.942-13.066Zm-3.122,14.565-3.438,1.032-1.038-12.763,3.521-1.32Zm-3.961,1.19-3.438,1.032L404.137,277l3.562-1.3Zm-3.954,1.19-3.438,1.032-1.238-12.1,3.521-1.32Zm-3.954,1.19-3.438,1.025-1.334-11.78,3.514-1.32ZM395.988,279.7,394.7,267.931l3.624-1.609,1.231,12.062Zm-1.375-12.117-1.286-11.753,3.734-1.9,1.231,12.062Zm-1.375-12.117L391.9,243.7l3.844-2.207,1.231,12.055Zm5.7-29.206,1.128,12.378-3.837,2.207L395,228.767Zm4.456-2.833,1.032,12.7-3.837,2.2-1.135-12.378Zm4.456-2.833,1.018,13.045-3.83,2.2L404,223.107Zm4.456-2.826.839,13.355-3.83,2.2-.935-13.066Zm5.2,10.852-3.824,2.194-.839-13.382,3.92-2.489Zm.818,14.077-3.72,1.9-.839-13.389,3.824-2.194Zm.763,14.049-3.624,1.609-.839-13.4,3.72-1.9Zm.784,14.043-3.521,1.32L415.5,258.7l3.617-1.609Zm.763,14.049-3.438,1.032-.846-13.417,3.521-1.32Zm-2.558,14.792L417.23,286.2l3.438-1.032.743,13.706Zm-3.879.832-.942-13.066,3.438-1.032.818,13.41Zm-3.858.866L409.3,288.561l3.438-1.032.935,13.066Zm-3.851.866-1.135-12.44,3.438-1.032,1.032,12.722Zm-3.851.86-1.238-12.11,3.438-1.025,1.135,12.378Zm-3.844.86-1.341-11.78,3.438-1.025,1.2,12.1Z",
    transform: "translate(-121.445 -62.518)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M388.52,220.14,398.9,311.6l.55-.062-.86-7.6,3.3-.736.818,8.032.55-.055-.825-8.1,3.3-.743.777,8.527.55-.048-.784-8.6,3.308-.743.736,9.029.55-.048-.743-9.1,3.315-.743.688,9.524.55-.041L414,300.462l3.315-.743.633,10.02.55-.034-.633-10.109,3.315-.743.571,10.522h.55l-.578-10.611,3.624-.811-.076-.323-3.569.8-.75-13.754,3.734-1.121-.1-.316-3.652,1.1-.75-13.754,3.837-1.437-.117-.309-3.741,1.375-.75-13.754,3.947-1.754-.138-.3-3.83,1.705-.75-13.754,4.057-2.063-.151-.3L418.627,242l-.75-13.719L422,225.9l-.165-.289-4.016,2.3-.743-13.706,4.264-2.709-.179-.282-4.126,2.606-.756-13.96h-.55l.777,14.269-3.927,2.489-.846-13.43-.55.034.866,13.754-3.927,2.5-.928-12.9-.55.041.99,13.286-3.934,2.5-1-12.378-.55.048,1.032,12.667-3.94,2.5-1.08-11.849-.55.048,1.107,12.131-3.947,2.5-1.155-11.326-.55.055,1.183,11.6-3.954,2.5-1.224-10.81Zm5.763,8.6,1.231,12.048L391.67,243l-1.334-11.746Zm11.581,20.19,3.727-1.9.935,13.066L406.9,261.7Zm.5,12.984-3.624,1.609-1.135-12.42,3.727-1.9Zm4.181-1.5.935,13.066-3.521,1.32-1.038-12.757Zm-3.129,14.572-3.507,1.3-1.135-12.378L406.4,262.3Zm-4.057,1.52-3.507,1.32-1.238-12.1,3.624-1.609Zm-4.814-11.127-1.238-12.09,3.734-1.9,1.135,12.378Zm-1.238-12.475-1.231-12.083,3.837-2.207L401.05,251Zm3.129-14.593,3.83-2.2,1.032,12.708-3.734,1.9Zm4.36-2.5,3.83-2.2.935,13.066-3.727,1.9Zm4.36-2.5,3.824-2.2.839,13.362-3.727,1.9Zm4.69,11.519.839,13.369-3.624,1.609-.942-13.066Zm.86,13.719.839,13.369-3.521,1.32-.942-13.066Zm.86,13.719.839,13.375-3.438,1.032-.942-13.066Zm-3.122,14.565-3.438,1.032L407.968,275.1l3.576-1.286Zm-3.961,1.19-3.438,1.032L403.91,276.62l3.521-1.32Zm-3.954,1.19-3.438,1.032-1.238-12.1,3.521-1.32Zm-3.954,1.19-3.438,1.025-1.334-11.78,3.514-1.32Zm-4.814-11.085-1.334-11.773,3.624-1.609,1.231,12.062ZM394.386,267.2l-1.334-11.766,3.734-1.9,1.231,12.062Zm-1.375-12.117-1.334-11.759,3.844-2.207,1.231,12.055Zm5.7-29.206,1.128,12.378L396,240.461l-1.231-12.076Zm4.456-2.833,1.032,12.7-3.837,2.2-1.135-12.378Zm4.456-2.833.935,13.025-3.83,2.2-1.038-12.729Zm4.456-2.826.839,13.355-3.83,2.2-.935-13.066Zm5.2,10.852-3.824,2.194-.839-13.382,3.92-2.489Zm.763,14.056-3.72,1.9-.839-13.389,3.823-2.194Zm.8,14.056-3.624,1.609-.846-13.4,3.72-1.9Zm.763,14.049-3.521,1.32-.846-13.41,3.617-1.609Zm.763,14.049-3.438,1.032-.846-13.417,3.521-1.32Zm-2.558,14.792-.846-13.424,3.438-1.032.763,13.74Zm-3.865.866-.942-13.066,3.438-1.032.839,13.382Zm-3.858.866-1.038-12.763,3.438-1.032.935,13.066Zm-3.851.866-1.135-12.44,3.438-1.032,1.032,12.722Zm-3.851.86-1.238-12.11,3.438-1.025,1.135,12.378Zm-3.844.86-1.341-11.78,3.438-1.025,1.231,12.069Z",
    transform: "translate(-121.37 -62.418)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M434.76,195.09l5.213,112.43h.55l-.509-11,6.141.756.392,10.776h.55l-.385-10.687,6.141.756.261,10.432h.55l-.261-10.315,6.141.756.138,10.081h.55l-.138-10.006,6.141.756v9.738h.55v-9.669l6.141.756-.1,9.394h.55l.1-9.332,6.134.756-.227,9.05h.55l.22-8.995,6.134.756-.344,8.706h.55l3.6-91.723h-.55l-.447,11.319-7.124-2.751.3-11.979h-.55l-.289,11.78-7.124-2.751.138-12.44h-.55l-.138,12.234-7.118-2.751V209.016h-.55V221.71l-7.111-2.751-.186-13.375h-.55l.186,13.155-7.111-2.751-.351-13.843h-.55l.344,13.616-7.1-2.751-.516-14.311h-.55l.509,14.077-7.1-2.751-.688-14.778Zm8.349,17.88.5,13.685-6.939-2.421-.653-14.022Zm-4.429,54.754,6.457,1.417.5,13.706-6.3-1.087Zm20.672-22.006,6.787,2.063v12.626l-6.629-1.754Zm-.358,12.832-6.622-1.754-.337-13.32,6.781,2.063Zm7.7-10.57,6.787,2.063-.138,12.268-6.629-1.754Zm7.338,2.256,6.787,2.063-.3,11.911-6.629-1.754Zm6.485,14.338-.3,11.918-6.471-1.424.138-12.248Zm-7.31,10.37-6.464-1.423V260.915l6.622,1.754Zm-7.021-1.52L459.716,272l-.179-12.963,6.622,1.754Zm-7.021-1.54-6.464-1.424-.337-13.32,6.622,1.754Zm-7.042-1.547-6.464-1.423-.5-13.678,6.616,1.754ZM445.172,254.9l-.5-13.678,6.781,2.063.337,13.341Zm-.509-14.022-.5-13.671,6.939,2.421.323,13.334Zm7-11.051,6.946,2.421.179,12.977L452,243.159Zm7.5,2.62,6.946,2.428v12.619l-6.787-2.063Zm7.5,2.62,6.952,2.428-.138,12.261-6.794-2.063Zm7.5,2.62,6.953,2.428-.3,11.9-6.794-2.063Zm7.537,2.6,6.959,2.428-.454,11.546-6.8-2.063Zm6.492,14.318-.454,11.553-6.636-1.754.3-11.89Zm-.468,11.89-.454,11.553-6.471-1.424.3-11.89Zm-.523,11.89-.419,11.546-6.306-1.087.3-11.89Zm-7.276,10.377-6.306-1.087.138-12.248,6.464,1.424Zm-6.877-1.183-6.285-1.087V273.885l6.464,1.424Zm-6.877-1.183-6.306-1.087-.179-12.963,6.464,1.417Zm-6.877-1.183-6.306-1.087-.337-13.32,6.457,1.417Zm-6.877-1.183-6.3-1.087-.5-13.678,6.457,1.417ZM437.93,253.337l6.616,1.754.5,13.706-6.464-1.417Zm-.688-14.38,6.774,2.063.5,13.7-6.622-1.754Zm-.688-14.38L443.494,227l.5,13.692-6.781-2.063Zm14.187-8.637.337,13.334-6.946-2.421-.5-13.664Zm7.661,2.978.179,12.977-6.946-2.428-.337-13.307Zm7.661,2.978v12.619l-6.953-2.428-.117-12.99Zm7.661,2.978-.138,12.261-6.953-2.428v-12.6Zm7.668,2.978-.268,11.876-6.959-2.428.138-12.241Zm7.668,2.978-.454,11.546-6.918-2.434.275-11.9Zm-8.94,70.261.3-11.89,6.3,1.087-.454,11.56Zm-6.684-.846.138-12.255,6.3,1.087-.248,11.938Zm-6.691-.825V286.807l6.3,1.087-.138,12.282Zm-6.691-.825-.179-12.97,6.3,1.087v12.64Zm-6.691-.825-.309-13.341,6.3,1.087.179,13Zm-6.7-.825-.5-13.685,6.3,1.087L452.8,297.7Zm-6.7-.825-.653-14.043,6.3,1.087.5,13.712Z",
    transform: "translate(-135.811 -60.928)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M489.736,218.3l1.444-.543-56.7-25.444.468,1.9Z",
    transform: "translate(-135.724 -60.06)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M490.742,210.337l.681-11.354L433.08,168.56l.963,16.333Z",
    transform: "translate(-135.287 -52.643)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M419.561,192.31l-32.851,24.7,1.52.743,31.8-23.546Z",
    transform: "translate(-120.805 -60.06)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M417.845,168.56l.963,16.333-32.851,24.7L384.3,196.652Z",
    transform: "translate(-120.052 -52.643)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 39.37,
    height: 0.44,
    transform: "matrix(0.805, -0.594, 0.594, 0.805, 267.406, 157.505)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M510.572,201.21l-2.792-1.76v15.569l2.2,1.1Z",
    transform: "translate(-158.616 -62.29)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M494.8,192.917l-2.833-1.767-.021,16.278,2.256,1.073Z",
    transform: "translate(-153.673 -59.698)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M479.043,184.614l-2.881-1.774-.041,17,2.311,1.045Z",
    transform: "translate(-148.729 -57.103)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M463.275,176.314l-2.923-1.774-.062,17.708,2.366,1.025Z",
    transform: "translate(-143.785 -54.51)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M447.516,168.021l-2.971-1.781-.076,18.423,2.414.99Z",
    transform: "translate(-138.844 -51.918)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M506.187,199.45l-3.507,3.714,2.049,1.073.22,11.567-1.492,1.389,2.462,1.087,2.469-2.159-2.2-1.1Z",
    transform: "translate(-157.024 -62.29)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M490.431,191.15l-3.411,3.8,1.926,1.011.241,12.351-1.513,1.5,2.448,1.073,2.544-2.386-2.256-1.073Z",
    transform: "translate(-152.133 -59.698)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M474.675,182.84l-3.315,3.906,1.8.942.261,13.135-1.54,1.6,2.441,1.073,2.62-2.613-2.311-1.045Z",
    transform: "translate(-147.242 -57.103)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M458.915,174.54l-3.225,4,1.685.88.282,13.919-1.568,1.705,2.434,1.073,2.7-2.84-2.366-1.025Z",
    transform: "translate(-142.348 -54.51)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M443.159,166.24l-3.129,4.092,1.568.811.3,14.7-1.589,1.809,2.421,1.073,2.771-3.074-2.414-.99Z",
    transform: "translate(-137.457 -51.918)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M504.722,371.012,503,370.95l-.3,9.181h1.657Z",
    transform: "translate(-157.03 -115.852)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M482.883,370.23l-.083,9.676h1.616l.241-9.614Z",
    transform: "translate(-150.815 -115.627)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M462.79,369.51l.131,10.171H464.5l.117-10.1Z",
    transform: "translate(-144.565 -115.402)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M505.2,371.012l-1.726-.062-.289,9.181h1.65Z",
    transform: "translate(-157.183 -115.852)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M483.362,370.23l-.083,9.676H484.9l.241-9.614Z",
    transform: "translate(-150.965 -115.627)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M463.27,369.51l.131,10.171h1.582l.117-10.1Z",
    transform: "translate(-144.715 -115.402)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M443.21,368.79l1.884.069v10.6h-1.547Z",
    transform: "translate(-138.45 -115.178)",
    fill: "#edaf47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M429.95,369.309l.915,10.288h1.368l-.6-10.357Z",
    transform: "translate(-134.309 -115.318)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M418.77,369.752l1.162,9.985h1.327l-.866-10.047Z",
    transform: "translate(-130.817 -115.459)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M407.58,370.2,409,379.878h1.286l-1.128-9.738Z",
    transform: "translate(-127.323 -115.599)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M442.42,368.79l-1.74.069.667,10.6h1.41Z",
    transform: "translate(-137.66 -115.178)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M429.5,369.309l.915,10.288h1.368l-.6-10.357Z",
    transform: "translate(-134.168 -115.318)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M418.31,369.752l1.169,9.985h1.327l-.866-10.047Z",
    transform: "translate(-130.674 -115.459)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M407.13,370.2l1.417,9.676h1.279L408.7,370.14Z",
    transform: "translate(-127.182 -115.599)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M442.74,358.56l47.65,3.48-.22,1.884-47.285-2.709Z",
    transform: "translate(-138.303 -111.983)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M487.932,365l-.158,3.4-44.645-1.6-.179-4.381Z",
    transform: "translate(-138.369 -113.188)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M429.991,358.56l-28.071,2.682.44,1.926,27.776-1.953Z",
    transform: "translate(-125.555 -111.983)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M430.963,362.42l-26.393,1.857.55,3.562,26.022-1.038Z",
    transform: "translate(-126.382 -113.188)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M475.945,365l-.055,1.245-44.748-2.008-26.318.818-.254-.777,26.393-1.857Z",
    transform: "translate(-126.382 -113.188)",
    fill: "#792935",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M390.968,191.135a2.18,2.18,0,0,0,1.795,1.685c.736,0,1.128-.75.873-1.685a2.18,2.18,0,0,0-1.795-1.685C391.119,189.457,390.727,190.206,390.968,191.135Z",
    transform: "translate(-122.112 -59.167)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M398.417,193.967l-5.8-2.957,4.394,4.133Z",
    transform: "translate(-122.65 -59.654)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M410.317,184.147l-5.8-2.957,4.4,4.133Z",
    transform: "translate(-126.367 -56.587)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M402.308,181.125a2.18,2.18,0,0,0,1.795,1.685c.736,0,1.128-.75.873-1.685a2.18,2.18,0,0,0-1.795-1.685C402.439,179.44,402.074,180.2,402.308,181.125Z",
    transform: "translate(-125.654 -56.041)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M391.63,187.913h.22l5.041,46.763h-.22Zm2.434.784h.22L399,233.465h-.22Zm7.867-6.519h.22l5.687,49.348h-.22Zm-2.441-.688h.22l4.552,48.908h-.22Z",
    transform: "translate(-122.341 -56.681)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M402.892,180.7a2.269,2.269,0,0,0,1.864,1.747c.763,0,1.169-.784.908-1.747a2.262,2.262,0,0,0-1.864-1.747C403.03,178.95,402.624,179.727,402.892,180.7Z",
    transform: "translate(-125.833 -55.888)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M391.582,190.707a2.262,2.262,0,0,0,1.864,1.747c.763,0,1.169-.784.908-1.747a2.262,2.262,0,0,0-1.864-1.747C391.72,188.988,391.314,189.744,391.582,190.707Z",
    transform: "translate(-122.3 -59.014)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M413.669,253.534l-3.679-1.114.186,5.811,3.493.935Z",
    transform: "translate(-128.075 -78.833)",
    fill: "#91303e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M406.52,252.42l-7.64,4.319,1.52,4.628,6.306-3.136Z",
    transform: "translate(-124.605 -78.833)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M410.889,261.805l-3.493-.935-6.306,3.136,3.8.866Z",
    transform: "translate(-125.296 -81.473)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M475.2,370.337l-43.262-1.547-24.812.99.22,1.485,24.695.667,43.118-.5Z",
    transform: "translate(-127.182 -115.178)",
    fill: "#792935",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 0.44,
    height: 59.842,
    transform: "translate(299.046 134.568) rotate(-66.29)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M417.184,380.11l-5.144.11.11.475h5.1Z",
    transform: "translate(-128.715 -118.713)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M414.159,380c.1.688.564,1.307,1.045,1.307s.8-.585.688-1.307-.564-1.307-1.045-1.307S414.042,379.275,414.159,380Z",
    transform: "translate(-129.37 -118.269)",
    fill: "#bc9eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M415.251,381.243a.5.5,0,0,0,.371-.179,1.293,1.293,0,0,0,.22-1c-.089-.688-.516-1.21-.935-1.21a.5.5,0,0,0-.378.179,1.293,1.293,0,0,0-.22,1c.083.688.516,1.21.935,1.21Z",
    transform: "translate(-129.417 -118.319)",
    fill: "#910046"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M415.628,380.2l.076.523-1,.034-.089-.516Z",
    transform: "translate(-129.518 -118.741)",
    fill: "#bc9eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M435.43,378.872v-.11h.117c0-.6-.069-1.2-.124-1.781h.124c.055.591.1,1.19.124,1.781h0v.11h-.241Zm.406-.481h.11v.33a.951.951,0,0,1,.206,0h0l.041-.818h-.2v-.11h.2l.041-.832h-.213a1.9,1.9,0,0,1-.048.557h-.11a1.807,1.807,0,0,0,.041-.585v-.048h.062a1.376,1.376,0,0,0,.323,0h.069l-.1,2.008H436.2a.818.818,0,0,0-.309.034h-.076Zm1.066.371a.963.963,0,0,1,.034-.468h-.083v-.11h.241v.11h-.048a.853.853,0,0,0-.048.364.523.523,0,0,1,.2,0h.165a.193.193,0,0,0,0-.11V376.96h-.117a.268.268,0,0,0-.2,0q-.082.062-.041.248h.062v.11h-.261v-.11h.117a.446.446,0,0,1,0-.254h-.11a12.284,12.284,0,0,0-.089,1.7h.048v.11a2.309,2.309,0,0,0-.419,0h-.076v-.076a4.729,4.729,0,0,0,.055-.578h.11a4.891,4.891,0,0,1-.048.523h.206a12.449,12.449,0,0,1,.089-1.7H436.6v-.048h.309v.1a.22.22,0,0,1,.076-.089.358.358,0,0,1,.275,0,.485.485,0,0,0,.144,0h.062v1.678h0a.282.282,0,0,1-.048.179c-.055.069-.144.083-.282.055a.331.331,0,0,0-.179,0l-.069.048Zm-1.705.076.076-1.967h.344v.11h-.248v.908h.158V378h-.165v.846Zm-.261-.034h-.076v-.083h.1c0-.585,0-1.176.048-1.76a.241.241,0,0,0-.124.034.419.419,0,0,0-.117.33v.5a.413.413,0,0,0,0,.227h0a.172.172,0,0,1,.055.083.372.372,0,0,1,0,.193v.041a2.253,2.253,0,0,1-.172.433l-.1-.048a2.125,2.125,0,0,0,.165-.413v-.048a.345.345,0,0,0,0-.131h0l-.041-.048a.5.5,0,0,1-.048-.289v-.5a.4.4,0,0,1,.523-.461v.11H435.1c-.041.585-.062,1.183-.048,1.767h0v.11Zm.158-2.393h.1a12.431,12.431,0,0,0,.131-1.857h-.1a.261.261,0,0,0-.213.124.412.412,0,0,0,0,.165v.571a.6.6,0,0,0,.034.3.2.2,0,0,0,.117.1.117.117,0,0,0,.089,0l.055.1a.22.22,0,0,1-.172,0,.309.309,0,0,1-.179-.151.688.688,0,0,1-.048-.365v-.571a.5.5,0,0,1,.041-.206.364.364,0,0,1,.3-.186,1,1,0,0,1,.323.041v.11h-.069a12.531,12.531,0,0,1-.131,1.829h.089v.11h-.3Zm1.589.1v-.048l-.578.034v-.3h.11v.172h.351l.076-1.7a1.176,1.176,0,0,1-.261,0,.688.688,0,0,1-.034.323l-.1-.041a.551.551,0,0,0,0-.337v-.083h.083a1.1,1.1,0,0,0,.371,0h.069l-.083,1.871h.117a3.4,3.4,0,0,1,.543-.818l-.385-.86h-.151v-.11l.3-.041v.11h0l.364.811V374.6h-.055l-.041-.1a.447.447,0,0,1,.3,0v.1H437.6a15.271,15.271,0,0,1,0,1.767h.034v.11h-.227v-.11h.083v-.75a3.3,3.3,0,0,0-.516.756h.1v.11a.825.825,0,0,0-.4.027Zm-1.176-.406h.11v.2a.934.934,0,0,1,.289,0,6.424,6.424,0,0,1,.048-.784v.069a.722.722,0,0,0-.22-.041v-.11a.832.832,0,0,1,.248.041,7.057,7.057,0,0,1,.089-.846h-.275a.935.935,0,0,1-.062.371l-.1-.041a.832.832,0,0,0,.048-.385v-.062h.523v.062c-.076.585-.131,1.183-.151,1.774v.062h-.062a.812.812,0,0,0-.378,0h-.083Zm.825-.461v-.131h.254v.11Z",
    transform: "translate(-135.746 -116.939)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M424.33,378.872v-.11h.1c0-.6-.069-1.2-.124-1.781h.11c.055.591.1,1.19.124,1.781h0v.11h-.151Zm.406-.481h.11v.33a.951.951,0,0,1,.206,0h0l.041-.818h-.2v-.11h.2l.041-.832h-.213a1.905,1.905,0,0,1-.048.557h-.11a1.808,1.808,0,0,0,.041-.585v-.048h.062a1.376,1.376,0,0,0,.323,0h.069l-.1,2.008H425.1a.818.818,0,0,0-.309.034h-.076Zm1.066.371a.962.962,0,0,1,.034-.468h-.083v-.11h.241v.11h-.055a.852.852,0,0,0-.048.364.523.523,0,0,1,.2,0h.165a.193.193,0,0,0,0-.11V376.96h-.117a.268.268,0,0,0-.2,0q-.082.062-.041.248h.062v.11H425.7v-.11h.083a.447.447,0,0,1,0-.254h-.11a12.284,12.284,0,0,0-.089,1.7h.048v.11a2.309,2.309,0,0,0-.419,0h-.076v-.076a4.735,4.735,0,0,0,.055-.578h.11a4.883,4.883,0,0,1-.048.523h.206a12.434,12.434,0,0,1,.089-1.7h-.089v-.048h.309v.1a.22.22,0,0,1,.076-.089.358.358,0,0,1,.275,0,.485.485,0,0,0,.144,0h.062v1.678h0a.282.282,0,0,1-.048.179c-.055.069-.144.083-.282.055a.331.331,0,0,0-.179,0l-.069.048Zm-1.705.076.069-1.967h.344v.11h-.248v.908h.158V378h-.165v.846Zm-.261-.034h-.055v-.083h.1c0-.585,0-1.176.048-1.76a.241.241,0,0,0-.124.034.419.419,0,0,0-.117.33v.5a.413.413,0,0,0,0,.227h0a.172.172,0,0,1,.055.083.372.372,0,0,1,0,.193v.041a2.254,2.254,0,0,1-.172.433l-.1-.048a2.125,2.125,0,0,0,.165-.413v-.048a.345.345,0,0,0,0-.131h0l-.041-.048a.5.5,0,0,1-.048-.289v-.5a.4.4,0,0,1,.523-.461v.11h-.048c-.041.585-.062,1.183-.048,1.767h0v.11Zm.158-2.393h.1a12.435,12.435,0,0,0,.131-1.857h-.1a.261.261,0,0,0-.213.124.413.413,0,0,0,0,.165v.571a.6.6,0,0,0,.034.3.2.2,0,0,0,.117.1.117.117,0,0,0,.089,0l.055.1a.22.22,0,0,1-.172,0,.309.309,0,0,1-.179-.151.688.688,0,0,1-.048-.365v-.571a.5.5,0,0,1,.041-.206.365.365,0,0,1,.3-.186,1,1,0,0,1,.323.041v.11h-.069a12.522,12.522,0,0,1-.131,1.829h.089v.11h-.3Zm1.589.1v-.048l-.578.034v-.3h.11v.172h.351l.076-1.7a1.177,1.177,0,0,1-.261,0,.687.687,0,0,1-.034.323l-.1-.041a.543.543,0,0,0,0-.337v-.083h.069a1.1,1.1,0,0,0,.371,0h.069l-.083,1.871h.117a3.4,3.4,0,0,1,.543-.818l-.385-.86h-.151v-.11l.3-.041v.11h0l.364.811V374.6H426.3l-.041-.1a.447.447,0,0,1,.3,0v.1h-.062a15.3,15.3,0,0,1,0,1.767h.034v.11H426.3v-.11h.083v-.75a3.294,3.294,0,0,0-.516.756h.1v.11a.825.825,0,0,0-.392.027Zm-1.176-.406h.11v.2a.934.934,0,0,1,.289,0,6.43,6.43,0,0,1,.048-.784v.069a.722.722,0,0,0-.22-.041v-.11a.832.832,0,0,1,.248.041,7.051,7.051,0,0,1,.089-.846h-.275a.936.936,0,0,1-.062.371l-.1-.041a.826.826,0,0,0,.048-.385v-.062h.523v.062c-.076.585-.131,1.183-.151,1.774v.062h-.062a.812.812,0,0,0-.378,0h-.083Zm.825-.461v-.131h.254v.11Z",
    transform: "translate(-132.285 -116.939)",
    fill: "#8f5e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M33.1,385.372H180.842l-1.4-2.022H34.207Z",
    transform: "translate(-10.367 -119.725)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M81.492,385.372l-.956-2.022H34.207L33.1,385.372Z",
    transform: "translate(-10.367 -119.725)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M219.1,359.31l-.083.1-.309,2.675,2.641.241.11-.083Z",
    transform: "translate(-68.336 -112.217)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 0.708,
    cy: 0.708,
    r: 0.708,
    transform: "translate(154.356 244.473)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M222.91,374.892h.447v-5.109l.454-4.876,1.128-8.362-.447-.055-1.135,8.369-.447,4.9Z",
    transform: "translate(-69.647 -111.336)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M225.236,358.508l-1.513-.268.33.516-.53,3.693-.433.715,1.912.144-.419-.784.406-3.672Z",
    transform: "translate(-69.704 -111.883)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M223.55,375.733l-1.864-.193.364.578-.55,4.257h-.241v.468l2.627.069v-.433h-.378l-.213-4.236Z",
    transform: "translate(-69.132 -117.286)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M228.438,360.68l-2.091.186-.138,2.311,1.953.261Z",
    transform: "translate(-70.678 -112.645)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M226.28,362.343l-1.073-.083-.027.33,1.073.131Z",
    transform: "translate(-70.356 -113.138)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M223.833,361.612l-1.155-.172-.048.33,1.169.117Z",
    transform: "translate(-69.56 -112.882)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M221.729,359.764l-.2,2.483-2.6-.227.241-2.709Z",
    transform: "translate(-68.404 -112.217)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M228.286,361.04l-.172,2.3-1.664-.2.124-2.022Z",
    transform: "translate(-70.753 -112.757)",
    fill: "#e5bfa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M221.616,359.989l-.144,2.125-2.221-.172.165-2.372Z",
    transform: "translate(-68.504 -112.298)",
    fill: "#f4f7c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M229.325,360.68l.165.028-.254,2.73h-.186Z",
    transform: "translate(-71.565 -112.645)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M225.57,356.8a.536.536,0,0,0,.083-1.052.688.688,0,0,1,.193.536A.749.749,0,0,1,225.57,356.8Z",
    transform: "translate(-70.478 -111.105)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M224.866,358.62l.688.1-.158.213-.5,3.659.282.646-.612-.055a.585.585,0,0,0,.2-.289c.034-.172.468-3.968.468-3.968Z",
    transform: "translate(-70.166 -112.001)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M223.923,376.025l-.186.323.186,4.161H223.4l.083-4.2-.083-.337Z",
    transform: "translate(-69.8 -117.42)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M79,112.09,38.93,139.006,57.621,280.7l29.591-3.837Z",
    transform: "translate(-12.188 -35.006)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M100.937,236.26l-7.867,80.8,12.846-.812Z",
    transform: "translate(-29.096 -73.786)",
    fill: "#114258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M60.954,124.14,49.6,132.062l9.469,152.646,4.614.55Z",
    transform: "translate(-15.52 -38.77)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M77.219,120.654,76.38,281.875l2.9-.729L84.962,114.74Z",
    transform: "translate(-23.884 -35.834)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M178.429,143.068,107.35,110.32l7.1,165.9,58.873,5.708Z",
    transform: "translate(-33.556 -34.454)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M165.165,129.668l9.724,153.038-9.724-1.5L142.849,121.044ZM127.253,113.26,149.761,280.2h3.81L135.03,115.543Zm-16.773-5.33L131.3,278.73l1.926-.543L114.537,109.574Z",
    transform: "translate(-34.534 -33.707)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M123.431,289.629l-8.878-.585-4.023-83.265Zm50-141.739,4.745,91.668,5.5-85.2Z",
    transform: "translate(-34.549 -46.187)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M110.3,271.741l.089-.612,62.634,9.153-.089.612Zm-.571-13.176.1-.605,63.6,11.147-.1.605Zm-.571-13.176.124-.605,64.574,13.135-.124.605Zm-.571-13.176.138-.6,65.55,15.129-.138.6Zm-.564-13.176.151-.6,66.52,17.123-.151.6Zm-.564-13.2.165-.591,67.489,19.159-.165.591Zm-.564-13.176.179-.591,68.466,21.139-.179.591Zm-.564-13.176.193-.585L175.984,202l-.193.585Zm-.564-13.176.206-.578,70.405,25.094-.206.578Zm-.564-13.176.22-.578,71.368,27.15-.22.578Zm-.564-13.176.227-.571,72.344,29.075-.227.571Zm-.564-13.176.241-.564,73.287,31.1-.241.564Z",
    transform: "translate(-32.535 -39.419)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M109.684,270.734l.089-.612,62.634,9.153-.089.612Zm-.571-13.176.1-.605,63.611,11.154-.1.605Zm-.571-13.176.124-.605,64.574,13.135-.124.605Zm-.585-13.169.138-.6,65.55,15.129-.138.6Zm-.564-13.176.151-.6,66.52,17.123-.151.6Zm-.55-13.2.165-.591,67.5,19.159-.165.591Zm-.564-13.176.179-.591,68.459,21.105-.179.591Zm-.564-13.176.193-.585L175.364,201l-.193.585Zm-.564-13.176.206-.578,70.405,25.094-.206.578Zm-.564-13.176.22-.578,71.368,27.15-.22.578Zm-.564-13.176.227-.571L176.6,167.464l-.227.571Zm-.564-13.176.241-.564,73.321,31.07-.241.564Z",
    transform: "translate(-32.341 -39.107)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M57.018,278.394l32.844-7.613.138.6-32.844,7.613Zm-1.54-11.615,33.82-9.174.158.591-33.82,9.181Zm-1.54-11.615,34.79-10.728.179.585-34.79,10.728Zm-1.534-11.6,35.76-12.289.2.585L52.6,244.147Zm-1.54-11.615,36.722-13.829.22.578L51.069,232.519Zm-1.554-11.615,37.706-15.4.234.571L49.543,220.869Zm-1.54-11.615L86.451,191.76l.248.564L48.016,209.282ZM46.214,197.11,85.866,178.6l.261.557L46.489,197.667Zm-1.54-11.615L85.3,165.421l.275.55L44.969,186.045Zm-1.54-11.615,41.591-21.628.282.543L43.463,174.43Zm-1.54-11.615,42.568-23.189.3.543L41.889,162.808ZM40.08,150.657,83.624,125.9l.3.536L40.383,151.193Z",
    transform: "translate(-12.547 -39.319)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M57.015,277.735l32.844-7.613.138.6-32.844,7.626Zm-1.54-11.615,33.82-9.174.158.591-33.82,9.194ZM53.934,254.5l34.79-10.728.179.585L54.113,255.11ZM52.4,242.91l35.76-12.289.2.585L52.6,243.495ZM50.86,231.3,87.6,217.452l.22.578-36.75,13.843Zm-1.554-11.608,37.706-15.4.234.571-37.706,15.39Zm-1.54-11.615,38.682-16.986.248.564L48.013,208.636Zm-1.554-11.615,39.652-18.512.261.557L46.486,197.014Zm-1.54-11.615L85.3,164.769l.275.55L44.966,185.4Zm-1.52-11.636,41.571-21.6.282.543L43.46,173.777Zm-1.54-11.615L84.178,138.4l.3.543L41.906,162.135Zm-1.54-11.615L83.614,125.22l.3.536L40.379,150.513Z",
    transform: "translate(-12.544 -39.107)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M178.143,122.987,101.7,82.84l.681,16.03,75.35,35.168Z",
    transform: "translate(-31.792 -25.871)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M178.04,141.318l-1.066.447-74.181-34.109-.1-1.506Z",
    transform: "translate(-32.101 -33.151)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M177.659,373.29H114.048l-.688-22.15,65.062,6.306Z",
    transform: "translate(-35.433 -109.665)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M98.435,373.29H65.5L63.37,355.6l34.377-4.463Z",
    transform: "translate(-19.821 -109.665)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M154.413,104.015l3.046,1.623-3.067,163.82-3.06-.275Zm29.412,15.638-2.991-1.589-8.541,153.113,3.067.3ZM161.819,270.167l3.067.3,5.777-157.81-3.033-1.637Zm-41.859-4.023,3.088.3-5.226-181.9L114.7,82.876Zm20.906,2.008,3.074.3.33-169.858L141.2,96.953Zm-31.345-3.012,3.095.3L104.57,77.5l-3.15-1.678Zm20.871,1.981,3.081.3L131.032,91.582l-3.081-1.65Z",
    transform: "translate(-31.704 -23.679)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M80.959,82.84,35.29,119.831l1.389,9.848L81.64,98.87Z",
    transform: "translate(-11.051 -25.871)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M208.555,139.292l4.085-2.042-8.534,153.113-.825-.027,5.109-138.857,1.066-.447.413-11.051Z",
    transform: "translate(-63.517 -42.864)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M190.979,129.344l3.748-2.3L188.9,286.164l-.715-.021,3.273-143.472.915-.605.371-11.794Z",
    transform: "translate(-58.801 -39.675)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M176.812,116.82l-3.493,2.524,1.114.591-.083,12.722-1.032.64-.179,148.65.578.021Z",
    transform: "translate(-54.103 -36.484)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M157.678,106.59l-3.438,2.641,1.4.736-.076,13.479-.949.646,2.139,153.643.6.028Z",
    transform: "translate(-48.201 -33.289)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M138.39,96.34l-3.48,2.709,1.465.77.069,14.324-1.135.77,5.048,158.615.5.027Z",
    transform: "translate(-42.164 -30.087)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M119.344,86.09l-2.964,3.067.894.468.337,15.225-.921.963,7.3,163.49.619.048Z",
    transform: "translate(-36.377 -26.886)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M82.271,106.15,37.31,136.958l1.114.193,43.95-29.495Z",
    transform: "translate(-11.682 -33.151)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M167.475,358.8,145.29,356.72v18.313h21.531Z",
    transform: "translate(-45.406 -111.408)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M166.147,382.669v-1.231l-20.857-.268v1.5Z",
    transform: "translate(-45.406 -119.044)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M163.321,380.767v-1.252l-18.031-.385v1.4Z",
    transform: "translate(-45.406 -118.407)",
    fill: "#a35100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M161.836,372.813l.358-13.279-16.9-1.754v14.682Z",
    transform: "translate(-45.406 -111.739)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M167.3,370.619l-7.035-.131.3-9.222,7.179.543Zm3.48.2,5.777.172.557-8.314-5.9-.481Zm-42.747-.832,6.471.1-.062-10.934-6.567-.53ZM117.5,357.78l.385,12.048,7.069.11-.172-11.567Z",
    transform: "translate(-36.726 -111.739)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M175.954,371.291l-5.165-.151.4-7.991,5.281.433Zm-9.291-.385-6.43-.124.282-8.589,6.561.5Zm-32.816-.53-5.852-.089-.158-10.735,5.955.481Zm-9.545-.144-6.457-.1-.364-11.409,6.664.536Z",
    transform: "translate(-36.72 -112.033)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M75.808,360.046l3.858-.433.688,10.659L76.5,370.4Zm14.029-1.575-3.865.433.688,11.147,3.858-.131Zm-8.252,11.753,3.858-.131-.688-11.051-3.858.433Zm10.178-.351,4.855-.165-.591-11.938-4.986.557Zm-20.362.688,3.858-.131-.688-10.26-3.858.433Zm-5.33-9.442,1.114,9.586,2.985-.1-.688-9.868Z",
    transform: "translate(-20.664 -111.736)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M68.125,371,67.08,362l2.751-.309.653,9.229Zm4.229-.144-.688-9.373,3.246-.364.688,9.628Zm5.089-.172-.688-9.765L80,360.549l.688,10.02Zm5.089-.172-.688-10.164,3.246-.364.688,10.418Zm5.089-.172-.688-10.556,3.253-.364.688,10.81Zm5.089-.172-.688-10.955,4.367-.488.557,11.3Z",
    transform: "translate(-20.979 -112.033)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M179.03,357.457l-65.86-6.327.083,1.788,65.715,6.141Z",
    transform: "translate(-35.374 -109.662)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M97.183,351.13,61.98,355.7l.172,1.368,35.113-4.154Z",
    transform: "translate(-19.387 -109.662)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M91.611,88.889,88.73,86.53,100.3,269.193h.447L92.01,105.84l-1.093-.736-.873-14.95Z",
    transform: "translate(-27.741 -27.024)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M77.6,95.93l2.93,2.049L79.264,99,80.3,112.936l1.052.66L91.656,272.8l-.364.041Z",
    transform: "translate(-24.265 -29.959)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M66.47,105.34l3.218,1.547-1.485,1.2.949,13.032,1.142.5L82.679,276.457l-.378.041Z",
    transform: "translate(-20.789 -32.898)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M58.314,116.225,55.35,114.74l17.962,165.4h.316l-14.242-150.6-1.032-.468-1.128-11.973Z",
    transform: "translate(-17.316 -35.834)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M47.06,125.46l-2.84-1.32L64.335,283.793h.282L48.374,137.536s-1.018-.371-.99-.385-1.3-10.9-1.3-10.9Z",
    transform: "translate(-13.84 -38.77)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M36.119,134.438,33.1,133.53l22.267,153.9.433-.041L37.109,145.7,36,145.509l-1.389-9.848Z",
    transform: "translate(-10.367 -41.702)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M59.895,92.1l2.9-2.448L76.482,266.566l-3.053.392ZM78.951,266.25l3.06-.392L70.444,83.188l-2.923,2.476Zm5.5-.688,2.9-.378-1.045-24.069L79.157,75.83l-4.009,3.383Zm-16.573,2.111,3.053-.392L55.115,96.124l-2.868,2.421Zm-15.865,2.063,2.407-.309L32.188,115.509l-2.008,1.7Zm4.848-.626,3.053-.392L39.835,109.052l-2.806,2.366Zm5.5-.688,3.053-.392L47.489,102.588l-2.833,2.393Z",
    transform: "translate(-9.455 -23.682)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M173.091,368.63l-2.2-.083.131-2.565,2.214.144Zm-9.552-5.777-3.033-.227-.076,2.283,3.019.213Zm9.834.887-2.228-.179-.1,2.063,2.214.158Zm.179,7.565,2.063.062.158-2.338-2.063-.069Zm.151-2.668,2.063.076.158-2.421-2.111-.138Zm.158-2.806,2.111.151.138-2.063-2.132-.172Zm-2.991,3.033-.117,2.359,2.18.062.138-2.352Zm-49.651-6.726,2.634.186-.041-2.675-2.641-.213Zm42.21,3.335-3.019-.2-.1,2.868,3.005.11Zm-42.134,1.19,2.62.1-.055-3.913-2.593-.158Zm9.868.371,2.338.089v-3.638l-2.318-.151Zm0-4.195,2.311.165V360.44l-2.3-.186Zm-.612.454-2.682-.179.055,3.8,2.627.1Zm0-3.095-2.751-.22.041,2.627,2.689.186Zm-9.187,10.088,2.613.041-.048-3.067-2.62-.089Zm-.688-3.143-2.971-.1.1,3.191,2.923.048Zm43.365-1.994,2.579.179.11-2.249-2.6-.2Zm-46.591-6.01.089,2.751,3.053.213-.048-2.71Zm3.15,3.493-3.04-.2.131,4.126,2.978.11Zm9.937,4.848-2.62-.089.041,2.991,2.579.041Zm33.387.791,2.544.1.138-2.689-2.572-.172Zm-.1,2.682,2.517.048.117-2.29-2.551-.041Zm-3.528-2.455-.076,2.386,2.991.055.089-2.338Zm-29.144,1.932,2.359.034v-2.888l-2.338-.083Z",
    transform: "translate(-36.711 -112.164)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M175.349,371.515l-1.76-.055.117-2.063,1.781.062Zm-2.682-.083-1.87-.055.1-2.063,1.884.062Zm-6.581-.289-2.214-.041.076-2.015,2.235.076Zm-3.136-.062-2.682-.048.069-2.063,2.7.089Zm-29.7-.468h-2.063v-2.62l2.063.069Zm-2.971-.048-2.269-.034-.041-2.682,2.311.083Zm-6.581-.1-2.3-.034-.048-2.806,2.311.083Zm-3.225-.048-2.62-.041-.089-2.875,2.661.089Zm55.063-1.561-1.788-.069.124-2.166,1.8.117Zm-2.709-.1-1.891-.069.11-2.249,1.9.124Zm-6.6-.248-2.242-.083.1-2.448,2.262.151Zm-3.163-.117-2.7-.1.083-2.551,2.709.179Zm-29.825-1.128-2.063-.076v-3.39l2.008.131Zm-2.95-.11-2.324-.089-.048-3.487,2.373.158Zm-6.629-.248-2.317-.089-.062-3.672,2.324.151Zm-3.239-.124-2.675-.1-.124-3.782,2.751.179Zm55.3-.688-1.809-.131.1-1.747,1.822.151Zm-2.751-.193-1.912-.131.089-1.781,1.919.158Zm-6.616-.468-2.269-.158.076-1.953,2.29.172Zm-3.191-.227-2.716-.193.069-1.974,2.751.206Zm-29.976-2.1-2-.138v-2.283l1.994.158Zm-2.93-.206-2.386-.165v-2.318l2.421.193Zm-6.7-.468-2.324-.165-.041-2.386,2.331.186Zm-3.253-.227L117.556,362l-.076-2.434,2.751.227Z",
    transform: "translate(-36.72 -112.298)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M154.6,359.683l6.994.722-.344,12.695-6.781-.144Zm-9.311-.963v14.043l8.541.179.158-13.32Z",
    transform: "translate(-45.406 -112.033)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M160.892,373.221l-6.478-.138.151-12.949,6.664.688Zm-7.4-.158-8.252-.179V359.13l8.39.866Z",
    transform: "translate(-45.39 -112.161)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M146.18,368.175v-8l7.152.743-.089,7.565Zm14.538.578.193-7.056-5.426-.564-.089,7.406Zm-5.33.406-.041,3.652,5.261.11.1-3.548Zm-9.208-.364v3.817l7.008.151.041-3.686Z",
    transform: "translate(-45.683 -112.485)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M160.305,373.053l-4.951-.1.041-3.335,5,.2Zm-7.413-.158-6.7-.144v-3.507l6.746.268Zm7.53-4.009-5.013-.2.083-7.083,5.116.529Zm-7.489-.3-6.753-.268V360.64l6.842.688Z",
    transform: "translate(-45.683 -112.632)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M83.976,367.357l-1.21.062-.261-3.913,1.19-.089Zm-4.669.234,1.307-.069-.254-3.858-1.375.1Zm1.025-4.408-.144-2.2-1.375.151.165,2.152Zm-1.974-1.994-1.114.124.144,2.063,1.135-.089Zm6.079,6.12,1.272-.062-.254-3.989-1.293.1Zm-.935-6.7-1.176.131.151,2.276,1.19-.089Zm4.353,6.526,1.245-.062L88.838,363l-1.245.1ZM85.42,362.8l-.151-2.366-1.307.144.165,2.331Zm-6.877.99-1.128.083.261,3.782,1.169-.062Zm-8.41.179L70,362.123l-1,.11.165,1.8Zm-.612,4.126.9-.048-.254-3.59-.935.1Zm-.77-3.535-.949.076.413,3.521.853-.041Zm-.206-2.242-1,.11.206,1.747.956-.076Zm6.684,1.286-.138-2.022-1.43.158.165,1.967Zm-1.059,4.257,1.375-.069-.254-3.727-1.375.11Zm-.763-3.652-1.087.083.254,3.652,1.135-.055Zm-.193-2.4-1.052.117.138,1.919,1.08-.083Zm15.445-1.733-1.245.138.158,2.455,1.245-.1Zm-.763,7.565.186,2.84,1.238-.041-.186-2.861Zm-5.089.254.186,2.751,1.224-.041-.193-2.751Zm-5.089.254.186,2.675,1.2-.041-.206-2.689Zm6.959,2.441,1.258-.041-.2-2.813-1.272.062Zm-5.13.158,1.279-.041-.179-2.751-1.307.069Zm-9.744.33h.846l-.179-2.558-.887.048Zm4.628-.158,1.307-.041-.179-2.641-1.341.069ZM68.241,368.6l.3,2.517h.777l-.227-2.531Zm22.24-6.189-.158-2.558-1.238.138.158,2.517ZM72.6,368.374l.186,2.593,1.169-.041-.22-2.606Zm16.945-1.32,1.238-.062-.261-4.126-1.238.1Zm4.731-7.647-1.795.2.165,2.634,1.788-.138Zm2.407,2.524-.138-2.751-1.809.2L94.9,362.1Zm-3.741,4.951,1.76-.089-.241-4.229-1.781.138Zm2.421,3.308,1.726-.062-.151-2.991-1.754.089Zm-2.393-2.847.186,2.923L94.9,370.2l-.172-2.957Zm-3.2,3.04L91,370.341l-.179-2.888-1.238.062Zm6.973-7.963-1.788.138.241,4.236,1.754-.089Z",
    transform: "translate(-21.123 -112.176)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M68.937,371.238l-.261-2.214h.53l.2,2.221Zm1.245-.041-.2-2.235h.578l.158,2.249Zm3-.1-.158-2.269.832-.041.193,2.3Zm1.63-.055-.193-2.311,1.032-.055L75.806,371Zm3.438-.117-.165-2.373.866-.041.179,2.386Zm1.657-.055-.186-2.393,1-.048.158,2.414Zm3.438-.117-.165-2.455.9-.048.172,2.469Zm1.678-.055-.172-2.483,1.018-.076.158,2.5Zm3.438-.117-.165-2.538.935-.048.165,2.551Zm1.705-.055L90,367.958l.928-.048.158,2.579Zm3.39-.117-.165-2.62,1.451-.076.151,2.648Zm2.207-.076-.151-2.654,1.444-.076.131,2.682ZM68.6,368.267l-.378-3.218.633-.048.289,3.239Zm1.32-.069-.3-3.26.688-.048.234,3.28Zm3.053-.151-.241-3.349.756-.069.282,3.363Zm1.6-.083-.282-3.383,1.087-.083.234,3.438Zm3.5-.179-.241-3.48.832-.062.268,3.5Zm1.63-.083-.268-3.521,1.038-.083.234,3.548Zm3.438-.172-.241-3.61.887-.069.254,3.631Zm1.664-.083-.254-3.652.983-.076.241,3.679Zm3.438-.172L88,363.536l.935-.069.241,3.769Zm1.705-.089L89.7,363.4l.935-.069.241,3.81Zm3.39-.172-.241-3.879,1.479-.117.227,3.913Zm2.228-.11-.227-3.934,1.479-.11.2,3.975Zm-27.432-2.62-.172-1.444.688-.076.131,1.472Zm1.424-.11-.138-1.5.688-.076.11,1.527Zm3.122-.241-.117-1.616.75-.083.138,1.637Zm1.54-.117-.138-1.664,1.121-.124.117,1.705Zm3.555-.268-.158-1.809.811-.089.138,1.822Zm1.6-.124-.144-1.85,1.059-.117.124,1.884Zm3.5-.268-.131-1.974.873-.1.138,2Zm1.65-.124-.144-2.063,1-.11.131,2.063Zm3.438-.261-.138-2.152.935-.1.138,2.187Zm1.705-.131-.138-2.214.935-.1.144,2.249Zm3.39-.261-.144-2.331,1.485-.165.138,2.386Zm2.249-.172-.138-2.414,1.5-.165.124,2.469Z",
    transform: "translate(-21.254 -112.317)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M198.357,361.686l-.062,1.272-20.885-.75.1-2.469Z",
    transform: "translate(-55.437 -112.351)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M167.378,361.266,162,366.306l-16.711-.681V356.72l22.185,2.077Z",
    transform: "translate(-45.406 -111.408)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M113.29,353.73l22.006,2.056-.076,3.088H113.551Z",
    transform: "translate(-35.411 -110.474)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M63.65,357.767l34.137-4.037.261,5.144-34.1,1.65Z",
    transform: "translate(-19.908 -110.474)",
    fill: "#792935",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M84.63,366.241l.2-.021-.138.88Z",
    transform: "translate(-26.461 -114.375)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M76.18,373.274l-.22,1.946-.481.021-.158-2.29.832-.041Z",
    transform: "translate(-23.553 -116.464)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M84.33,362.4l.839-.089-.3,1.912-.392.028Z",
    transform: "translate(-26.367 -113.154)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M83.132,366.33l.268,3.5-.866.041-.234-3.48Z",
    transform: "translate(-25.733 -114.409)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M82.72,372.581l.825-.041-.385,2.4-.275.007Z",
    transform: "translate(-25.864 -116.349)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M76.85,363.249l.619-.069-.2,1.712-.282.021Z",
    transform: "translate(-24.031 -113.425)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M75.956,370.27l-.825.041-.241-3.349.784-.062Z",
    transform: "translate(-23.419 -114.587)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M70.08,364.018l.426-.048-.131,1.534-.165.014Z",
    transform: "translate(-21.916 -113.672)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M70.37,367.337l.034-.007-.014.186Z",
    transform: "translate(-22.007 -114.722)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M68.132,365.69l-.172-1.444.695-.076.131,1.472Z",
    transform: "translate(-21.254 -113.735)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M75.537,365.047l-.77.062-.117-1.616.75-.083Z",
    transform: "translate(-23.344 -113.497)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M77.14,366.814l.131-.014-.076.66Z",
    transform: "translate(-24.121 -114.556)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M68.97,367.42l.289,3.246-.55.027-.378-3.225Z",
    transform: "translate(-21.37 -114.75)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M69.271,375.492l-.261-2.214.53-.028.055.612-.131,1.623Z",
    transform: "translate(-21.582 -116.57)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M82.989,364.385l-.825.069-.124-1.795.811-.089Z",
    transform: "translate(-25.652 -113.235)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M97.1,365.256l.942-.076.234,3.769-.935.048Z",
    transform: "translate(-30.355 -114.05)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M107.5,359.794l1.059-.124-.516,2.5-.406.028Z",
    transform: "translate(-33.603 -112.329)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M97.9,363.077l-.935.069-.138-2.152.935-.1Z",
    transform: "translate(-30.271 -112.71)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M107.77,364.464l.2-.014-.158.777Z",
    transform: "translate(-33.687 -113.822)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M104.93,371.445l1.176-.055-.543,2.661-.468.014Z",
    transform: "translate(-32.801 -115.99)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M105.85,362.356l-1.479.117-.151-2.338,1.492-.165Z",
    transform: "translate(-32.579 -112.423)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M105.982,364.56l.213,3.645-.055.268-1.389.076-.241-3.879Z",
    transform: "translate(-32.669 -113.856)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M91.82,361.578l.44-.048-.151,2.07-.151.014Z",
    transform: "translate(-28.706 -112.91)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M91.117,373.432l-.089,1.2-.743.028L90.12,372.2l.908-.041Z",
    transform: "translate(-28.175 -116.23)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M92.1,365.67h.041l-.021.289Z",
    transform: "translate(-28.794 -114.203)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M89.7,365.829l.887-.069.254,3.631-.9.048Z",
    transform: "translate(-28.044 -114.231)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M99.709,360.7l-.2,2.256h-.062l-.138-2.214Z",
    transform: "translate(-31.045 -112.651)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M98.465,371.794l-.234,2.551-.543.021-.158-2.538.935-.048Z",
    transform: "translate(-30.489 -116.111)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M90.451,363.731l-.88.069-.131-1.974.866-.1Z",
    transform: "translate(-27.963 -112.973)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M137.42,374.4v-2.62l1.479.048.275,2.6Z",
    transform: "translate(-42.948 -116.111)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M135.224,361.058v2.29l-1.4-.1-.481-2.345Z",
    transform: "translate(-41.673 -112.713)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M137.42,365.72l1.045.069.358,3.377-1.4-.055Z",
    transform: "translate(-42.948 -114.219)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M135.918,373.46l-.358-1.74.358.007Z",
    transform: "translate(-42.367 -116.093)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M135.518,365.593v3.418L135,368.99l-.715-3.48Z",
    transform: "translate(-41.967 -114.153)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M138.383,363.585l-.963-.069V361.24l.722.055Z",
    transform: "translate(-42.948 -112.82)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M122.98,364.76l1.073.076.385,3.652-1.4-.048Z",
    transform: "translate(-38.438 -113.919)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M123.138,374.1l-.048-2.806,1.465.048.289,2.785Z",
    transform: "translate(-38.472 -115.958)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M120.717,359.884l.041,2.4-1.389-.1-.509-2.448Z",
    transform: "translate(-37.151 -112.351)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M123.938,362.522l-1-.069-.041-2.393.791.062Z",
    transform: "translate(-38.413 -112.451)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M121.084,364.643l.062,3.7-.516-.021-.77-3.762Z",
    transform: "translate(-37.463 -113.856)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M121.619,373.132l-.4-1.912.364.014Z",
    transform: "translate(-37.888 -115.936)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M199.414,369.83l1.245.083.254,2.152L199.29,372Z",
    transform: "translate(-62.271 -115.502)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M200.655,368.2l-1.135-.076.1-1.747.825.069Z",
    transform: "translate(-62.342 -114.425)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M199.07,375.942l.117-2.042,1.733.062.028.241-.117,1.788Z",
    transform: "translate(-62.202 -116.773)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M197.858,369.731l-.117,2.029-.481-2.07Z",
    transform: "translate(-61.637 -115.459)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M196.42,366.11l1.313.11-.1,1.754-.791-.055Z",
    transform: "translate(-61.374 -114.341)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M185.09,371.338l.1-2.448.922.062.289,2.434Z",
    transform: "translate(-57.836 -115.209)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M184.94,375.435l.076-2.015,1.417.048.234,2Z",
    transform: "translate(-57.789 -116.624)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M185.851,365.111l.234,1.974-.825-.055.083-1.96Z",
    transform: "translate(-57.889 -114.016)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M183.588,373.367l-.041.977-.227-.983Z",
    transform: "translate(-57.283 -116.605)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M183.187,364.914l-.083,1.953-1.327-.089-.468-2.008Z",
    transform: "translate(-56.655 -113.922)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M182.821,371.228l-.591-2.538,1.142.076-.1,2.476Z",
    transform: "translate(-56.942 -115.146)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M151.52,361.191l.743,7.406-2.847-.11-1.506-7.668Z",
    transform: "translate(-46.224 -112.688)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M151.051,376.793l-.681-3.473,2.751.11.344,3.411Z",
    transform: "translate(-46.992 -116.592)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M163.32,362.411l.722,6.891-2.868-.117-1.465-7.124v-.021Z",
    transform: "translate(-49.909 -113.069)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M162.12,373.79l2.771.11.337,3.26-2.428-.048Z",
    transform: "translate(-50.662 -116.739)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M241.52,385.619H364.368L363.2,384.14H242.435Z",
    transform: "translate(-75.46 -119.972)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M281.75,385.619l-.784-1.479H242.435l-.915,1.479Z",
    transform: "translate(-75.46 -119.972)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M353.685,369.067l-1.506,9.751H260.93L259.17,368.4l33.655-1.3Z",
    transform: "translate(-80.972 -114.65)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M259.17,368.4l33.655-1.3.729,11.718H260.93Z",
    transform: "translate(-80.972 -114.65)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M265.842,367.71l-3.322,10.934-1.981-10.92Zm.894-.165,1.981,10.92,3.322-10.92Zm6.334,0,1.981,10.92,3.321-10.92Zm6.279-.406,1.981,11.326,3.322-11.326Zm6.244-.289,1.981,11.615,3.322-11.615Z",
    transform: "translate(-81.4 -114.572)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M288.846,237.84,259.42,258.622l10.7,66.238,22.652-1.135Z",
    transform: "translate(-81.05 -74.28)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M365.945,367.788l1.265,11.134h-2.6c-.172,0-3.48-11.134-3.48-11.134Zm-17.584,0s3.308,11.134,3.48,11.134h2.593l-1.265-11.134Zm-11.519,0s3.308,11.134,3.48,11.134h2.6l-1.272-11.134Zm-12.034-.1s3.308,11.237,3.48,11.237h2.6l-1.265-11.134Zm-11.257-.364s3.5,11.6,3.672,11.6h2.6l-1.465-11.429Z",
    transform: "translate(-97.956 -114.718)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M367.286,326.441l7.276-58.006-72.351-30.6,3.927,85.885Z",
    transform: "translate(-94.414 -74.28)",
    fill: "#7dc5bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M333,250.88l5.4,2.283c4.126,16.958,16.958,68.15,19.042,76.491l-4.436-.2Z",
    transform: "translate(-104.03 -78.353)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M381.073,332.708l-12.468-.557L350.01,258.06l26.2,11.072Z",
    transform: "translate(-109.343 -80.595)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M304.37,238.76l5.041,2.132L329.168,325l-2.441-.11Z",
    transform: "translate(-95.089 -74.567)",
    fill: "#cae8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M304.45,281.4l12.53,57.064H306.836Z",
    transform: "translate(-95.114 -87.884)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M393.22,275.14l9.724,4.3-4.663,36.764Z",
    transform: "translate(-122.838 -85.929)",
    fill: "#3f9487"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M316.215,268.135l.3,11.512-12.729-3.769-.1.33,12.839,3.8.3,11.512-12.468-2.991-.083.337,12.557,3.012.3,11.519-12.206-2.207-.062.337,12.268,2.221.3,11.519-11.938-1.424-.041.344,11.986,1.43.289,11.278h.344l-.289-11.23,3.122.371v11h.344V316.066l8.479,1.011-.041,10.37h.344l.041-10.315,2.964.351-.309,10.171h.344l.309-10.136,9.628,1.148-.358,9.346h.344l.358-9.318,2.806.337-.612,9.215h.344l.612-9.194,9.8,1.169-.688,8.314h.344l.688-8.3,2.654.316-.9,8.252.344.034.9-8.252,8.459,1.011.041-.344-8.465-1.011.956-8.617,8.534,1.547.062-.337-8.555-1.547.942-8.658,8.6,2.063.083-.337-8.644-2.063.942-8.637,8.679,2.565.1-.33-8.74-2.586.942-8.624,8.747,3.046.117-.323-8.837-3.088.935-8.61,8.837,3.535.131-.316-8.94-3.569.887-8.142-.344-.034-.873,8.046-3.892-1.554.688-8.335h-.344l-.688,8.252-10.164-4.119.564-8.479h-.344l-.557,8.362-4.126-1.657.337-8.679h-.344l-.33,8.555-9.971-3.989.275-9.077h-.344l-.275,8.94-4.4-1.76.041-9.284H330l-.041,9.153-8.7-3.48v-9.579h-.344v9.387l-4.649-1.857-.248-9.744h-.344l.248,9.628L302.661,250.6l-.131.316,13.4,5.364.3,11.512-13-4.539-.11.323Zm4.683-9.882v11.154l-4.339-1.513-.3-11.491Zm9.043,3.652-.041,10.68-8.658-3.026V258.39Zm13.884,36.131-9.779-2.345.316-10.37,9.841,2.909Zm.688-9.7,3.61,1.066-.633,9.524-3.356-.8ZM333.7,295.6l-3.548-.853.041-10.666,3.824,1.128Zm-3.5-11.876.041-10.666,4.126,1.437-.316,10.363Zm4.491-9.112,9.9,3.438-.378,9.8-9.848-2.916Zm10.247,3.576,3.872,1.375-.633,9.5-3.617-1.073Zm4.209,1.472,10.1,3.507-.688,8.94-10.04-2.971Zm9.414,12.777-.688,8.94-9.958-2.386.633-9.5Zm-.736,9.27-.688,8.94-9.882-1.788.633-9.524Zm-10.955,7.076-3.088-.557.378-9.786,3.342.8Zm-3.438-.619-9.717-1.76.316-10.391,9.779,2.338Zm-10.061-1.822-3.26-.591.041-10.673,3.535.846Zm-3.6-.653-8.527-1.54V292.939L329.8,295Zm-8.527-13.066V281.407l8.61,2.544-.041,10.687Zm0-11.539v-11.2l8.658,3.019-.041,10.687ZM334.672,263.8l-.316,10.315-4.126-1.437.041-10.659Zm10.315,4.126-.378,9.8-9.91-3.438.316-10.315Zm4.477,1.788-.633,9.483-3.885-1.375.378-9.779ZM360,273.932l-.688,8.94-10.123-3.535.633-9.463Zm3.28,10.315-3.652-1.272.688-8.906,3.885,1.554Zm-.977,8.995-3.438-1.011.688-8.906L363.2,284.6Zm-1,8.961-3.163-.756.688-8.906,3.4,1Zm-.983,9.022-2.916-.53.688-8.906,3.15.756Zm-3.652,8.72.688-8.906,2.9.523-.949,8.692Zm-10.143-1.21.633-9.545,9.875,1.788-.688,8.94Zm-3.156-.378.378-9.786,3.074.557-.646,9.566Zm-10-1.19.323-10.418,9.731,1.76-.392,9.786Zm-3.315-.4.041-10.673,3.253.591-.323,10.439Zm-8.823-1.052V304.493l8.52,1.54-.041,10.693ZM317.466,303.8l3.438.619v11.244l-3.129-.371Zm-.3-11.849,3.727.894v11.223l-3.438-.619Zm-.3-11.849,4.03,1.19v11.209l-3.734-.894Zm-.3-11.856,4.332,1.513v11.175l-4.037-1.155Z",
    transform: "translate(-94.514 -76.916)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M367.033,326.343l7.3-58.137L301.6,237.46l.014.275,3.927,85.878.344-.014-3.913-85.61,71.98,30.43L366.689,326.3Z",
    transform: "translate(-94.223 -74.161)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M376.643,253.506,301.17,216.88l.6,12.213,74.181,32.156Z",
    transform: "translate(-94.089 -67.734)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M376.221,266.8,302.04,234.64l.117,2.2,72.351,30.6Z",
    transform: "translate(-94.361 -73.281)",
    fill: "#e5aa87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M284.184,242.39v84.393h-2.29l-4.442-79.235ZM263.67,257l9.8,69.779h5.268l-5.268-76.828Z",
    transform: "translate(-82.377 -75.701)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M288.218,236.841l-.117-2.2L257.41,257.224l1.382.4Z",
    transform: "translate(-80.422 -73.281)",
    fill: "#921941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M258.792,267.879l-1.382-.4,10.79,66.678,1.293-.041Z",
    transform: "translate(-80.422 -83.537)",
    fill: "#921941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M270.118,324.825l.337-.062-10.687-66.128L289.1,237.922l-.2-.282L259.39,258.477Z",
    transform: "translate(-81.041 -74.217)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M264.963,267.061l1.375,9.875-3.383,1.912.172.3,3.267-1.85,1.375,9.882-3.177,1.547.151.309,3.129-1.513,1.375,9.889-3.067,1.21.124.316,2.991-1.183,1.375,9.889-2.9.866.1.33,2.854-.853,1.375,9.889-2.751.536.069.337,2.751-.53,1.327,9.084.344-.048-1.293-9.084.853-.165,1.258,9.3.344-.048-1.258-9.318,3.8-.743,1.066,9.923.344-.034-1.073-9.951,1.375-.261,1.045,10.15.344-.034L279.6,316.808l4.642-.908.846,10.886h.344l-.853-10.927,1.843-.358.825,11.106h.344l-.839-11.175,6.272-1.258-.069-.337-6.224,1.21-.86-11.546,6.595-1.974-.1-.33-6.533,1.974-.866-11.546,6.918-2.751-.124-.316-6.822,2.7-.867-11.532,7.241-3.5-.151-.309-7.124,3.438-.853-11.526,7.565-4.277-.172-.3-7.427,4.195-.86-11.5,7.895-5.034-.186-.289-7.73,4.958-.688-9.277h-.344l.688,9.463-1.953,1.252-.688-9.119h-.344l.736,9.332-5.818,3.727-.887-8.6-.344.034.86,8.782-1.534.983-.887-8.493-.344.034.928,8.637-4.986,3.2-1.08-8-.344.048,1.107,8.163-1.128.688-1.121-7.888-.344.048,1.142,8.039-3.542,2.269.186.289Zm6.739-4.319,1.1,10.535-4.752,2.689-1.375-10.04Zm2.641,21.318L273.209,273.5l1.5-.846,1.1,10.707Zm1.5-.344,1.1,10.707-1.424.564-1.135-10.563Zm-.811-11.257,5.577-3.15.88,11.3-5.35,2.586Zm6.485,8.514.88,11.3-5.116,2.022-1.107-10.735Zm.908,11.691.88,11.3-4.883,1.458-1.107-10.742Zm-4.339,12.86-1.375.413-1.155-10.618,1.423-.564Zm-1.719.516-4.05,1.21L270.939,297.2l4.277-1.685Zm-5.46-9.194-1.375-10.054,4.511-2.18,1.135,10.535Zm-1.375-10.412-1.375-10.047L272.9,273.7l1.135,10.542Zm4.064-24.832,1.066,10.625-1.5.846-1.135-10.563Zm6.134-3.934.88,11.292-5.584,3.156-1.1-10.728Zm3.136,10.013-1.925,1.087-.88-11.319,1.953-1.252Zm.887,11.869-1.9.921-.88-11.319,1.926-1.087Zm.887,11.869-1.884.743-.88-11.326,1.9-.921Zm.887,11.876-1.864.557-.88-11.333,1.884-.743Zm-.956,12.241-.88-11.326,1.864-.557.86,11.526Zm-4.993.97-1.107-10.742,4.876-1.458.86,11.244Zm-1.685.33-1.135-10.556,1.375-.413,1.1,10.707Zm-4.126.811-1.375-10.061,4.037-1.21,1.135,10.522Zm-2.606-9.689.908-.275,1.375,10.026-.86.165Zm-1.506-10.288.963-.378,1.375,10.026-.915.275ZM268.2,287.355l1.018-.488,1.375,10.026-.963.378Zm-1.458-10.267,1.073-.605,1.375,10.02-1.018.5Zm-1.458-10.267,1.121-.688,1.375,10.013-1.073.605Z",
    transform: "translate(-81.656 -76.922)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M367.725,371.861l.007-.254-3.005-.041.323-2.544-.254-.034-.33,2.572-3.026-.041.3-2.613-.254-.027-.3,2.634-8.094-.11.206-2.771-.254-.021-.206,2.785-2.978-.041.186-2.833-.254-.021-.193,2.854-8.149-.117.089-2.991-.254-.007-.089,2.991-2.923-.041.076-3.053-.261-.007-.069,3.06-8.2-.117-.034-3.218-.261.007.034,3.212-2.868-.041-.041-3.28-.254.007.041,3.267-8.259-.117-.151-3.438-.261.007.151,3.432-2.813-.041-.151-3.493-.254.007.151,3.48-3.218-.041-.007.254Z",
    transform: "translate(-97.35 -114.734)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M367.935,371.861l.007-.254-3.005-.041.323-2.544-.254-.034-.33,2.572-3.026-.041.3-2.613-.254-.027-.3,2.634-8.094-.11.206-2.771-.254-.021-.213,2.785-2.971-.041.186-2.833-.261-.021-.186,2.854-8.149-.117.089-2.991-.261-.007-.083,2.991-2.923-.041.076-3.053-.261-.007-.076,3.06-8.2-.117-.028-3.218-.261.007.034,3.212-2.868-.041-.041-3.28-.254.007.041,3.267-8.259-.117-.151-3.438-.261.007.151,3.432-2.813-.041-.151-3.493-.254.007.151,3.48-3.218-.041-.007.254Z",
    transform: "translate(-97.415 -114.734)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M316.509,268.135l.3,11.512-12.729-3.769-.1.33,12.839,3.8.3,11.512-12.468-2.991-.083.337,12.557,3.012.3,11.519-12.2-2.207-.062.337,12.268,2.221.3,11.519-11.938-1.423-.041.344,11.986,1.43.289,11.278h.344l-.289-11.237,3.122.371v11h.344V316.066l8.479,1.011-.041,10.37h.344l.041-10.315,2.964.351-.309,10.171h.344l.309-10.136,9.628,1.148-.358,9.346h.344l.358-9.318,2.806.337-.612,9.215h.344l.612-9.194,9.8,1.169-.688,8.314h.344l.688-8.3,2.654.316-.9,8.252.344.034.9-8.252,8.459,1.011.041-.344-8.465-1.011.942-8.672,8.534,1.547.062-.337-8.555-1.547.942-8.658,8.6,2.063.083-.337-8.644-2.063.942-8.637,8.679,2.565.1-.33-8.74-2.586.942-8.624,8.761,3.06.11-.323-8.837-3.088.949-8.562,8.837,3.535.131-.316-8.94-3.569.887-8.142-.344-.034-.873,8.046-3.892-1.554.688-8.335h-.344l-.688,8.252-10.178-4.126.564-8.479h-.344l-.557,8.362-4.126-1.657.337-8.679h-.344l-.33,8.555-9.971-3.989.268-9h-.344L335,263.458l-4.4-1.76.034-9.215h-.344l-.034,9.077-8.747-3.542v-9.524h-.344v9.387l-4.649-1.857-.248-9.744h-.344l.248,9.628-13.231-5.33-.131.316,13.4,5.364.3,11.512-13-4.539-.11.323Zm4.683-9.882v11.154l-4.339-1.513-.3-11.491Zm9.043,3.652-.041,10.68-8.685-3.06V258.39Zm13.884,36.131-9.779-2.345.316-10.37,9.841,2.909Zm.688-9.7,3.61,1.066-.633,9.524-3.356-.8ZM333.99,295.6l-3.542-.873.041-10.666,3.824,1.128Zm-3.5-11.876.041-10.666,4.126,1.437-.316,10.363Zm4.491-9.112,9.9,3.438-.378,9.8-9.848-2.916Zm10.246,3.576,3.872,1.375-.633,9.5-3.617-1.073Zm4.209,1.472,10.116,3.535-.688,8.94-10.04-2.971Zm9.38,12.8-.688,8.94-9.958-2.386.633-9.5Zm-.736,9.27-.688,8.94-9.882-1.788.633-9.524Zm-10.927,7.076-3.088-.557.378-9.786,3.342.8Zm-3.438-.619L334,306.432l.316-10.391,9.793,2.311Zm-10.061-1.822-3.26-.591.041-10.673,3.535.846Zm-3.6-.653-8.541-1.575v-11.2L330.077,295Zm-8.527-13.066V281.407l8.61,2.544-.041,10.687Zm0-11.539V269.888l8.665,3.019-.041,10.687Zm13.437-17.282-.316,10.315-4.126-1.437.041-10.659Zm10.315,4.126-.385,9.731-9.91-3.438.316-10.315Zm4.477,1.788-.633,9.483-3.885-1.375.378-9.779Zm10.535,4.216-.688,8.94-10.123-3.535.633-9.463Zm3.28,10.315L359.915,283l.688-8.906,3.885,1.554Zm-.977,8.995-3.438-1.011.688-8.906,3.645,1.272Zm-.983,9.009-3.163-.756.688-8.906,3.4,1Zm-.983,9.022-2.916-.529.688-8.906,3.15.756Zm-3.652,8.72.688-8.906,2.9.523-.949,8.692Zm-10.143-1.21.633-9.545,9.875,1.788-.688,8.94Zm-3.156-.378.378-9.786,3.074.557-.64,9.566Zm-10-1.19L334,306.824l9.717,1.76-.378,9.71Zm-3.315-.4.041-10.673,3.253.591-.323,10.439Zm-8.851-1.128V304.493l8.52,1.54-.041,10.693ZM317.74,303.8l3.438.619v11.244l-3.129-.371Zm-.3-11.849,3.727.894v11.223l-3.438-.619Zm-.3-11.849,4.03,1.19v11.209l-3.734-.894Zm-.3-11.856,4.332,1.513v11.175l-4.016-1.155Z",
    transform: "translate(-94.601 -76.916)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M261.947,371.63l30.7-.591-.007-.254-1.685.034-.344-3.548-.254.028.344,3.521-1.451.028-.3-3.514-.254.021.3,3.5-4.415.083-.378-3.418-.254.027.378,3.4-1.444.028-.351-3.4-.254.028.344,3.377-4.415.083-.406-3.3-.261.034.413,3.273-1.444.027-.4-3.273-.254.027.392,3.253-4.415.083-.44-3.177-.261.034.44,3.15-1.437.027-.447-3.156-.254.034.44,3.122-4.415.089-.474-3.06-.254.041.468,3.026-1.437.027-.5-3.04-.254.041.488,3-1.554.034Z",
    transform: "translate(-81.837 -114.703)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M327.093,367.726l.11,11.264H325.14l-.33-11.34Zm9.428.309-.069,10.955h1.953l.3-10.886Zm11.821.378-.468,10.577H349.7l.688-10.508Zm11.821.378-.839,10.2h1.726l1.1-10.13Zm13.671.44-1.85-.062-1.265,9.813h1.609Z",
    transform: "translate(-101.472 -114.822)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M261.73,371.63l30.7-.591-.007-.254-1.678.034-.344-3.548-.261.028.344,3.521-1.451.028-.3-3.514-.254.021.3,3.5-4.415.083-.371-3.418-.261.027.378,3.4-1.444.028-.351-3.4-.254.028.344,3.377-4.415.083-.406-3.3-.261.034.413,3.273-1.444.027-.4-3.273-.254.027.392,3.253-4.415.083-.44-3.177-.254.034.44,3.15-1.444.027-.447-3.156-.254.034.44,3.122-4.415.089-.474-3.06-.254.041.468,3.026-1.43.027-.5-3.04-.254.041.5,3-1.554.034Z",
    transform: "translate(-81.771 -114.703)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M269.868,324.825l.337-.062-10.687-66.128,29.337-20.713-.2-.282L259.14,258.477Z",
    transform: "translate(-80.963 -74.217)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M264.713,267.061l1.375,9.875-3.383,1.912.172.3,3.267-1.85,1.375,9.882-3.177,1.547.151.309,3.129-1.513L269,297.416l-3.067,1.21.124.316,2.991-1.183,1.375,9.889-2.9.866.1.33,2.854-.853,1.375,9.889-2.751.536.069.337,2.751-.53L273.2,327.3l.344-.048-1.293-9.084L273.1,318l1.258,9.3.344-.048-1.258-9.318,3.8-.743,1.066,9.923.344-.034-1.073-9.951,1.375-.261,1.045,10.15.344-.034-1.045-10.185,4.642-.908.846,10.886h.344l-.853-10.927,1.843-.358.832,11.134h.344l-.825-11.216,6.265-1.224-.069-.337-6.2,1.217-.866-11.56,6.595-1.974-.1-.33-6.526,1.974-.866-11.546,6.918-2.751-.124-.316-6.822,2.7-.867-11.532,7.241-3.5-.151-.309-7.124,3.438-.86-11.519,7.565-4.277-.172-.3-7.427,4.195-.86-11.5,7.881-5.041-.186-.289L282,255.577l-.688-9.277h-.344l.688,9.463-1.953,1.252-.688-9.119h-.344l.722,9.3-5.818,3.727-.853-8.575-.344.034.9,8.775-1.534.983-.928-8.486-.344.034.928,8.637-4.986,3.2-1.08-8-.344.048,1.107,8.163-1.128.688-1.121-7.888-.344.048,1.142,8.039-3.542,2.269.186.289Zm6.739-4.319,1.135,10.542-4.752,2.689-1.375-10.04Zm2.641,21.318L272.959,273.5l1.5-.846,1.1,10.707Zm1.5-.344,1.1,10.707-1.424.564L274.1,284.4Zm-.8-11.278,5.577-3.15.88,11.3-5.35,2.586Zm6.485,8.514.88,11.3-5.116,2.022-1.107-10.735Zm.908,11.691.86,11.264-4.883,1.458-1.107-10.742Zm-4.339,12.86-1.375.413-1.135-10.563,1.423-.564Zm-1.719.516-4.085,1.176-1.375-10.054,4.277-1.685Zm-5.46-9.229-1.375-10.054,4.511-2.18,1.135,10.535Zm-1.375-10.412-1.375-10.026,4.745-2.682,1.135,10.542Zm4.064-24.832,1.1,10.7-1.5.846-1.135-10.563Zm6.134-3.934.8,11.3-5.584,3.156-1.1-10.728Zm3.136,10.013-1.926,1.087-.88-11.319,1.953-1.252Zm.887,11.869-1.9.922-.88-11.319,1.926-1.087Zm.887,11.869-1.884.743-.88-11.326,1.9-.921Zm.887,11.876-1.864.557-.88-11.333,1.884-.743Zm-.956,12.241-.88-11.326,1.864-.557.86,11.526Zm-4.993.97-1.107-10.735,4.876-1.458.853,11.292Zm-1.685.33-1.135-10.556,1.375-.413,1.1,10.707Zm-4.126.811-1.375-10.061,4.037-1.21,1.135,10.522Zm-2.606-9.689.908-.275,1.375,10.026-.86.165ZM269.4,297.67l.963-.378,1.375,10.026-.915.275Zm-1.458-10.315,1.018-.488,1.375,10.026-.963.378Zm-1.458-10.267,1.073-.605,1.375,10.02-1.018.5Zm-1.458-10.267,1.121-.688,1.375,10.013-1.073.605Z",
    transform: "translate(-81.578 -76.922)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M367.373,326.343l7.289-58.137L301.94,237.46l.014.275,3.927,85.878.344-.014-3.913-85.61,71.98,30.43L367.029,326.3Z",
    transform: "translate(-94.33 -74.161)",
    fill: "#666296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M308.11,367.1l.729,11.718h2.173l-.509-11.643Z",
    transform: "translate(-96.257 -114.65)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M325.3,367.66l.337,11.333H327.7l-.11-11.264Z",
    transform: "translate(-101.625 -114.825)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M342.309,368.21l-.069,10.955h1.953l.289-10.886Z",
    transform: "translate(-106.916 -114.996)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M359.318,368.76l-.468,10.577h1.836l.7-10.508Z",
    transform: "translate(-112.103 -115.168)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M376.336,369.32l-.866,10.191h1.719l1.1-10.13Z",
    transform: "translate(-117.294 -115.343)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M395.2,369.932l-1.85-.062-1.265,9.813h1.609Z",
    transform: "translate(-122.482 -115.515)",
    fill: "#ba5c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M307.92,362.73l63.157,2.806-.254,2.228-62.772-2.029Z",
    transform: "translate(-96.197 -113.285)",
    fill: "#f2f7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M281.91,216.88,239.5,252.3l12.516,69.2,34.666-1.32-.131-3.005-23.945,1.176-10.79-66.678,30.691-22.584Z",
    transform: "translate(-74.829 -67.734)",
    fill: "#ba8ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M255.331,295.89l-6.251,3.837,7.771,43.812,6.024-.337Z",
    transform: "translate(-77.821 -92.41)",
    fill: "#921941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M263.053,343.4l-7.475-46.873-5.928,3.645,7.723,43.544Z",
    transform: "translate(-77.999 -92.61)",
    fill: "#22214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M259.879,322.6l.64,4-5.433,1.472-.688-3.748Zm-4.738,5.818.688,3.748,5.405-1.21-.64-4.009Zm7.454,11.23-.64-4.009-5.364.956.688,3.755Zm-8.906-19.406.688,3.748,5.467-1.733-.64-4Zm2.689-19.565-.557-3.493-5.612,3.438.516,2.916,5.57-3.019Zm-.516,31.826.688,3.748,5.371-.956-.64-4.009Zm-2.9-16.353.688,3.741,5.5-1.987h0l-.64-4.009Zm4.353,24.53.571,3.225,5.336-.3-.578-3.624Zm-6.526-36.784.688,3.734,5.55-2.751.062.131-.688-4.126Zm.722,4.085.688,3.734,5.5-2.5.048.1-.688-4.126Zm.722,4.085.688,3.741,5.5-2.249v.062l-.646-4.071Z",
    transform: "translate(-78.174 -92.813)",
    fill: "#111127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M258.131,343.854l-.543-3.06,5.158-.688.55,3.438Zm-.633-3.569-.633-3.59,5.192-.922.612,3.83Zm-.729-4.126-.633-3.583,5.226-1.176.612,3.83Zm-.729-4.126-.633-3.583,5.261-1.424.612,3.83Zm-.729-4.126-.633-3.583,5.3-1.678.612,3.83Zm-.729-4.126-.633-3.576,5.323-1.926.612,3.83Zm-.729-4.126-.633-3.576,5.357-2.18.612,3.824Zm-.729-4.126-.633-3.569,5.391-2.441.612,3.824ZM252.4,311.4l-.633-3.562,5.419-2.7.612,3.817Zm-.729-4.126-.633-3.555,5.453-2.957.605,3.81Zm-.729-4.126-.488-2.751,5.446-3.349.5,3.129Z",
    transform: "translate(-78.249 -92.772)",
    fill: "#175775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M259.54,368.525l1.32-.048,1.41,10.473h-.97Zm7.785-.3-1.375.055,1.637,10.666h1Zm6.464-.248-1.41.055,1.506,10.92h1.045Zm6.464-.248-1.458.055,1.375,11.168h1.08Zm6.464-.248-1.506.055,1.252,11.416h1.121Z",
    transform: "translate(-81.087 -114.768)",
    fill: "#430033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M259.17,368.413l1.32-.048,1.41,10.473h-.97Zm7.785-.3-1.375.055,1.637,10.666h1Zm6.464-.248-1.41.055,1.485,10.907h1.045Zm6.464-.248-1.458.055,1.375,11.168h1.08Zm6.464-.248-1.506.055,1.252,11.416h1.155Zm6.464-.248-1.554.062,1.121,11.691h1.162Z",
    transform: "translate(-80.972 -114.656)",
    fill: "#792935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M255.14,327.918l-.64-3.576,3.349-1.362.3,3.844Z",
    transform: "translate(-79.513 -100.87)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M254.083,321.821l-.633-3.569,3.727-1.692.3,3.872Z",
    transform: "translate(-79.185 -98.865)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M250.5,301.036l4.773-2.936.248,3.218-4.539,2.455Z",
    transform: "translate(-78.264 -93.1)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M256.193,334l-.633-3.576,2.957-1.073.3,3.817Z",
    transform: "translate(-79.844 -102.86)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M251.973,309.583l-.633-3.555,4.484-2.428.309,3.92Z",
    transform: "translate(-78.526 -94.818)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M253.026,315.7l-.626-3.562,4.105-2.042.3,3.9Z",
    transform: "translate(-78.858 -96.848)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M257.25,340.064l-.64-3.576,2.572-.818.3,3.8Z",
    transform: "translate(-80.172 -104.834)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M260.413,358.18l-.633-3.583,1.389-.248.282,3.7Z",
    transform: "translate(-81.162 -110.668)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M261.373,363.661l-.543-3.06.99-.131.248,3.156Z",
    transform: "translate(-81.49 -112.579)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M259.36,352.159l-.64-3.59,1.788-.4.289,3.734Z",
    transform: "translate(-80.831 -108.738)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M258.3,346.124l-.633-3.59,2.18-.585.289,3.762Z",
    transform: "translate(-80.503 -106.795)",
    fill: "#457891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M9.96,385.359H130.965l-1.148-2.049H10.868Z",
    transform: "translate(-3.14 -119.712)",
    fill: "#9694b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M49.591,385.359l-.777-2.049H10.868l-.908,2.049Z",
    transform: "translate(-3.14 -119.712)",
    fill: "#434168"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M122.175,319.441l6.251-112.691L67.36,178.83l7.846,140.611Z",
    transform: "translate(-21.067 -55.85)",
    fill: "#70c5ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M59.472,319.441H35.41L16.98,203.367,51.626,178.83Z",
    transform: "translate(-5.332 -55.85)",
    fill: "#065275"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 25.988,
    height: 2.18,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, 38.009, 175.337)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 25.988,
    height: 2.18,
    transform: "translate(40.101 202.674) rotate(-79.81)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 25.988,
    height: 4.36,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, 26.742, 179.895)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 25.988,
    height: 1.747,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, 18.762, 185.878)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M67.752,354.67l1.74.316-3.48,19.372h-1.8Z",
    transform: "translate(-20.083 -110.768)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M56.142,354.45l3.48.626L56.17,374.29H52.58Z",
    transform: "translate(-16.451 -110.699)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M35.257,272.85l1.719.309-4.594,25.575-.461-.083-.612-3.83Z",
    transform: "translate(-9.808 -85.214)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M39.38,288.246l.8.144,4.353-24.22,4.291.77-4.594,25.575-3.383-.612L36.505,314.13l-.413-.076-.633-3.989Z",
    transform: "translate(-11.104 -82.503)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 23.306,
    height: 2.18,
    transform: "translate(42.99 245.779) rotate(-78.9)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M42.732,318.257l1.54.3,3.954-22.013,4.3.77L47.93,322.885l-4.181-.75-3.762,19.207-.8-5.013Z",
    transform: "translate(-12.269 -92.613)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M43.65,355.092l3.37-18.76.578.1,4.009-20.417,3.8.743,3.961-22.04,2.146.385-4.594,25.582-1.719-.316-3.8,19.351-3.425-.674-2.985,16.587H43.739Z",
    transform: "translate(-13.662 -92.044)",
    fill: "#387391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M127.395,360.666l9.614,15.535h-1.953L125.38,360.57Z",
    transform: "translate(-39.187 -112.61)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M82.185,358.5l10.542,17.027h-1.96L80.17,358.4Z",
    transform: "translate(-25.068 -111.933)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M135.593,361.059l7.592,12.261-.124,2.173-8.981-14.5Z",
    transform: "translate(-41.904 -112.741)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M88.1,358.785l10.4,16.807H95.085L84.57,358.62Z",
    transform: "translate(-26.442 -112.001)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M112.967,359.976l9.868,15.941h-6.347L106.42,359.66Z",
    transform: "translate(-33.266 -112.326)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 5.673,
    height: 31.544,
    transform: "translate(68.564 183.745) rotate(-33.55)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 1.747,
    height: 31.544,
    transform: "matrix(0.834, -0.553, 0.553, 0.834, 82.194, 186.432)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 3.053,
    height: 31.544,
    transform: "translate(53.067 149.163) rotate(-33.55)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 5.673,
    height: 31.544,
    transform: "translate(69.418 156.567) rotate(-33.55)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M134.927,272.59l11.292,17.027-.124,2.187L133.84,273.312Z",
    transform: "translate(-41.83 -85.133)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M77.905,292.18l16.8,23.368-2.448,1.5L75.45,293.679Z",
    transform: "translate(-23.593 -91.251)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M119.729,323.244l-4.559,2.785-16.8-23.374,4.559-2.785Z",
    transform: "translate(-30.752 -93.653)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M77.36,323.643l2.5-1.423,17.144,22.123-2.5,1.417Z",
    transform: "translate(-24.19 -100.633)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M122.543,350.49l-4.649,2.558-17.144-21.47,4.642-2.558Z",
    transform: "translate(-31.495 -102.757)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 1.747,
    height: 31.544,
    transform: "matrix(0.834, -0.553, 0.553, 0.834, 83.041, 159.259)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M87.394,279.142l-15.762-23.78-.193-3.452,17.412,26.27Z",
    transform: "translate(-22.341 -78.674)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M75.71,324.1l15.2,19.606-1.43.811L75.841,326.926Z",
    transform: "translate(-23.675 -101.22)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M120.23,335.326l1.43-.756L138.8,355.214l-1.43.756Z",
    transform: "translate(-37.579 -104.49)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M134.28,337.394l1.073-.564,8.851,10.659-.083,1.754Z",
    transform: "translate(-41.967 -105.196)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M88.713,314.854l-1.4.86L73.962,297.14l-.172-3.04Z",
    transform: "translate(-23.075 -91.851)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M117.46,307.01l1.4-.86,16.8,23.368-1.4.86Z",
    transform: "translate(-36.714 -95.614)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 3.04,
    height: 31.408,
    transform: "matrix(0.834, -0.552, 0.552, 0.834, 51.546, 175.914)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M132.282,308.71l11.78,16.388-.11,1.953-12.722-17.7Z",
    transform: "translate(-41.014 -96.414)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 1.747,
    height: 31.544,
    transform: "translate(48.484 146.981) rotate(-33.55)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M147.937,253.189,135.07,233.782l1.093-.722L148.06,251Z",
    transform: "translate(-42.214 -72.787)",
    fill: "#c5e8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M120.148,313.95l3.108-78.1h.688L120.8,313.978Zm-9.806-.942,1.375-81.738h.688l-1.375,81.738ZM100.157,226.69h.688l.378,85.376h-.688ZM88.59,222.11h.688l2.132,89.007h-.688Z",
    transform: "translate(-27.697 -69.367)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M120.659,314.07l3.136-78.1h.688l-3.136,78.1Zm-9.806-.942,1.375-81.738h.688l-1.375,81.738ZM100.647,226.81h.688l.337,85.349h-.688ZM89.08,222.23h.688L91.9,311.237h-.688Z",
    transform: "translate(-27.85 -69.405)",
    fill: "#5d5996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M142.771,377.613h-1.726l.818-11.732,1.6.131Zm-7.4-12.378-1.74-.144L133.15,377.6h1.795Z",
    transform: "translate(-41.614 -114.022)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M148.074,366.381l-1.6-.131-.818,11.725h1.726Z",
    transform: "translate(-45.521 -114.384)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M123.356,364.131l-1.891-.151-.144,13.286h1.864Z",
    transform: "translate(-37.919 -113.675)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M136.4,365.254l-1.74-.144-.481,12.509h1.795Z",
    transform: "translate(-41.936 -114.028)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M124.309,364.131l-1.891-.151-.138,13.286h1.864Z",
    transform: "translate(-38.219 -113.675)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M106.566,363.015l-2.036-.165.2,14.063h1.932Z",
    transform: "translate(-32.676 -113.322)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M92.887,361.9,90.7,361.71l.536,14.847h2Z",
    transform: "translate(-28.356 -112.966)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M107.242,363.015l-2.042-.165.2,14.063h1.932Z",
    transform: "translate(-32.885 -113.322)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M93.557,361.9l-2.187-.186.536,14.847h2Z",
    transform: "translate(-28.566 -112.966)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M79.831,360.773,80.45,376.2H78.373L77.5,360.58Z",
    transform: "translate(-24.234 -112.613)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M76.71,360.58l-1.74.151.873,15.473h1.74Z",
    transform: "translate(-23.444 -112.613)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M63.865,361.61l-1.685.144,1.3,14.771h1.671Z",
    transform: "translate(-19.449 -112.935)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M50.623,362.64,49,362.784l1.719,14.063h1.6Z",
    transform: "translate(-15.333 -113.257)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M29,235.526l.646-.089,11.1,77.963-.646.089Zm8.073-5.336.653-.076,9.332,82.522-.653.076Zm9.325-6.134.653-.055,7.805,87.756-.653.055Z",
    transform: "translate(-9.086 -69.958)",
    fill: "#1b194e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M28.51,235.526l.646-.089L40.276,313.4l-.646.089Zm8.094-5.336.653-.076,9.332,82.522-.653.076Zm9.325-6.134.653-.055,7.805,87.749-.653.055Z",
    transform: "translate(-8.933 -69.958)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M42.2,363.67l2.111,13.5h-1.52L40.64,363.808Z",
    transform: "translate(-12.722 -113.578)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M63.028,361.61l-1.678.144,1.293,14.771h1.671Z",
    transform: "translate(-19.19 -112.935)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M49.786,362.64l-1.616.144,1.719,14.063h1.6Z",
    transform: "translate(-15.074 -113.257)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M41.371,363.67l2.111,13.5H41.956L39.81,363.808Z",
    transform: "translate(-12.463 -113.578)",
    fill: "#a9648e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M51.89,200.47l-34.707,22.8-3.693-23.01,36.207-30,64.78,31.957-1.382,22.535Z",
    transform: "translate(-4.242 -53.174)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M59.03,283.26l56.26,14.07-.66,10.728-54.85-11.271L29.2,305.458,27.85,297.1Z",
    transform: "translate(-8.727 -88.465)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M64.2,350.12l51.432,4.993-.392,6.34L64.6,357.313,37.15,359.706l-.97-6.072Z",
    transform: "translate(-11.329 -109.347)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M55.644,240.69l59.4,18.822-.688,11.182L56.435,254.829,23.756,269.174l-1.506-9.4Z",
    transform: "translate(-6.978 -75.17)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M115.367,329.481,114.906,337,62.3,329.343l-28.938,5.02-1.21-7.289L61.789,320.3Z",
    transform: "translate(-10.07 -100.033)",
    fill: "#c48a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M23.756,269.174l-1.506-9.4L55.644,240.69l.791,14.139Z",
    transform: "translate(-6.978 -75.17)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M32.15,327.074,61.789,320.3l.509,9.043-28.938,5.02Z",
    transform: "translate(-10.07 -100.033)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M36.18,353.637l27.989-3.507.426,7.186L37.15,359.709Z",
    transform: "translate(-11.329 -109.35)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M59.03,283.26l.75,13.527L29.2,305.458,27.85,297.1Z",
    transform: "translate(-8.727 -88.465)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M17.183,223.267l-3.693-23.01,36.207-30,2.194,30.21Z",
    transform: "translate(-4.242 -53.174)",
    fill: "#6e3b2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M112.08,239.394l-58.13-22.185L21.264,237.743l-2.414-.756,34.707-22.8,61.2,24.282Zm1.217,23.031L55.4,246.552,22.694,260.9l2.3.3,30.561-12.378,55.214,14.263Zm-1.479,24.069L56.975,275.215l-30.588,8.672,2.317.688,28.367-7.64,52.36,10.233Zm-3.356,18.024,2.29-.646-52.677-7.654-28.883,5.006,2.173.688,26.82-4.037Zm1.375,14.49L59.2,314.881l-27.446,2.393,1.609.371,25.884-1.987,49.218,3.576Z",
    transform: "translate(-5.916 -66.894)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M32.127,312.283,29.81,311.6l30.581-8.672h0l.1,1.712Z",
    transform: "translate(-9.339 -94.608)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M62.889,335.093,36.076,339.13l-2.166-.653,28.869-5.006.069.007.089,1.623Z",
    transform: "translate(-10.62 -104.147)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M18.86,236.987l34.707-22.8h0l.179,3.15-32.479,20.4Z",
    transform: "translate(-5.92 -66.894)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M57.243,263.554,26.737,275.9l-2.3-.3L57.119,261.25Z",
    transform: "translate(-7.662 -81.591)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M37.59,362.973l27.446-2.393.048.777L39.2,363.344Z",
    transform: "translate(-11.769 -112.613)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M117.336,367.216l-9.146-.626v.481l9.146.578Z",
    transform: "translate(-33.819 -114.49)",
    fill: "#5d5996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M115.149,367.491v10.865h-.179l-.131-10.886Z",
    transform: "translate(-35.896 -114.765)",
    fill: "#5d5996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M158.462,217.918l-3.892-1.348,3.851,2.042Z",
    transform: "translate(-48.304 -67.637)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M159.112,224.056l-1.712-.186,1.664.949Z",
    transform: "translate(-49.188 -69.917)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M158.095,231.691l-2.875-.811,2.84,1.41Z",
    transform: "translate(-48.507 -72.106)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M158.141,237.776l-1.981-.406,1.946.908Z",
    transform: "translate(-48.8 -74.133)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M157.4,244.94l-2.613-.75,2.572,1.437Z",
    transform: "translate(-48.373 -76.263)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M155.661,269.7l-3.1-.578,3.074,1.025Z",
    transform: "translate(-47.676 -84.049)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M156.188,274.135l-1.368-.165,1.348.578Z",
    transform: "translate(-48.382 -85.564)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M156.093,278.768l-.963-.158.935.6Z",
    transform: "translate(-48.479 -87.013)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M155,281.757l-2.936-.557,2.916.928Z",
    transform: "translate(-47.52 -87.822)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M154.195,305.18l-1.575-.22,1.547.585Z",
    transform: "translate(-47.695 -95.242)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M153.045,309.79l-3.445-.66,3.418,1.093Z",
    transform: "translate(-46.752 -96.545)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M154.16,311.91h-.75l.736.22Z",
    transform: "translate(-47.942 -97.413)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M153.252,315.489l-2.242-.289,2.221.674Z",
    transform: "translate(-47.192 -98.441)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M152.467,335.118l-1.327-.138,1.313.385Z",
    transform: "translate(-47.233 -104.618)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M152.691,336.925l-.591-.055.578.261Z",
    transform: "translate(-47.532 -105.208)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M151.954,340.125l-1.774-.165,1.767.358Z",
    transform: "translate(-46.933 -106.173)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M152.138,341.883l-1.148-.083,1.135.261Z",
    transform: "translate(-47.186 -106.748)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M152.308,343.63h-.488l.488.213Z",
    transform: "translate(-47.445 -107.32)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M150.638,358.3l-2.228-.124,2.214.385Z",
    transform: "translate(-46.38 -111.864)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M151.228,360.1h-.688l.667.3Z",
    transform: "translate(-47.045 -112.464)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M150.613,363.21H148.99l1.609.248Z",
    transform: "translate(-46.561 -113.435)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M150.582,364.58h-1.513c.083,0,1.5.227,1.5.227Z",
    transform: "translate(-46.585 -113.863)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M151.015,365.77h-.385l.378.151Z",
    transform: "translate(-47.073 -114.234)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M66.34,173.02l8.8,4.36-8.713-3.095Z",
    transform: "translate(-20.748 -54.036)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M66.7,178.04l2.407,1.417-2.317-.213Z",
    transform: "translate(-20.861 -55.604)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M67.23,185.33l4.3,2.07-4.209-1.032Z",
    transform: "translate(-21.026 -57.88)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M67.84,193.75l2.648.97H67.916Z",
    transform: "translate(-21.217 -60.51)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M68.32,200.24l5.625,2.544-5.536-1.272Z",
    transform: "translate(-21.367 -62.537)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M68.97,209.22l3.322,1.678-3.246-.619Z",
    transform: "translate(-21.57 -65.341)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M70.99,243.86l2.476.9-2.455-.454Z",
    transform: "translate(-22.201 -76.16)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M71.19,247.52l3.652,1.107-3.6-.282Z",
    transform: "translate(-22.263 -77.303)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M71.64,255.48l1.705.653H71.64Z",
    transform: "translate(-22.404 -79.789)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M71.83,259.02l3.975,1.2-3.94-.6Z",
    transform: "translate(-22.463 -80.895)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M73.3,285.24l3.762,1.272-3.727-.633Z",
    transform: "translate(-22.922 -89.084)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M73.56,289.89l1.506.653H73.594Z",
    transform: "translate(-23.003 -90.536)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M73.76,293.49l3.225.908-3.191-.3Z",
    transform: "translate(-23.066 -91.66)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M74.07,299.04l5.013,1.341-4.979-.674Z",
    transform: "translate(-23.162 -93.394)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M75.36,322.22l1.382.351-1.348.2Z",
    transform: "translate(-23.565 -100.633)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M75.53,325.31l3.088.571H75.564Z",
    transform: "translate(-23.618 -101.598)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M75.68,327.93l1.162.378-1.128.165Z",
    transform: "translate(-23.665 -102.416)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M75.86,331.06l3.438.818-3.4-.22Z",
    transform: "translate(-23.722 -103.394)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M76.95,351.32l3.15.488H76.978Z",
    transform: "translate(-24.062 -109.721)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M77.13,354.37l.887.206-.866.11Z",
    transform: "translate(-24.118 -110.674)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M77.21,355.7l2.084.179-2.063.165Z",
    transform: "translate(-24.143 -111.089)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M77.39,358.71l1.554.33H77.418Z",
    transform: "translate(-24.199 -112.029)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M33.416,195.008a48.694,48.694,0,0,0,11-9.3C40.754,189.1,37.309,192,33.416,195.008Zm-10.109,7.537a29.028,29.028,0,0,0,5.02-4.47A32.223,32.223,0,0,0,23.307,202.545Zm16.78-8.85a31.509,31.509,0,0,0,5.57-4.25,34.97,34.97,0,0,0-5.591,4.25Zm4.126.454a11.952,11.952,0,0,0,3.72-2.159,13.258,13.258,0,0,0-3.714,2.173Zm-16.057,8.789a56.191,56.191,0,0,0,7.53-5.557,62.385,62.385,0,0,0-7.53,5.556ZM19.993,208.6a10.068,10.068,0,0,0,4.814-3.906A40.63,40.63,0,0,1,19.993,208.6Zm3.83.894a72.958,72.958,0,0,0,8.479-6.464,81.052,81.052,0,0,0-8.479,6.485Zm12.1-8.08c1.926-1.279,3.6-2.448,5.46-3.81a16.883,16.883,0,0,0-5.46,3.83Zm2.606,3.8a78.787,78.787,0,0,0,8.995-6.471,87.423,87.423,0,0,0-8.995,6.492Zm-6.643,4.374a12.083,12.083,0,0,0,3.6-2.366,13.4,13.4,0,0,0-3.6,2.386Zm-12.3,7.565a40.986,40.986,0,0,0,8.507-5.24c-2.985,1.754-5.653,3.383-8.507,5.254Zm6.189-.165a63.18,63.18,0,0,0,8.293-5.446,70.089,70.089,0,0,0-8.3,5.46Zm12.667-7.915a20,20,0,0,0,4.814-2.833,22.2,22.2,0,0,0-4.814,2.833Zm7.963-4.683a7.6,7.6,0,0,0,2.964-1.712,8.424,8.424,0,0,0-2.964,1.705Zm-4.47,29.447a45.483,45.483,0,0,0,7.207-4.346,50.482,50.482,0,0,0-7.214,4.339Zm-1.43,3.026a16.588,16.588,0,0,0,4.587-2.132A18.4,18.4,0,0,0,40.5,236.867ZM28.63,241.612c2.923-1.692,5.5-3.26,8.376-5.055a37.052,37.052,0,0,0-8.376,5.055Zm-4.037,2.517a3.06,3.06,0,0,0,1.871-1.059,3.377,3.377,0,0,0-1.871,1.038Zm5.99-.234a30.469,30.469,0,0,0,6-3.383,33.817,33.817,0,0,0-6,3.356Zm14.923-6.265a14.62,14.62,0,0,0,4.477-1.623,16.216,16.216,0,0,0-4.477,1.6ZM26.56,247.272a5.584,5.584,0,0,0,2.62-1.307A6.189,6.189,0,0,0,26.56,247.272Zm16.333,13.6a49.631,49.631,0,0,0,8.067-3.493,55.1,55.1,0,0,0-8.067,3.493Zm-4.456,3.748a19.681,19.681,0,0,0,5.13-2.063,21.834,21.834,0,0,0-5.13,2.063Zm-9.174,2.235a24.867,24.867,0,0,0,5.777-2.3,27.584,27.584,0,0,0-5.777,2.3ZM31.869,269a15.486,15.486,0,0,0,4.587-1.726A17.191,17.191,0,0,0,31.869,269Zm9.731-2.668a3.831,3.831,0,0,0,2.29-.763A4.236,4.236,0,0,0,41.6,266.334Zm5.336-3.624a19.854,19.854,0,0,0,5.254-1.843,22.006,22.006,0,0,0-5.261,1.843Zm.77,2.283a2.324,2.324,0,0,0,1.747-.653A2.558,2.558,0,0,0,47.706,264.993Zm-1.644,17.969a30,30,0,0,0,6.567-1.891,33.29,33.29,0,0,0-6.567,1.919Zm-1.63,2.318a10.315,10.315,0,0,0,3.927-.763,11.47,11.47,0,0,0-3.927.791Zm-7.1,3.026a17.146,17.146,0,0,0,5.013-1.217,19.014,19.014,0,0,0-5.013,1.245Zm-3.59-1.912a19.764,19.764,0,0,0,5.46-.942,21.93,21.93,0,0,0-5.46.977Zm16.566-.591a8.176,8.176,0,0,0,3.487-.688,9.056,9.056,0,0,0-3.48.722ZM41.7,284.166a1.974,1.974,0,0,0,2.063-.688,19.356,19.356,0,0,0-2.056.715Zm-8.727,4.711a2.063,2.063,0,0,0,1.747-.213,2.29,2.29,0,0,0-1.733.241Zm14.723,12.3a11.745,11.745,0,0,0,5.873-.763Zm-1,1.96a5.8,5.8,0,0,0,2.943-.481A6.43,6.43,0,0,0,46.689,303.139Zm4.47,1.788a5.879,5.879,0,0,0,2.943-.6,6.512,6.512,0,0,0-2.909.6Zm2.29-2.4a3.775,3.775,0,0,0,2.345-.5,4.167,4.167,0,0,0-2.311.5Zm-16.573,2.9a30.4,30.4,0,0,0,6.877-.4,33.74,33.74,0,0,0-6.842.4Zm2.978-1.926a22.864,22.864,0,0,0,4.085-.75,7.991,7.991,0,0,0-4.085.75Zm5.123.977a12.225,12.225,0,0,0,3.652-.426,7.407,7.407,0,0,0-3.652.447Zm-9.628-.282a3.734,3.734,0,0,0,1.747-.323,1.637,1.637,0,0,0-1.774.316Z",
    transform: "translate(-6.144 -57.999)",
    fill: "#563027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M126.035,204.693a63.02,63.02,0,0,1-9.1-3.913,69.961,69.961,0,0,1,9.1,3.913Zm-38.51-18.341c6.65,3.548,12.791,6.554,19.668,9.628-6.712-3.528-12.887-6.561-19.688-9.628Zm-11-3.253a39.067,39.067,0,0,0,7.283,2.682A43.365,43.365,0,0,0,76.48,183.1ZM124.4,206.956a19.944,19.944,0,0,0,5.1,2.235,22.163,22.163,0,0,0-5.144-2.228Zm-18.684-7.647c4.216,1.912,8.046,3.583,12.316,5.364a70.9,70.9,0,0,0-12.316-5.364Zm-9.387-3.8a39.792,39.792,0,0,0,4.126,1.609A8.252,8.252,0,0,0,96.34,195.5ZM79.52,188.725c3.727,1.375,7.035,2.675,10.652,4.284a34.742,34.742,0,0,0-10.652-4.284Zm38.964,20.734a14.5,14.5,0,0,0,4.36,1.857,16.07,16.07,0,0,0-4.367-1.857Zm-14.07-4.587,6.767,2.751A17.749,17.749,0,0,0,104.414,204.872ZM90.66,198a58.571,58.571,0,0,0,9.057,3.046A65,65,0,0,0,90.674,198Zm-10.8-1.506c2.751,1.059,5.275,1.96,8.08,2.909a28.3,28.3,0,0,0-8.067-2.9Zm.11-3.72a10,10,0,0,0,3.748,1.313,11.086,11.086,0,0,0-3.734-1.307Zm38.2,22.4a56.183,56.183,0,0,0,8.685,3.487,62.365,62.365,0,0,0-8.672-3.48Zm-11.347-5.316a42.588,42.588,0,0,0,7.626,2.854,47.272,47.272,0,0,0-7.626-2.854Zm3.493,5.33a60.721,60.721,0,0,0,9.16,3.294,67.393,67.393,0,0,0-9.16-3.273ZM88.26,207.733a53.521,53.521,0,0,0,12.667,3.438C96.533,210.023,92.579,208.943,88.26,207.733Zm6.12-2.751c2.489.928,4.738,1.685,7.283,2.455a24.179,24.179,0,0,0-7.283-2.462Zm-14.826-2.517a48.633,48.633,0,0,0,8.4,2.269,53.993,53.993,0,0,0-8.4-2.276ZM113.808,239.3a60.258,60.258,0,0,0,9.174,3.129,66.922,66.922,0,0,0-9.174-3.136Zm-10.81.371,10.687,2.751a41.193,41.193,0,0,0-10.714-2.758Zm-5.667-3.4a15.129,15.129,0,0,0,4.69,1.2,16.758,16.758,0,0,0-4.7-1.2Zm-9.628-5.3c2.7.88,5.13,1.6,7.874,2.338a27.019,27.019,0,0,0-7.86-2.352Zm-6.643-.908a10.315,10.315,0,0,0,3.934.729,11.47,11.47,0,0,0-3.92-.736Zm4.126,4.215a30.163,30.163,0,0,0,6.643,1.671,33.482,33.482,0,0,0-6.6-1.678Zm30.9,9.951a12.446,12.446,0,0,0,4.257,1.087A13.809,13.809,0,0,0,116.084,244.235ZM94.6,240.205a29.247,29.247,0,0,0,6.547,1.637,32.45,32.45,0,0,0-6.554-1.63Zm29.13,4.03a14.862,14.862,0,0,0,4.47,1.747A16.5,16.5,0,0,0,123.731,244.235Zm-10.15,19.64a52.045,52.045,0,0,0,8.644,2.579,57.764,57.764,0,0,0-8.644-2.6Zm-11.691-1.162c3.624,1.032,6.918,1.864,10.6,2.675a52.458,52.458,0,0,0-10.59-2.7Zm-11.643-1.2A39.8,39.8,0,0,0,97.977,263,44.172,44.172,0,0,0,90.247,261.51Zm-5.907-4.057a48.663,48.663,0,0,0,8.507,1.871,54.008,54.008,0,0,0-8.507-1.871Zm30.444,11.292A49.809,49.809,0,0,0,123.3,271,55.3,55.3,0,0,0,114.784,268.744Zm-8.376-1.6a11.29,11.29,0,0,0,4.037,1.093,12.523,12.523,0,0,0-4.037-1.093Zm-12.853-2.242a41.306,41.306,0,0,0,7.846,1.671,45.858,45.858,0,0,0-7.881-1.678Zm-7.021-1.066a8.252,8.252,0,0,0,3.493.736,9.167,9.167,0,0,0-3.493-.736Zm14.716,4.614a13.417,13.417,0,0,0,5.777,1.093C105.033,269.109,103.245,268.765,101.25,268.456Zm15.129,17.57a49.951,49.951,0,0,0,8.706,1.417,55.466,55.466,0,0,0-8.679-1.417Zm-4.814,1.155a27.718,27.718,0,0,0,6.43,1.334,30.762,30.762,0,0,0-6.382-1.334Zm-8.679-3.06a38.19,38.19,0,0,0,7.633,1.08,42.392,42.392,0,0,0-7.633-1.08Zm-.44,1.21a15.316,15.316,0,0,0,3.273.688,5.13,5.13,0,0,0-3.273-.66Zm1.527,2.943c2.524.323,4.773.557,7.31.77a20.52,20.52,0,0,0-7.31-.743Zm13.754,1.176a6.189,6.189,0,0,0,3.06.406,6.877,6.877,0,0,0-3.067-.378ZM91.76,283.433c2.661.536,5.061.928,7.75,1.279a25.8,25.8,0,0,0-7.75-1.279Zm3.273,2.373a23.642,23.642,0,0,0,6,.873,26.229,26.229,0,0,0-6-.908Zm-8.067-.358a18.148,18.148,0,0,0,5.24.86,20.13,20.13,0,0,0-5.24-.894ZM83.8,282.532a22.267,22.267,0,0,0,5.783,1.066,24.7,24.7,0,0,0-5.783-1.1Zm3.053-1.41a10.721,10.721,0,0,0,4.037.543,11.883,11.883,0,0,0-4.037-.578Zm27.507,23.643a34.576,34.576,0,0,0,7.3.688,38.373,38.373,0,0,0-7.331-.7Zm-5.35-1.884a43.024,43.024,0,0,0,8.177.337,47.755,47.755,0,0,0-8.2-.371Zm-3.487,1.375a12.378,12.378,0,0,0,4.36.468,13.754,13.754,0,0,0-4.387-.5Zm-9.483.722a33.484,33.484,0,0,0,7.193.564,37.135,37.135,0,0,0-7.221-.591Zm16.14,1.375a7.489,7.489,0,0,0,3.383.309,8.293,8.293,0,0,0-3.418-.358ZM96.891,302a15.817,15.817,0,0,0,4.9.688,17.524,17.524,0,0,0-4.9-.688Zm-8.073.887c2.379.186,4.491.282,6.877.323a18.83,18.83,0,0,0-6.877-.3Zm-2.5-2.531a13.065,13.065,0,0,0,4.47.55,14.524,14.524,0,0,0-4.477-.516Zm-1.747,3.28a9.276,9.276,0,0,0,3.707.777,10.316,10.316,0,0,0-3.707-.743Z",
    transform: "translate(-23.915 -57.184)",
    fill: "#9f5614"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M157.184,361.54l-.076.1-.289,2.427,2.407.227.1-.076Z",
    transform: "translate(-49.007 -112.913)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 0.64,
    cy: 0.64,
    r: 0.64,
    transform: "translate(111.451 246.247)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M160.65,375.722h.406v-4.649l.413-4.436,1.025-7.613-.406-.055-1.025,7.62-.413,4.463Z",
    transform: "translate(-50.203 -112.111)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M162.77,360.808l-1.375-.248.3.474-.481,3.356-.4.653,1.747.131-.385-.708.371-3.349Z",
    transform: "translate(-50.253 -112.607)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M161.234,376.489l-1.7-.179.337.523-.5,3.879h-.22v.426l2.393.062v-.4h-.351L161,376.95Z",
    transform: "translate(-49.734 -117.526)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M165.682,362.79l-1.9.165-.124,2.1,1.774.241Z",
    transform: "translate(-51.143 -113.304)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M163.724,364.306l-.977-.076-.027.3.977.117Z",
    transform: "translate(-50.849 -113.753)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M161.493,363.635l-1.052-.165-.041.309,1.059.1Z",
    transform: "translate(-50.125 -113.516)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M159.571,361.953l-.179,2.262-2.373-.206.227-2.469Z",
    transform: "translate(-49.069 -112.913)",
    fill: "#252068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M165.541,363.11l-.158,2.1-1.513-.179.11-1.843Z",
    transform: "translate(-51.208 -113.404)",
    fill: "#e5a076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M159.472,362.158l-.131,1.932-2.022-.151.144-2.159Z",
    transform: "translate(-49.163 -112.988)",
    fill: "#f2f7a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M166.488,362.79l.151.021-.227,2.489h-.172Z",
    transform: "translate(-51.949 -113.304)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M163.07,359.253a.488.488,0,0,0,.076-.963.646.646,0,0,1,.172.488.688.688,0,0,1-.248.474Z",
    transform: "translate(-50.958 -111.898)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M162.4,360.91l.6.083-.144.2-.454,3.328.254.591-.557-.048a.536.536,0,0,0,.179-.268c0-.151.426-3.61.426-3.61Z",
    transform: "translate(-50.656 -112.716)",
    fill: "#7c78b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M161.571,376.748l-.172.3.172,3.789h-.481l.083-3.824-.083-.309Z",
    transform: "translate(-50.34 -117.648)",
    fill: "#7c78b5"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 1920,
    height: 265,
    transform: "translate(-5 2078)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footer-bg.71b59c6ca51ec804e5764202fa155ef8.svg";
export { ForwardRef as ReactComponent };